// Function to find an object by ID
function findObjectById(id) {
    const objects = canvas.getObjects();
    for (let i = 0; i < objects.length; i++) {
      if (objects[i].get("id") === id) {
        return objects[i];
      }
    }
    return null;
  }
  
  // Given a size's real width_data/height_data (which always carries the true
  // physical aspect ratio), compute editing-canvas pixel dimensions that keep
  // that exact ratio while capping the longest side to maxDim. This replaces
  // the old hardcoded bucket lookup, which forced many sizes (e.g. 1.5x3.0,
  // 6.0x12.0) into an incorrect ratio and caused squished print exports.
  function getEditingCanvasDims(width_data, height_data, maxDim) {
    maxDim = maxDim || 600;
    var rawW = parseFloat(width_data);
    var rawH = parseFloat(height_data);
    if (!rawW || !rawH) {
      return { width: maxDim, height: maxDim };
    }
    var scale = maxDim / Math.max(rawW, rawH);
    return {
      width: Math.round(rawW * scale),
      height: Math.round(rawH * scale),
    };
  }

  // Function to resize canvas and adjust object positions
  function resizeCanvas(newWidth, newHeight, obj_height) {
    // On mobile, cap the logical canvas to 450px on its longest side.
    // With retina scaling disabled (enableRetinaScaling: false) this keeps the
    // internal pixel buffer at or below ~810 000 pixels — well within iOS limits.
    if (window.innerWidth < 750) {
      var mobileCap = 450;
      var longestSide = Math.max(newWidth, newHeight);
      if (longestSide > mobileCap) {
        var mobileScale = mobileCap / longestSide;
        newWidth  = Math.round(newWidth  * mobileScale);
        newHeight = Math.round(newHeight * mobileScale);
      }
    }
  
    var oldWidth = canvas.getWidth();
    var oldHeight = canvas.getHeight();
  
    // Set new canvas dimensions
    canvas.setWidth(newWidth);
    canvas.setHeight(newHeight);
  
    // Sync the CSS display dimensions to the new aspect ratio so the visual
    // container always matches the internal Fabric proportions — prevents
    // image distortion when portrait/landscape sizes are selected.
    var wrapper = canvas.wrapperEl;
    wrapper.style.width = '';   // remove Fabric's fixed-px inline width; let CSS max-width rule
    wrapper.style.height = '';  // remove Fabric's fixed-px inline height; let aspect-ratio rule
    wrapper.style.aspectRatio = newWidth + ' / ' + newHeight;
  
    // Calculate position adjustments
    var widthRatio = newWidth / oldWidth;
    var heightRatio = newHeight / oldHeight;
  
    canvas.getObjects().forEach(function (obj) {
      if (obj.type === "i-text" || obj.type === "text") {
        obj.scaleToHeight(obj_height);
        obj.scaleToWidth(obj.width * widthRatio);
        obj.set({
          left: obj.left * widthRatio,
          top: obj.top * heightRatio,
        });
      } else {
        obj.scaleToHeight(canvas.height - obj_height);
        obj.set({
          left: obj.left * widthRatio,
          top: obj.top * heightRatio,
        });
      }
      obj.setCoords();
    });
    canvas.renderAll();
  }
  function updateHeight() {}
  
  // Design Click End
  function refreshClickSvg($this) {
    var class_exsist = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all"
    ).hasClass("active-new");
  
    var svgEl = $this.find("svg")[0];
    var serializer = new XMLSerializer();
    var svgStr = serializer.serializeToString(svgEl);
    var path = fabric.loadSVGFromString(svgStr, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      obj.set({ flipX: false, flipY: false });
  
      var $activeSize = $(
        "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new"
      );
      var size_varinats = $activeSize.find(".loop").attr("size_varinats");
      var canvas_object_height = parseFloat($activeSize.attr("obj_height")) || 200;
      // obj_height was calibrated for the full desktop canvas. On mobile the canvas
      // is capped at 450px, so scale obj_height down proportionally to prevent
      // scaleToHeight() from receiving a negative or zero value which flips the SVG.
      var desktopCanvasHeight = parseFloat($activeSize.find(".loop").attr("height_data")) || canvas.height;
      if (desktopCanvasHeight > canvas.height) {
        canvas_object_height = Math.round(canvas_object_height * (canvas.height / desktopCanvasHeight));
      }
  
      if (size_varinats == "6.0 x 6.0") {
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 4, top: canvas.height / 3.3 });
          obj.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true
    });
    obj.setCoords();
      } else if (
        size_varinats == "1.5 x 3.0" ||
        size_varinats == "2.0 x 3.0" ||
        size_varinats == "2.0 x 4.0" ||
        size_varinats == "4.0 x 6.0"
      ) {
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 3.5, top: canvas.height / 2.8 });
          obj.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true
    });
    obj.setCoords();
      } else if (size_varinats == "1.5 x 2.0") {
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 3, top: canvas.height / 2.8 });
          obj.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true
    });
    obj.setCoords();
      } else {
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 3, top: canvas.height / 2.8 });
         obj.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true
    });
    obj.setCoords();
      }
  
      canvas.add(obj);
      canvas.setActiveObject(obj);
      set1Objects.push(obj.toJSON()); // Save image data
      showtoolbardynamic();
      /* Auto-collapse asset panel bottom sheet on mobile after insert */
      if (window.innerWidth < 750) {
        setTimeout(function () { ttCollapseAssetSheet(); }, 180);
      }
    });
    $(".my_editor#design").fadeIn();
    $(".my_editor#text").fadeOut();
    $(".main-secrion .canvas-container").addClass("for-margin");
  }
  
  function addImageToCanvas(clickedImageUrl, imgcav_id = null) {
    fabric.Image.fromURL(clickedImageUrl, function (img) {
      // Auto-fit to 65% of canvas and center
      var _pad = 0.65;
      var _maxW = canvas.getWidth() * _pad;
      var _maxH = canvas.getHeight() * _pad;
      var _ar = img.width / img.height;
      if (_ar > _maxW / _maxH) {
        img.scaleToWidth(_maxW);
      } else {
        img.scaleToHeight(_maxH);
      }
      var _sw = img.getScaledWidth();
      var _sh = img.getScaledHeight();
  
      img.set({
        left: (canvas.getWidth() - _sw) / 2,
        top:  (canvas.getHeight() - _sh) / 2,
        src: clickedImageUrl,
      });

      /* Semi-permanent tattoos are single-color (black ink) only, so the
         artwork is converted to grayscale before it lands on the canvas.
         The filter is forced through the Canvas2D backend (instead of the
         default WebGL backend, which is capped at fabric.textureSize /
         4096px) so the pixel data is processed at the image's native
         resolution and the upload doesn't lose quality. */
      if ($(".loop-all.selection_active").attr("id") === "qty-classic") {
        var _prevFilterBackend = fabric.filterBackend;
        fabric.filterBackend = new fabric.Canvas2dFilterBackend();
        img.filters.push(new fabric.Image.filters.Grayscale());
        img.applyFilters();
        fabric.filterBackend = _prevFilterBackend;
      }

      img.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        mtr: true
      });
      img.setCoords();
  
      if (imgcav_id != null) {
        img.id = imgcav_id;
      }
  
      canvas.add(img);
      canvas.setActiveObject(img);
      $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
      /* Auto-collapse asset panel bottom sheet on mobile after insert */
      if (window.innerWidth < 750) {
        setTimeout(function () { ttCollapseAssetSheet(); }, 180);
      }
    });
  }
  
  // Function to match image URL with Fabric.js objects on the canvas and select the object
  function matchAndSelectObject(clickedImageUrl) {
    var canvasObjects = canvas.getObjects();
  
    for (var i = 0; i < canvasObjects.length; i++) {
      if (canvasObjects[i].type === "image") {
        // Compare images based on source URL
        var imageUrl = canvasObjects[i].src;
        if (imageUrl === clickedImageUrl) {
          // Select the corresponding object
          canvas.setActiveObject(canvasObjects[i]);
          canvas.renderAll(); // Update the canvas
          return canvasObjects[i]; // Return the matched object
        }
      }
    }
    return null; // No matching object found
  }
  
  function saveCanvasState() {
    undoStack.push(canvas.toJSON());
    redoStack.length = 0; // Clear redo stack
  }
  
  function setTextAlignment(align) {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject instanceof fabric.Text) {
      selectedObject.set("textAlign", align);
      canvas.renderAll();
    }
  }
  
  // Function to set the selected text color
  function setTextFillColor(color) {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      activeObject.set({ fill: color });
      canvas.renderAll();
    }
  }
  
  // Function to set the selected text color
  function setTextFillColorText(color) {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      activeObject.set({ fill: color });
      canvas.renderAll();
    }
  }
  function updateqty_html(variant_id = null){
    if(variant_id == null){
        var custom_variant_size = $("div#shopify-section-tattoo_popup .loop-all.active-new .loop").attr("size_varinats");
       variant_id = $(".variants_data.matched span[size='" + custom_variant_size + "']").attr("id");
    }
  
  
    var qtyhtml = "";
  
    /* Collect all qty values, sort numerically ascending, then build options */
    var qtys = [];
    $('.loop-all-draft_first[data-id="' + variant_id + '"]').each(function () {
      var acqty = parseInt($(this).attr("data-qty"), 10);
      if (!isNaN(acqty)) qtys.push(acqty);
    });
    qtys.sort(function (a, b) { return a - b; });
  
    $.each(qtys, function (index, acqty) {
      if (index === 0) {
        $(".quantity_selected").attr("value", acqty);
        $(".selected_sizes_data .sel_qty_data .insert_data__text").text(acqty);
        $("li.file_qty span").text(acqty);
        $(".tt-tile-qty-val").text(acqty);
        $(".count_update").text(acqty);
      }
      qtyhtml += '<option value="' + acqty + '">' + acqty + "</option>";
    });
  
    $(".sel_qty").html(qtyhtml);
    $(".qty_selected_row.sel_qty").trigger("change");
  
  }
  function getUrlParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
  }
  
  
  function makevariablefor_atc() {
    $formdata = null;
    $formdata = new FormData();
    var formDataArray = $(".form_syn").serializeArray();
  
    $.each(formDataArray, function (i, field) {
      // EMPTY values skip karo
      if (field.value !== null && field.value !== "" && field.value !== undefined) {
        $formdata.append(field.name, field.value);
      }
    });
  
    /* Resolve the currently selected size label robustly. The wizard proxy-clicks
       into the hidden legacy popup (#shopify-section-tattoo_popup .loop.active) to
       sync state, but that proxy can silently no-op (slick-cloned nodes, or a
       wizard size with no matching legacy .loop), leaving .loop.active stale/empty
       and producing a truncated SKU like "IB--25". To avoid that, prefer the
       wizard's own active size card — the most direct source of truth for what
       the customer actually picked — before falling back to the legacy DOM. */
    var sizevariable =
      jQuery(".tt-size-card--active").first().attr("data-var-label") ||
      window._ttWizardActiveVarLabel ||
      jQuery("#shopify-section-tattoo_popup .loop.active").attr("size_varinats");
    var dimensionsku = sizevariable ? sizevariable.split(" x ").join("-") : "";

    if (!dimensionsku) {
      // Never submit a malformed SKU (e.g. "IB--25") — block Add to Cart instead.
      console.error("makevariablefor_atc: could not resolve a tattoo size for SKU generation; blocking Add to Cart.");
      $("span.add_product_to_cart").removeClass("active");
      alert("Please reselect your tattoo size before adding to cart.");
      return Promise.reject(new Error("makevariablefor_atc: missing size for SKU"));
    }

    var prdsku =
      jQuery(".variants_data.matched").attr("data-sku") +
      "-" +
      dimensionsku +
      "-" +
      jQuery(".quantity_selected").val();
    $formdata.append("sku", prdsku);
  
    displayFormData(formDataArray);
    $(".form_syn")[0].reset();
  
    // Use fetch to convert data URLs to Blobs non-blocking — avoids the
    // CPU-freezing charCodeAt loop that was blocking the main thread on mobile
    // for large (1800×3600) images. Returns a Promise so callers can await it.
    var promises = [];
  
    var dataURLs = $(".last-cart_page_inner .cmn.left img.base_img").attr("src");
    if (dataURLs && dataURLs.includes("base64")) {
      promises.push(
        fetch(dataURLs)
          .then(function (r) { return r.blob(); })
          .then(function (blob) {
            $formdata.append("properties[Front Tattoo]", blob, "FrontTattoo.png");
          })
      );
    }
  
    var dataURL2 = $(".back_tatt img").attr("src");
    if (dataURL2 && dataURL2.includes("base64") && $("span.cstm-btn.active").attr("data-text") == "Yes") {
      promises.push(
        fetch(dataURL2)
          .then(function (r) { return r.blob(); })
          .then(function (blob) {
            $formdata.append("properties[Tatoo image Back]", blob, "TattooBack.png");
          })
      );
    }
  
    return Promise.all(promises);
  }
  
  // Function to new Tattoo the canvas
  function clearCanvas() {
    canvas.clear();
    localStorage.removeItem("presentObjects");
  }
  
  function saveCanvas6x6() {
    const canvasData_json = JSON.stringify(canvas.toJSON());
    // Retrieve the existing canvas data from local storage
    const savedCanvasDataf = localStorage.getItem("canvasData");
  
    if (savedCanvasDataf) {
      allCanvasDataf = JSON.parse(savedCanvasDataf);
    }
    allCanvasDataf.push(canvasData_json);
    // Store the updated array back in local storage
    localStorage.setItem("canvasData", JSON.stringify(allCanvasDataf));
    canvasDataDiv.innerHTML = "";
  }
  function loadCanvas6x6() {
    const savedCanvasData = localStorage.getItem("canvasData");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDiv.appendChild(svgDiv);
          }
        });
      }
    }
  }
  function loadCanvasNext6x6() {
    canvas.setDimensions({ width: 720, height: 720 });
    const savedCanvasData = localStorage.getItem("canvasData");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          const image = new Image();
          var svgData = canvas.toSVG();
          if (svgData) {
            // Create a new div element to display the SVG
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
            canvasDataDiv.appendChild(svgDiv);
          }
        });
      }
    }
  }
  function loadCanvasNextNext6x6() {
    canvas.setDimensions({ width: 720, height: 720 });
    const savedCanvasData = localStorage.getItem("canvasData");
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          // You can access the objects on the canvas after loading
          const objectsOnCanvas = canvas.getObjects();
        });
      }
    }
  }
  
  function saveCanvas4x6() {
    const canvasData_json = JSON.stringify(canvas.toJSON());
    // Retrieve the existing canvas data from local storage
    const savedCanvasDataf = localStorage.getItem("canvasDataSmall");
  
    if (savedCanvasDataf) {
      allCanvasDatafSmall = JSON.parse(savedCanvasDataf);
    }
  
    allCanvasDatafSmall.push(canvasData_json);
    // Store the updated array back in local storage
    localStorage.setItem("canvasDataSmall", JSON.stringify(allCanvasDatafSmall));
    canvasDataDivSmall.innerHTML = "";
  }
  function loadCanvas4x6() {
    const savedCanvasData = localStorage.getItem("canvasDataSmall");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            // canvasDataDiv.innerHTML = '';
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivSmall.appendChild(svgDiv);
          } else {
            //console.log('Canvas is empty or there was an issue converting to SVG.');
          }
        });
      }
    }
  }
  function loadCanvasNext4x6() {
    canvas.setDimensions({ width: 500, height: 600 });
    const savedCanvasData = localStorage.getItem("canvasDataSmall");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
  
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            // canvasDataDiv.innerHTML = '';
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivSmall.appendChild(svgDiv);
          } else {
            //console.log('Canvas is empty or there was an issue converting to SVG.');
          }
        });
      }
      //canvasDataDiv.innerHTML = '';
    }
  }
  function loadCanvasNextNext4x6() {
    const savedCanvasData = localStorage.getItem("canvasDataSmall");
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          // You can access the objects on the canvas after loading
          const objectsOnCanvas = canvas.getObjects();
          // console.log(objectsOnCanvas);
        });
      }
    }
  }
  
  function saveCanvasLands() {
    const canvasData_json = JSON.stringify(canvas.toJSON());
    console.log(canvasData_json);
    // Retrieve the existing canvas data from local storage
    const savedCanvasDatalandscape = localStorage.getItem("canvasDatalandscape");
  
    if (savedCanvasDatalandscape) {
      allCanvasDataflandscape = JSON.parse(savedCanvasDatalandscape);
    }
  
    allCanvasDataflandscape.push(canvasData_json);
    // Store the updated array back in local storage
    localStorage.setItem(
      "canvasDatalandscape",
      JSON.stringify(allCanvasDataflandscape)
    );
    canvasDataDivlandscape.innerHTML = "";
  }
  function loadCanvasLands() {
    const savedCanvasData = localStorage.getItem("canvasDatalandscape");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivlandscape.appendChild(svgDiv);
          }
        });
      }
    }
  }
  function loadCanvasNextLands() {
    canvas.setDimensions({ width: 400, height: 400 });
    const savedCanvasData = localStorage.getItem("canvasDatalandscape");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
  
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            // canvasDataDiv.innerHTML = '';
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivlandscape.appendChild(svgDiv);
          }
        });
      }
    }
  }
  function loadCanvasNextNextLands() {
    const savedCanvasData = localStorage.getItem("canvasDatalandscape");
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          // You can access the objects on the canvas after loading
          const objectsOnCanvas = canvas.getObjects();
          // console.log(objectsOnCanvas);
        });
      }
    }
  }
  
  function saveCanvasPotraits() {
    const canvasData_json = JSON.stringify(canvas.toJSON());
    //console.log(canvasData_json);
    // Retrieve the existing canvas data from local storage
    const savedCanvasDatapotrait = localStorage.getItem("canvasDatapotrait");
  
    if (savedCanvasDatapotrait) {
      allCanvasDatafpotrait = JSON.parse(savedCanvasDatapotrait);
    }
  
    allCanvasDatafpotrait.push(canvasData_json);
    //console.log("allCanvasData"+allCanvasData);
    // Store the updated array back in local storage
    localStorage.setItem(
      "canvasDatapotrait",
      JSON.stringify(allCanvasDatafpotrait)
    );
    canvasDataDivpotrait.innerHTML = "";
  }
  function loadCanvasPotraits() {
    const savedCanvasData = localStorage.getItem("canvasDatapotrait");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            // canvasDataDiv.innerHTML = '';
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivpotrait.appendChild(svgDiv);
          }
        });
      }
    }
  }
  function loadCanvasNextPotraits() {
    canvas.setDimensions({ width: 300, height: 400 });
    const savedCanvasData = localStorage.getItem("canvasDatapotrait");
  
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
  
          const image = new Image();
          var svgData = canvas.toSVG();
  
          if (svgData) {
            // Create a new div element to display the SVG
            // canvasDataDiv.innerHTML = '';
            var svgDiv = document.createElement("div");
            svgDiv.classList.add("loop-svg");
            svgDiv.innerHTML = svgData;
            var spanElement = document.createElement("span");
            spanElement.textContent = "Add to cart";
            spanElement.classList.add("add-cart-save");
            // Append the SVG div to the canvasDataDiv
            svgDiv.appendChild(spanElement);
  
            canvasDataDivpotrait.appendChild(svgDiv);
          }
        });
      }
      //canvasDataDiv.innerHTML = '';
    }
  }
  function loadCanvasNextNextPotraits() {
    const savedCanvasData = localStorage.getItem("canvasDatapotrait");
    if (savedCanvasData) {
      const allCanvasData = JSON.parse(savedCanvasData);
  
      for (let i = 0; i < allCanvasData.length; i++) {
        const data = allCanvasData[i];
  
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          // You can access the objects on the canvas after loading
          const objectsOnCanvas = canvas.getObjects();
          // console.log(objectsOnCanvas);
        });
      }
    }
  }
  
  function loadMoreImages(tabIndex) {
    // console.log("tabIndex",tabIndex);
    var $tab = $("#tab" + tabIndex); // Dynamically target the current tab by index
    var isLoading = $tab.data("isLoading") || false; // Check if it's already loading
    var page = $tab.data("page") || 1; // Get the current page number
    var imagesPerPage = parseInt(
      $tab.find(".design_content_dynamic").attr("limits_data"),
      10
    ); // Get the limit of images to load
  
    if (isLoading) return; // Prevent multiple load calls
    isLoading = true;
    $tab.data("isLoading", true); // Set loading status to true
  
    // Move items from the hidden source pool into the visible grid.
    // Use .clone() so all data-* attributes (data-label, data-cat, etc.) are preserved.
    setTimeout(function () {
      for (var i = 1; i <= imagesPerPage; i++) {
        var $srcEl = $tab.find(".design_content.get_imgs .svg_item:first-child");
        if ($srcEl.length) {
          var $imageSet = $srcEl.clone();
          $srcEl.remove();
          $tab.find(".design_content_dynamic").append($imageSet);
        }
      }
  
      isLoading = false;
      $tab.data("isLoading", false);
      page++;
      $tab.data("page", page);
    }, 1000);
  }
  
  // Clear canvas function
  function clearCanvas() {
    canvas.clear();
  }
  
  // Function to store the current set of objects
  function storeCurrentSet() {
    set1Objects[currentSetIndex] = [];
    canvas.getObjects().forEach(function (obj) {
      set1Objects[currentSetIndex].push(obj.toJSON());
    });
  }
  
  // Function to restore stored data onto the canvas
  function restoreStoredData() {
    clearCanvas();
    set1Objects[currentSetIndex].forEach(function (obj) {
      fabric.util.enlivenObjects([obj], function (enlivenedObjects) {
        enlivenedObjects.forEach(function (enlivenedObj) {
          enlivenedObj._skipAutoCenter = true; // preserve saved scale/position — skip object:added auto-resize
          enlivenedObj.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            mtr: true
          });
          enlivenedObj.setCoords();
          canvas.add(enlivenedObj);
        });
        canvas.renderAll();
      });
    });
  }
  
  function resizeCanvasv2() {
    // 50ms gap between the two triggers prevents simultaneous toDataURL calls
    // from competing for memory on iPhone's single-core CPU.
    // _resizingCanvas suppresses the visual active-class change in the handlers
    // so the button pills don't flicker to "Back" during this programmatic resize.
    _resizingCanvas = true;
    if (jQuery(".div_custom_front_back .cmn.active").length != 0) {
      if (jQuery(".div_custom_front_back .cmn.active").hasClass("back")) {
        jQuery(".div_custom_front_back .front").trigger("click");
        setTimeout(function () {
          jQuery(".div_custom_front_back .back").trigger("click");
        }, 50);
      } else {
        jQuery(".div_custom_front_back .back").trigger("click");
        setTimeout(function () {
          jQuery(".div_custom_front_back .front").trigger("click");
        }, 50);
      }
    } else {
      jQuery(".div_custom_front_back .back").trigger("click");
      setTimeout(function () {
        jQuery(".div_custom_front_back .front").trigger("click");
      }, 50);
    }
    // After both triggers have completed, clear the flag and guarantee
    // Front is the visually active button.
    setTimeout(function () {
      _resizingCanvas = false;
      jQuery(".div_custom_front_back .back").removeClass("active");
      jQuery(".div_custom_front_back .front").addClass("active");
    }, 120);
  }
  
  function showtoolbardynamic() {
    var activeObject = canvas.getActiveObject();
  
    if (activeObject) {
      // console.log("activeObject.type",activeObject.type);
      if (activeObject.type == "i-text") {
        $(".my_editor.for_text").show();
        $(".my_editor.for_img").hide();
      } else if (activeObject.type == "path") {
        $(".my_editor.for_text").hide();
        $(".my_editor.for_img").show();
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
        $("span.edit_item.edit_color").show();
      } else if (activeObject.type == "group") {
        $(".my_editor.for_text").hide();
        $(".my_editor.for_img").show();
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
        $("span.edit_item.edit_color").show();
      } else if (activeObject.type == "image") {
        $(".my_editor.for_text").hide();
        $(".my_editor.for_img").show();
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
        $("span.edit_item.edit_color").hide();
      }
    }
  }
  
  function refreshTattooPosition() {
    // Select all elements with the specified class
    $(".cstm_slides.cstm_slides_sticker").each(function () {
      // Get the data-top and data-left attributes
      var top = $(this).data("top");
      var left = $(this).data("left");
  
      // Set default values if attributes are not present
      if (typeof top === "undefined") {
        top = 50;
      }
      if (typeof left === "undefined") {
        left = 50;
      }
  
      // Set the CSS top and left properties
      $(this).css({
        top: top + "%",
        left: left + "%",
      });
    });
  }
  // Function to get a resized image
  function getResizedImage(originalCanvas, newWidth, newHeight) {
    // Store original dimensions
    var originalWidth = originalCanvas.getWidth();
    var originalHeight = originalCanvas.getHeight();
  
    // Calculate scale factors
    var scaleX = newWidth / originalWidth;
    var scaleY = newHeight / originalHeight;
  
    // scaleX and scaleY should always match (same aspect ratio in and out).
    // If they diverge, the export will be non-uniformly stretched — this is
    // exactly what caused artwork to look "squished" in the print file.
    // Warn loudly so a future mismatched size gets caught before it ships.
    if (Math.abs(scaleX - scaleY) > 0.01) {
      console.warn(
        "getResizedImage: non-uniform scale detected (scaleX=" + scaleX +
        ", scaleY=" + scaleY + "). Export will be stretched/squished — " +
        "check that the editing canvas ratio (" + originalWidth + "x" + originalHeight +
        ") matches the target ratio (" + newWidth + "x" + newHeight + ")."
      );
    }
  
    // Temporarily scale canvas dimensions
    originalCanvas.setWidth(newWidth);
    originalCanvas.setHeight(newHeight);
  
    // Scale all objects
    originalCanvas.getObjects().forEach(function (object) {
      object.scaleX *= scaleX;
      object.scaleY *= scaleY;
      object.left *= scaleX;
      object.top *= scaleY;
      object.setCoords();
    });
  
    // Render the canvas
    originalCanvas.renderAll();
  
    // Get the data URL of the resized image
    var dataURL = originalCanvas.toDataURL("image/png");
  
    // Reset canvas dimensions and scale objects back to original size
    originalCanvas.setWidth(originalWidth);
    originalCanvas.setHeight(originalHeight);
  
    originalCanvas.getObjects().forEach(function (object) {
      object.scaleX /= scaleX;
      object.scaleY /= scaleY;
      object.left /= scaleX;
      object.top /= scaleY;
      object.setCoords();
    });
  
    // Render the canvas back to original state
    originalCanvas.renderAll();
  
    return dataURL;
  }
  
  function displayFormData(formDataArray) {
    var formDataListElement = $("#formDataList");
    var listItem = $("<li></li>").text(JSON.stringify(formDataArray));
    formDataListElement.append(listItem);
  }
  function addclass_aaccdingto_size_variants(size_varinats) {
    if (size_varinats == "6.0 x 6.0") {
      $(".canvas-container").addClass("lScape");
      $(".canvas-container").removeClass("lPotrait");
      $(".canvas-container").removeClass("SScape");
      $(".canvas-container").removeClass("SPotrait");
  
      $(".large_design").attr("data-canvas-size", size_varinats);
      $(".data-chk").removeClass("active_layout");
      $(".large_design").addClass("active_layout");
      $(".large_design").click();
    } else if (size_varinats == "4.0 x 6.0") {
      $(".canvas-container").addClass("lPotrait");
      $(".canvas-container").removeClass("lScape");
      $(".canvas-container").removeClass("SScape");
      $(".canvas-container").removeClass("SPotrait");
  
      $(".small_design").attr("data-canvas-size", size_varinats);
      $(".data-chk").removeClass("active_layout");
      $(".small_design").addClass("active_layout");
      $(".small_design").click();
    } else if (
      size_varinats == "1.5 x 2.0" ||
      size_varinats == "1.5 x 3.0" ||
      size_varinats == "2.0 x 3.0" ||
      size_varinats == "2.0 x 4.0"
    ) {
      $(".canvas-container").addClass("SPotrait");
      $(".canvas-container").removeClass("lScape");
      $(".canvas-container").removeClass("lPotrait");
      $(".canvas-container").removeClass("SScape");
  
      $(".canvas-container").addClass("canvas_width_tablet");
      $(".lands_design").attr("data-canvas-size", size_varinats);
      $(".data-chk").removeClass("active_layout");
      $(".lands_design").addClass("active_layout");
      $(".lands_design").click();
    } else if (
      size_varinats == "1.5 x 1.5" ||
      size_varinats == "2.0 x 2.0" ||
      size_varinats == "3.0 x 3.0" ||
      size_varinats == "4.0 x 4.0"
    ) {
      $(".canvas-container").addClass("SScape");
      $(".canvas-container").removeClass("lScape");
      $(".canvas-container").removeClass("SPotrait");
      $(".canvas-container").removeClass("lPotrait");
  
      $(".potrait_design").attr("data-canvas-size", size_varinats);
      $(".data-chk").removeClass("active_layout");
      $(".potrait_design").addClass("active_layout");
      $(".potrait_design").click();
    }
  }
  
  /**********************************************/
  /**********************************************/
  /********************Our Script****************/
  /**********************************************/
  /**********************************************/
  var $formdata = null;
  var $nopopup = false;
  var $svgloaded = false;
  // True while resizeCanvasv2() is running — suppresses the visual active-class
  // change in the back/front click handlers so the button pills don't flicker.
  var _resizingCanvas = false;
  var $vrsvg = `<svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.19276 0.19635L3.99983 3.00342L6.79236 0.210894C6.85404 0.145239 6.92835 0.0927167 7.01082 0.0564776C7.0933 0.0202384 7.18224 0.00102854 7.27232 0C7.46519 0 7.65017 0.0766176 7.78655 0.212998C7.92293 0.349378 7.99954 0.53435 7.99954 0.72722C8.00124 0.816379 7.9847 0.904944 7.95093 0.987479C7.91717 1.07001 7.86689 1.14478 7.80319 1.20719L4.97431 3.99971L7.80319 6.8286C7.92305 6.94586 7.99333 7.10464 7.99954 7.2722C7.99954 7.46508 7.92293 7.65005 7.78655 7.78643C7.65017 7.92281 7.46519 7.99943 7.27232 7.99943C7.17964 8.00327 7.08717 7.9878 7.00079 7.954C6.91441 7.9202 6.836 7.8688 6.77054 7.80308L3.99983 4.996L1.20003 7.7958C1.13859 7.85927 1.06518 7.90994 0.984049 7.94489C0.902919 7.97984 0.81567 7.99837 0.727339 7.99943C0.534468 7.99943 0.349497 7.92281 0.213116 7.78643C0.076736 7.65005 0.000118324 7.46508 0.000118324 7.2722C-0.00157719 7.18305 0.0149648 7.09448 0.0487293 7.01195C0.0824938 6.92941 0.132769 6.85465 0.196468 6.79224L3.02536 3.99971L0.196468 1.17082C0.076611 1.05357 0.00632851 0.894781 0.000118324 0.72722C0.000118324 0.53435 0.076736 0.349378 0.213116 0.212998C0.349497 0.0766176 0.534468 0 0.727339 0C0.901872 0.00218166 1.06913 0.072722 1.19276 0.19635Z' fill='black'/></svg>`;
  let allCanvasDataflandscape = [];
  
  //Canvas
  
  const canvas = new fabric.Canvas("canvas", {
    selection: false, // Disable multiple selection
    enableRetinaScaling: window.innerWidth >= 750, // Prevent 3x memory buffer on iPhone
  });
  
  /* Move printable-area badges into the Fabric-generated .canvas-container so
     their position:absolute is relative to that div (which has position:relative)
     rather than .canvasmainbody. Done immediately after init so the container exists. */
  (function _mountCanvasBadges() {
    var container = canvas.wrapperEl;                                    // .canvas-container
    var front = document.querySelector('.wf-badge-wrap--front');
    var back  = document.querySelector('.wf-badge-wrap--back');
    if (container && front) container.appendChild(front);
    if (container && back)  container.appendChild(back);
  
    /* Initial position calculation — run after the first render so
       getBoundingClientRect() returns real coordinates.               */
    requestAnimationFrame(function () {
      if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
    });
  })();
  
  /* ── Mobile: keep Fabric.js touch-coordinate mapping fresh ────────────────
     The root problem: after any layout shift (drawer open/close, virtual
     keyboard, scroll) canvas.calcOffset() becomes stale, so touch-to-canvas
     coordinate mapping is wrong and objects (especially IText) can't be
     re-tapped.
  
     Approach: recalculate the offset BEFORE every single touch on the canvas
     (capture phase, so it runs before Fabric processes the event). We also
     hook the Fabric events for belt-and-suspenders coverage.                  */
  (function _mobileCanvasTouchFix() {
    /* ── touchstart on the upper canvas: refresh offset BEFORE Fabric.js ── */
    if (window.innerWidth < 750 && canvas.upperCanvasEl) {
      canvas.upperCanvasEl.addEventListener('touchstart', function () {
        canvas.calcOffset();
      }, { passive: true, capture: true });
    }
  
    /* ── After IText exits editing: reset bounding box ── */
    canvas.on('text:editing:exited', function (e) {
      if (e.target) {
        if (typeof e.target.initDimensions === 'function') e.target.initDimensions();
        e.target.setCoords();
      }
      canvas.calcOffset();
      canvas.requestRenderAll();
    });
  
    /* ── After any deselection: fresh offset for the next tap ── */
    canvas.on('selection:cleared', function () {
      if (window.innerWidth < 750) {
        canvas.calcOffset();
        /* Also recalc after the CSS transition settles (drawer ~320 ms) */
        setTimeout(function () { canvas.calcOffset(); }, 360);
      }
    });
  
    /* ── Increase touch target tolerance so small/thin text is still tappable ── */
    if (window.innerWidth < 750) {
      canvas.targetFindTolerance = 8;
    }
  
    /* ── Scroll → stale offset ── */
    if (window.innerWidth < 750) {
      window.addEventListener('scroll', function () {
        canvas.calcOffset();
      }, { passive: true });
    }
  
    /* ── Window resize (virtual keyboard show/hide on iOS) ── */
    if (window.innerWidth < 750) {
      window.addEventListener('resize', function () {
        canvas.calcOffset();
        if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
      }, { passive: true });
    }
  }());
  
  /* ── Printable-area badge position fix ────────────────────────────────────
     The badge uses CSS top: -11px (fixed pixels) as its baseline, but the
     canvas element inside the container can sit at a non-zero offset when its
     CSS uses top:50% + translate(-50%,-50%). This function reads the ACTUAL
     visual offset of the canvas element with getBoundingClientRect() and
     overrides the badge top so it always straddles the real canvas top edge,
     regardless of any CSS percentage recalculations triggered by layout shifts
     (e.g. mobile drawer open/close).                                          */
  function _recalcBadgePosition() {
    if (typeof canvas === 'undefined' || !canvas.wrapperEl) return;
    var container = canvas.wrapperEl;
    var mainCanvas = document.getElementById('canvas');
    if (!mainCanvas) return;
  
    var front = container.querySelector('.wf-badge-wrap--front');
    var back  = container.querySelector('.wf-badge-wrap--back');
    if (!front) return;
  
    var containerRect = container.getBoundingClientRect();
    var canvasRect    = mainCanvas.getBoundingClientRect();
  
    /* canvas top relative to the container top (visual, accounts for transforms) */
    var relTop  = canvasRect.top - containerRect.top;
    var badgeH  = (front.getBoundingClientRect().height || 22);
    var newTop  = Math.round(relTop - badgeH / 2);
  
    front.style.top = newTop + 'px';
    if (back) back.style.top = newTop + 'px';
  }
  
  fabric.Object.prototype.transparentCorners = false;
  fabric.Object.prototype.cornerColor = "#E44459";
  fabric.Object.prototype.cornerStyle = "circle";
  fabric.Object.prototype.borderColor = "#000";
  // Enlarge touch handles on mobile so they're thumb-reachable
  if (window.innerWidth < 749) {
    fabric.Object.prototype.cornerSize = 44;
  }
  canvas.clear();
  
  var set1Objects = [[], []];
  
  const convertImages = (query, callback) => {
    const images = document.querySelectorAll(query);

    images.forEach((image) => {
      const src = image.getAttribute("data-src");
      if (!src) return;

      fetch(src)
        .then((res) => {
          if (!res.ok) return null; // skip missing files silently
          return res.text();
        })
        .then((data) => {
          if (!data) return;
          const parser = new DOMParser();
          const svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");

          if (!svg) return; // guard against malformed / empty SVG response
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;

          image.parentNode.replaceChild(svg, image);
        })
        .then(callback)
        .catch(() => {}); // suppress 404 / network noise from console
    });
  };

  /* Lazy-load SVG spans as they scroll into view (IntersectionObserver).
     IMPORTANT: we observe the visible .svg_item CARD, not the hidden span
     (display:none elements never intersect the viewport so the observer
     would never fire if we watched the span directly).
     Falls back to eager convertImages() on browsers that lack the API.
     rootMargin: '200px' starts the fetch before the card is fully visible. */
  const lazyConvertImages = (query) => {
    const spans = document.querySelectorAll(query);
    if (!spans.length) return;

    if (!('IntersectionObserver' in window)) {
      convertImages(query);
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const card = entry.target; // the visible .svg_item card
        obs.unobserve(card);

        // Find the hidden span inside this card that still has data-src
        const image = card.querySelector('[data-src]');
        if (!image) return; // already loaded (span was replaced by svg)

        const src = image.getAttribute('data-src');
        if (!src) return;

        fetch(src)
          .then((res) => res.ok ? res.text() : null)
          .then((data) => {
            if (!data) return;
            const parser = new DOMParser();
            const svg = parser
              .parseFromString(data, 'image/svg+xml')
              .querySelector('svg');
            if (!svg) return;
            if (image.id) svg.id = image.id;
            if (image.className) svg.classList = image.className;
            image.parentNode.replaceChild(svg, image);
          })
          .catch(() => {});
      });
    }, { rootMargin: '200px' });

    // Observe the visible card, not the hidden span
    const observedCards = new Set();
    spans.forEach((span) => {
      const card = span.closest('.svg_item') || span.parentElement;
      if (card && !observedCards.has(card)) {
        observedCards.add(card);
        observer.observe(card);
      }
    });
  };
  
  //convertImages('.svg_item img');
  $(document).ready(function () {
    var sel_qty_ready = $(".qty_selected_row.sel_qty option:selected").val();
    $("li.file_qty span").text(sel_qty_ready);
    $(".tt-tile-qty-val").text(sel_qty_ready || "—");
  
    /* Rename desktop breadcrumb initial labels if admin left old defaults */
    (function () {
      var $tgy = $(".header_tattoo .tatoo_nav li.file_tgy");
      var tgyText = $tgy.text().trim();
      if (/^Technology/i.test(tgyText)) {
        $tgy.text(tgyText.replace(/^Technology(\s*Selection)?:?\s*/i, "Effect: "));
      }
      var $wopt = $(".header_tattoo .tatoo_nav li.file_w_option");
      var wText = $wopt.text().trim();
      if (/^W\.?\s*Option/i.test(wText)) {
        $wopt.text(wText.replace(/^W\.?\s*Option:?\s*/i, "White Ink: "));
      }
    }());
    var active_variant_handle = $(".loop-all.selection_active").attr(
      "custom_product"
    );
    var active_variant_handle_size = $(".loop-all.selection_active").attr("id");
    if (active_variant_handle_size != "qty-classic") {
      $("li.file_w_option").hide();
    } else {
      $("li.file_w_option").show();
    }
  
    /**********default show size***********/
    var qty_attr = $(
      ".tattoo_popup.popup_selection .loop-all.selection_active"
    ).attr("id");
    if (
      qty_attr == "qty-gliter" ||
      qty_attr == "qty-metalic" ||
      qty_attr == "qty-glow"
    ) {
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").addClass(
        "not-show"
      );
    } else {
      $("div#shopify-section-tattoo_popup .loop-all").show();
      $("div#shopify-section-tattoo_popup .loop-all").removeClass("not-show");
    }
    /**********default show size end***********/
  
    $(".variants_div .variants_data").removeClass("matched");
    if (active_variant_handle) {
      $(".variants_div .variants_data[custom_product='" + active_variant_handle + "']").addClass("matched");
    }
    $(".product-option.image_field").each(function () {
      var url = $(this).find("dd").text();
      $(this).find("dd").hide();
      $(this).append(
        "<img   height='' width='' loading='lazy' src='" + url + "'>"
      );
    });
  });
  
  var get_sym = $("form.form_syn").attr("sym");
  
  $(".center_close_btn").click(function () {
    $(".drower_search span.btn_close").click();
  });
  
  if ($(window).width() < 749) {
    /* Move canvas front/back toggle into the always-visible mobile slot */
    var fb = $(".canvas-container .div_custom_front_back");
    if (fb.length) {
      $(".mob_new_nav .tool_content").empty().append(fb);
    }
    /* Move save buttons back to canvas area (not the mobile bar) */
    var save_btn = $(".bottom_save_btns");
    if (save_btn.length) {
      $(".canvasmainbody").append(save_btn);
    }
  }
  
  /* ── Edit Selections sheet ── */
  function ttOpenEditSheet() {
    var $sheet = $("#tt-edit-sheet");
    $sheet.removeAttr("hidden").attr("aria-hidden", "false");
    /* Clear any leftover inline transform from a previous drag so the CSS
       open animation plays cleanly from translateY(100%) → translateY(0). */
    var panel = document.querySelector('.tt-edit-sheet__panel');
    if (panel) { panel.style.transform = ''; panel.style.transition = ''; }
    var overlay = document.querySelector('.tt-edit-sheet__overlay');
    if (overlay) { overlay.style.opacity = ''; overlay.style.transition = ''; }
    $("#tt-edit-selections-btn").attr("aria-expanded", "true");
    /* Sync current tile values from breadcrumb state */
    var tgyText = $(".tatoo_nav li.file_tgy").first().text().replace(/^Effect:\s*/i, "").trim();
    if (tgyText) $(".tt-tile-effect-val").text(tgyText);
    var sizeText = $(".tatoo_nav li.file_size span").first().text().trim();
    if (sizeText) $(".tt-tile-size-val").text(sizeText);
    var whiteText = $(".file_w_option span").first().text().trim();
    if (whiteText) $(".tt-tile-white-val").text(whiteText);
    var qtyText = $("li.file_qty span").first().text().trim();
    if (qtyText) $(".tt-tile-qty-val").text(qtyText);
    $("body").css("overflow", "hidden");
  }
  
  function ttCloseEditSheet() {
    $("#tt-edit-sheet").attr("hidden", true).attr("aria-hidden", "true");
    $("#tt-edit-selections-btn").attr("aria-expanded", "false");
    $("body").css("overflow", "");
  }
  
  $(document).on("click", "#tt-edit-selections-btn", function (e) {
    e.stopPropagation();
    ttOpenEditSheet();
  });
  
  $(document).on("click", "#tt-edit-sheet-close, #tt-edit-sheet-overlay", function () {
    ttCloseEditSheet();
  });
  
  $(document).on("click", ".tt-sheet-tile", function () {
    var step = $(this).data("edit-step");
    ttCloseEditSheet();
    if (step === "effect") {
      if (typeof ttOpenWizard === 'function') { ttOpenWizard(1); return; }
    } else if (step === "size") {
      $("li.file_size").first().trigger("click");
    } else if (step === "white") {
      $("li.file_w_option").first().trigger("click");
    } else if (step === "qty") {
      $("li.file_qty").first().trigger("click");
    }
  });
  
  $(document).on("keydown", "#tt-edit-sheet", function (e) {
    if (e.key === "Escape") ttCloseEditSheet();
  });
  
  /* Clicking outside the sheet panel closes it */
  $(document).on("click", ".tt-edit-sheet__panel", function (e) {
    e.stopPropagation();
  });
  
  /* ── Drag-to-dismiss: tt-edit-sheet ─────────────────────────────────────────
     Mirrors the slide_drower drag logic: touch the pill handle and drag down
     >80 px to dismiss; release earlier snaps the panel back into place.       */
  (function () {
    var sheet   = document.getElementById('tt-edit-sheet');
    var panel   = sheet && sheet.querySelector('.tt-edit-sheet__panel');
    var overlay = sheet && sheet.querySelector('.tt-edit-sheet__overlay');
    var handle  = sheet && sheet.querySelector('.tt-edit-sheet-handle');
  
    if (!sheet || !panel || !handle) return;
  
    var startY = 0, currentDelta = 0, dragging = false, dragIntent = false;
  
    panel.addEventListener('touchstart', function (e) {
      /* Only initiate a drag when the user touches the pill handle */
      if (!handle.contains(e.target)) return;
      if (sheet.hasAttribute('hidden')) return;
  
      startY       = e.touches[0].clientY;
      currentDelta = 0;
      dragIntent   = true;
      dragging     = false;
      panel.style.transition   = 'none';
      if (overlay) overlay.style.transition = 'none';
    }, { passive: true });
  
    panel.addEventListener('touchmove', function (e) {
      if (!dragIntent) return;
  
      var delta = e.touches[0].clientY - startY;
  
      /* Confirm drag on first meaningful downward movement */
      if (!dragging) {
        if (delta < 5) return;
        dragging = true;
      }
  
      currentDelta = Math.max(0, delta);
      panel.style.transform = 'translateY(' + currentDelta + 'px)';
  
      /* Fade overlay proportionally as panel moves down */
      if (overlay) {
        var ratio = Math.max(0, 1 - currentDelta / (window.innerHeight * 0.45));
        overlay.style.opacity = (0.45 * ratio).toFixed(3);
      }
    }, { passive: true });
  
    function _onTouchEnd() {
      dragIntent = false;
      if (!dragging) return;
      dragging = false;
  
      if (currentDelta > 80) {
        /* Animate panel off-screen, then call close to clean up */
        panel.style.transition = 'transform .32s cubic-bezier(.2,.7,.3,1)';
        if (overlay) overlay.style.transition = 'opacity .32s ease';
        panel.style.transform = 'translateY(100%)';
        if (overlay) overlay.style.opacity = '0';
  
        setTimeout(function () {
          panel.style.transition  = '';
          panel.style.transform   = '';
          if (overlay) {
            overlay.style.transition = '';
            overlay.style.opacity    = '';
          }
          ttCloseEditSheet();
        }, 340);
      } else {
        /* Snap back to fully open */
        panel.style.transition = 'transform .28s cubic-bezier(.32,.72,0,1)';
        panel.style.transform  = '';
        if (overlay) {
          overlay.style.transition = 'opacity .28s ease';
          overlay.style.opacity    = '';
        }
        setTimeout(function () {
          panel.style.transition = '';
          if (overlay) overlay.style.transition = '';
        }, 300);
      }
    }
  
    panel.addEventListener('touchend',    _onTouchEnd, { passive: true });
    panel.addEventListener('touchcancel', _onTouchEnd, { passive: true });
  }());
  
  var sliderSettings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    variableWidth: true,
    variableHeight: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='33' height='33' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16.5' cy='16.5' r='16.5' transform='matrix(-1 0 0 1 33 0)' fill='white'/><g clip-path='url(#clip0_212_116)'><path d='M7.39662 17.6682H22.8559L21.4717 19.0261V21.0517L25.6035 16.7845L21.4717 12.5172V14.5436L22.8559 15.9007H7.39662V17.6682Z' fill='black' /></g><defs><clipPath id='clip0_212_116'><rect width='18.2069' height='8.53448' fill='white' transform='matrix(-1 0 0 1 25.6035 12.5172)'/></clipPath></defs></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='33' height='33' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16.5' cy='16.5' r='16.5' transform='matrix(-1 0 0 1 33 0)' fill='white'/><g clip-path='url(#clip0_212_116)'><path d='M7.39662 17.6682H22.8559L21.4717 19.0261V21.0517L25.6035 16.7845L21.4717 12.5172V14.5436L22.8559 15.9007H7.39662V17.6682Z' fill='black' /></g><defs><clipPath id='clip0_212_116'><rect width='18.2069' height='8.53448' fill='white' transform='matrix(-1 0 0 1 25.6035 12.5172)'/></clipPath></defs></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  
  
  
  $(".tatoo_nav ul").hide();
  $(".my_editor").hide();
  $(".thumbs_for").hide();
  $(".thumbs_for:first-child").hide();
  $(".open_content").hide();
  $(".tattoo_popup .inner_Content").slick(sliderSettings);
  $(".edits_pop button:first-child").addClass("active");
  $(".pop_iner span:first-child").addClass("active");
  $("div#shopify-section-quntity-popup").hide();
  $("div#shopify-section-tattoo_popup_option").hide();
  $("div#shopify-section-tattoo_popup_notes").hide();
  $(".loop-all[obj_height='450']").addClass("active");
  $(".loop-all[obj_height='450']").addClass("active-new");
  $(".drop_down").hide();
  
  $(".slid_des li:first-child").addClass("active");
  $(".slid_des_content .tab-content").hide();
  $(".slid_des_content .tab-content:first").show();
  var white_data = $(
    ".tattoo_popup.popup_option .inner_Content_row .loop-all.white_option_active .loop-data span"
  ).text();
  $(".white_option_selected").attr("value", white_data);
  var title_product = $("form.form_syn").attr("data_title");
  $(".last-cart_page_inner .cmn.right .cmn_right_iner h2").text(title_product);
  var qty_val = $(".sel_qty").val();
  $(".count_update").text(qty_val);
  $(".quantity_selected").val(qty_val);
  $("li.file_qty span").text(qty_val);
  $(".tt-tile-qty-val").text(qty_val || "—");
  
  /*********Quantitu Dropdown Change **************/
  $(".qty_selected_row").change(function () {
    var qty_val = $(this).find("option:selected").val();
    $(".count_update").text(qty_val);
    $(".quantity_selected").val(qty_val);
    $("li.file_qty span").text(qty_val);
    $(".tt-tile-qty-val").text(qty_val);
    var selected_qty = $(".quantity_selected").val();
    localStorage.setItem("PageLoadQuantity", selected_qty);
  
  ////////****************update price start******************
    var custom_varinat_size = $(
      "div#shopify-section-tattoo_popup .loop-all.active-new .loop"
    ).attr("size_varinats");
    /* Fall back to the wizard-forced label when the hidden popup's active-new
       does not match (e.g. for new sizes not present in the popup's block list). */
    if (!custom_varinat_size && window._ttWizardActiveVarLabel) {
      custom_varinat_size = window._ttWizardActiveVarLabel;
    }
    var varinat_id = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("id");
    var varinat_price = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("price");
    var varinat_title = $(".variants_data.matched").attr("custom_product_title");
    $("form.form_syn").attr("data_price_product", varinat_price);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    $("form.form_syn").attr("size_selected", custom_varinat_size);
    $("form.form_syn").attr("data_title", varinat_title);
  
    $("form.form_syn .custom_varinat_id").attr("value", varinat_id);
  
    var form_qty = $(".sel_qty option:selected").val();
    var varinat_price_money = varinat_price;
    $("form.form_syn .actual_price").val(varinat_price_money);
    $(".loop-all-draft_first").removeClass("mm");
    $(".loop-all-draft_first[data-id='" + varinat_id + "']").each(function () {
      $(this).addClass("mm");
      var data_qty = parseInt($(this).attr("data-qty"));
  
      if (form_qty == data_qty) {
        varinat_price_money = $(this).attr("data-price");
      }
    });
    var varinat_price_money_qty = varinat_price_money;
  
    $("form.form_syn .price_selected").val(varinat_price_money);
    $("form.form_syn").attr("data_price_product", varinat_price_money);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    var form_qty_update = $(".quantity_selected").val();
    $(".sel_qty_data .insert_data__text").text(form_qty_update);
    (function () {
      var _sym = (typeof get_sym !== 'undefined' && get_sym) ? get_sym : '$';
      var _price = varinat_price_money_qty;
      var _qty = form_qty_update;
      if (!_price || String(_price) === 'undefined' || !_qty || String(_qty) === 'undefined') {
        $(".tatto_price").text('\u2014');
        $(".cmn_right_iner span.price").text('\u2014');
      } else {
        $(".tatto_price").text(_sym + _price);
        $(".cmn_right_iner span.price").text(_sym + _price);
      }
    })();
  
    //////////update price end*******************
  
    var qty_data = $("select.sel_qty option:selected").val();
    $(".quantity_selected").attr("value", qty_data);
    $(".selected_sizes_data .sel_qty_data .insert_data__text").text(qty_data);
    makevariablefor_atc();
  });
  
  
  
  /*********************On Product Name Click***START******************/
  $("div#shopify-section-tattoo_popup_selection .loop").click(function () {
    $("div#shopify-section-tattoo_popup").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_selection").removeClass("hide_div");
    var qty_attr = $(this).closest(".loop-all").attr("id");
        var opval = $(this).closest(".loop-all").attr("opval");
    if(opval == 'ophide'){
      $('#shopify-section-tattoo_popup .inner_Content .loop-all .loop[size_varinats="1.5 x 1.5"]').closest('.loop-all').hide();
    }else{
      $('#shopify-section-tattoo_popup .inner_Content .loop-all .loop[size_varinats="1.5 x 1.5"]').closest('.loop-all').show();
    }
  
   const $targets = $('#shopify-section-tattoo_popup .inner_Content .loop-all')
    .find('.loop[size_varinats="1.5 x 2.0"], .loop[size_varinats="1.5 x 3.0"]')
    .closest('.loop-all');
  
  if (['qty-metalic', 'qty-gliter', 'qty-glow'].includes(qty_attr)) {
    $targets.hide();
  } else {
    $targets.show();
  }
  
  
    if (qty_attr == "qty-semi-permanent") {
      $("span.edit_item.edit_color").hide();
    } else {
      $("span.edit_item.edit_color").show();
    }
  
    $(".qty_selected_row").hide();
    $('.qty_selected_row[id="' + qty_attr + '"]').show();
    $(".qty_selected_row").removeClass("sel_qty");
    $('.qty_selected_row[id="' + qty_attr + '"]').addClass("sel_qty");
  
    var custom_variant_size = $(
      "div#shopify-section-tattoo_popup .loop-all.active-new .loop"
    ).attr("size_varinats");
    var variant_id = $(
      ".variants_data.matched span[size='" + custom_variant_size + "']"
    ).attr("id");
  
  
    ///////var varinat_price=$(".variants_data.matched span[size='"+custom_variant_size+"']").attr('price');
  
    var selc_val = $('.qty_selected_row[id="' + qty_attr + '"]')
      .find("option:selected")
      .val();
    $("li.file_qty span").text(selc_val);
    $(".tt-tile-qty-val").text(selc_val || "—");
    $("input.quantity_selected").attr("value", selc_val);
    $("div#shopify-section-tattoo_popup_selection .loop").removeClass("active");
    $(this).addClass("active");
  
    $("div#shopify-section-tattoo_popup_selection .loop-all").removeClass(
      "selection_active"
    );
    $(this).closest(".loop-all").addClass("selection_active");
    var selectione_data = $(
      ".tattoo_popup.popup_selection .tattoo_popup_inner .selection_active .loop-data span"
    ).text();
    $(".tatoo_finsih_selected").attr("value", selectione_data);
    $(".selected_sizes_data .sel_tattoo_finish_data .insert_data__text").text(
      selectione_data
    );
    $(".maintitle_prd").text(selectione_data);
    $(".tatoo_nav li.file_tgy").text("Effect: " + selectione_data);
    $(".tt-tile-effect-val").text(selectione_data);
    var active_size = $(
      "div#shopify-section-tattoo_popup_selection .loop-all.selection_active"
    ).attr("id");
  
    var class_selection = $(this)
      .closest(".loop-all")
      .hasClass("selection_active");
  
    if (class_selection == true) {
      var active_variant_handle = $(this)
        .closest(".loop-all")
        .attr("custom_product");
      $(".variants_div .variants_data").removeClass("matched");
      if (active_variant_handle) {
        $(".variants_div .variants_data[custom_product='" + active_variant_handle + "']").addClass("matched");
        localStorage.setItem("PageLoadTechnology", active_variant_handle);
      }
    }
  
    var active_size = $(
      "div#shopify-section-tattoo_popup_selection .loop-all.selection_active"
    ).attr("id");
  
  
    console.log('active_size', active_size);
  
  
    if (active_size != "qty-classic") {
      $("li.file_w_option").hide();
      $("span.selection_btn.option").hide();
      $(".tt-sheet-tile-item--white-ink").addClass("tt-tile--hidden");
      var input = $("input.white_option_selected");
      var currentName = input.attr("name");
      var newName = "_" + currentName;
      input.attr("name", newName);
    } else {
      $("li.file_w_option").show();
      $("span.selection_btn.option").show();
      $(".tt-sheet-tile-item--white-ink").removeClass("tt-tile--hidden");
      var input = $("input.white_option_selected");
      var currentName = input.attr("name");
      var newName = currentName.replace("_", ""); // Remove underscore
      input.attr("name", newName);
    }
    localStorage.setItem("PageLoadId", active_size);
    makevariablefor_atc();
    if ($nopopup == false) {
      $("div#shopify-section-tattoo_popup_selection").fadeOut();
      $("div#shopify-section-tattoo_popup_back").hide();
    }
    if ($("div#shopify-section-tattoo_popup_selection").hasClass("pop_actice")) {
      /* breadcrumb re-open: do nothing extra (wizard handles it) */
    } else {
      if ($nopopup == false) {
        /* Wizard advances to size step via proxy handler; suppress old popup */
        if (typeof ttOpenWizard === 'function' && $('#tt-wizard').is(':visible')) {
          /* already inside wizard — let wizard proxy handler call ttNextStep */
        } else if (typeof ttOpenWizard === 'function') {
          /* triggered from breadcrumb or external: open wizard at size step */
          /* (handled by wizard breadcrumb listener) */
        }
      }
    }
    updateqty_html();
  });
  /*********************On Product Name Click***END******************/
  
  /*********************On Size Click***START******************/
  
  
  $("div#shopify-section-tattoo_popup .loop-all .loop").click(function () {
  
    $("div#shopify-section-tattoo_popup_selection").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_back").removeClass("hide_div");
  
    var custom_varinat_size = $(this).attr("size_varinats");
    var varinat_id = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("id");
    var varinat_price = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("price");
  
    var varinat_title = $(".variants_data.matched").attr("custom_product_title");
    $("form.form_syn").attr("data_price_product", varinat_price);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    $("form.form_syn").attr("size_selected", custom_varinat_size);
    $("form.form_syn").attr("data_title", varinat_title);
  
    $("form.form_syn .custom_varinat_id").attr("value", varinat_id);
  
    var form_qty = $(".sel_qty option:selected").val();
    var varinat_price_money = varinat_price;
    $("form.form_syn .actual_price").val(varinat_price_money);
    $(".loop-all-draft_first").removeClass("mm");
    $(".loop-all-draft_first[data-id='" + varinat_id + "']").each(function () {
      $(this).addClass("mm");
      var data_qty = parseInt($(this).attr("data-qty"));
  
      if (form_qty >= data_qty) {
        varinat_price_money = $(this).attr("data-price");
      }
    });
    //alert(varinat_price_money);
    var varinat_price_money_qty = varinat_price_money;
  
    $("form.form_syn .price_selected").val(varinat_price_money);
    $("form.form_syn").attr("data_price_product", varinat_price_money);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    var form_qty_update = $(".quantity_selected").val();
    $(".sel_qty_data .insert_data__text").text(form_qty_update);
    (function () {
      var _sym = (typeof get_sym !== 'undefined' && get_sym) ? get_sym : '$';
      var _price = varinat_price_money_qty;
      var _qty = form_qty_update;
      if (!_price || String(_price) === 'undefined' || !_qty || String(_qty) === 'undefined') {
        $(".tatto_price").text('\u2014');
        $(".cmn_right_iner span.price").text('\u2014');
      } else {
        $(".tatto_price").text(_sym + _price);
        $(".cmn_right_iner span.price").text(_sym + _price);
      }
    })();
  
    $("div#shopify-section-tattoo_popup .loop-all .loop").removeClass("active");
    $(this).addClass("active");
    var active_size = $(
      "div#shopify-section-tattoo_popup_selection .loop-all.selection_active"
    ).attr("id");
  
    $("div#shopify-section-tattoo_popup .loop-all").removeClass("active-new");
    $(this).closest(".loop-all").addClass("active-new");
    var size_data = $(".active-new .loop-data span").text();
    $(".size_selected").attr("value", size_data);
    $(".selected_sizes_data .sel_sizes_data .insert_data__text").text(size_data);
    var height_data = $(this).attr("height_data");
    var width_data = $(this).attr("width_data");
    const obj_height = $(this).attr("obj_height");
    var editingDims = getEditingCanvasDims(width_data, height_data);
    var newWidth = editingDims.width;
    var newHeight = editingDims.height;
  
    resizeCanvas(newWidth, newHeight, obj_height);
    var class_exsist_text = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new"
    )
      .find(".loop-data span")
      .text();
    $("li.file_size.size span").text(class_exsist_text);
    $(".tt-tile-size-val").text(class_exsist_text);
  
    $(".swatch-container").hide();
    $(".swatch-container").removeClass("tshow");
    $(".thumbnails_drower .thumbs_for").hide();
    $(".cstm_slidespar .slide_items").hide();
  
    var preview_class = "";
  
    if (class_exsist_text == "1.5 x 1.5 inches") {
      preview_class = "cmsize_1_5_1_5";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Arm Band
      $(".armband_thumbs").show();
      $(".armband_slider").show();
      $(".btn_prv_armband").show().addClass("tshow");
      //Face
      $(".face_slider").show();
      $(".face_thumbs").show();
      $(".btn_prv_face").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "1.5 in x 2 inches") {
      preview_class = "cmsize_1_5_2";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Arm Band
      $(".armband_thumbs").show();
      $(".armband_slider").show();
      $(".btn_prv_armband").show().addClass("tshow");
      //Face
      $(".face_slider").show();
      $(".face_thumbs").show();
      $(".btn_prv_face").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "1.5 in x 3 inches") {
      preview_class = "cmsize_1_5_3";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Arm Band
      $(".armband_thumbs").show();
      $(".armband_slider").show();
      $(".btn_prv_armband").show().addClass("tshow");
      //Face
      $(".face_slider").show();
      $(".face_thumbs").show();
      $(".btn_prv_face").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "2 x 2 inches") {
      preview_class = "cmsize_2_2";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Arm Band
      $(".armband_thumbs").show();
      $(".armband_slider").show();
      $(".btn_prv_armband").show().addClass("tshow");
      //Face
      $(".face_slider").show();
      $(".face_thumbs").show();
      $(".btn_prv_face").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "2 in x 3 inches") {
      preview_class = "cmsize_2_3";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Arm Band
      $(".armband_thumbs").show();
      $(".armband_slider").show();
      $(".btn_prv_armband").show().addClass("tshow");
      //Face
      $(".face_slider").show();
      $(".face_thumbs").show();
      $(".btn_prv_face").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "3 x 3 inches") {
      preview_class = "cmsize_3_3";
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
    } else if (class_exsist_text == "2 in x 4 inches") {
      preview_class = "cmsize_2_4";
      // Custom
      $(".cstm_slider").show();
      $(".custom_thumbs").show();
      $(".btn_prv_cstm_img").show().addClass("tshow");
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
      // Sleeves
      $(".sleeves_slider").show();
      $(".sleeves_thumbs").show();
      $(".btn_prv_sleeves").show().addClass("tshow");
      // Tiny
      $(".tiny_slider").show();
      $(".tiny_thumbs").show();
      $(".btn_prv_tiny").show().addClass("tshow");
    } else if (class_exsist_text == "4 x 4 inches") {
      preview_class = "cmsize_4_4";
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
    } else if (class_exsist_text == "4 in x 6 inches") {
      preview_class = "cmsize_4_6";
      // Back
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
    } else if (class_exsist_text == "6 x 6 inches") {
      // Back
      preview_class = "cmsize_6_6";
      $(".lower_slider").show();
      $(".lower_thumbs").show();
      $(".btn_prv_lower").show().addClass("tshow");
    }
    $(".cstm_slides_sticker").removeClass(function (index, className) {
      // This splits the class list into an array and filters out those starting with 'cmsize_'
      return (className.match(/\bcmsize_\S+/g) || []).join(" ");
    });
    $(".cstm_slides_sticker").addClass(preview_class);
  
    var back_has_active = $(".cmn.back").hasClass("active");
    if (back_has_active == true) {
      if (canvas.getObjects().length > 0) {
        canvas.renderAll();
      }
    }
    var size_varinats = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new .loop"
    ).attr("size_varinats");
    localStorage.setItem("PageLoadSize", size_varinats);
    addclass_aaccdingto_size_variants(size_varinats);
    if ($(window).width() < 1720) {
      var canvasContainerWidth = $(".canvas-container").width();
      if ($(".canvas-container").hasClass("canvas_width_tablet")) {
        var newHeight = canvasContainerWidth + 100;
        $(".canvas-container").css("height", newHeight + "px");
      } else {
        $(".canvas-container").height(canvasContainerWidth);
      }
    }
    /* After canvas container is sized, fix the badge position */
    requestAnimationFrame(function () {
      if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
    });
  
    /**********default show size***********/
    var qty_attr = $(
      ".tattoo_popup.popup_selection .loop-all.selection_active"
    ).attr("id");
    if (
      qty_attr == "qty-gliter" ||
      qty_attr == "qty-metalic" ||
      qty_attr == "qty-glow"
    ) {
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:not(.not-show)").each(
        function (index) {
          var currentElement = $(this); // Get the current element in the loop
          if (index == 0) {
            var currentElementitem = currentElement.find(".loop");
          }
        }
      );
    } else {
      $("div#shopify-section-tattoo_popup .loop-all").show();
      $("div#shopify-section-tattoo_popup .loop-all").removeClass("not-show");
    }
    /**********default show size end***********/
  
    resizeCanvasv2();
    makevariablefor_atc();
  
    $("div#shopify-section-tattoo_popup").fadeOut();
    if ($("#shopify-section-tattoo_popup").hasClass("pop_actice")) {
      /* breadcrumb re-open mode — wizard handles navigation */
    } else {
      if ($nopopup == false) {
        /* Wizard proxy handler advances step; old popup suppressed */
  $(document).ready(function() {
      var select = $('.qty_box_custom select.qty_selected_row.sel_qty');
      var options = select.find('option').toArray();
      options.sort(function(a, b) {
          return parseInt($(a).val()) - parseInt($(b).val());
      });
      select.empty().append(options);
      select.val($(options[0]).val()).trigger('change');
  });
      }
    }
    updateqty_html();
  });
  
  
  
  
  
  
  /*********************On Size Click***END******************/
  
  
  /*********************On Product Options Click***START******************/
  $("div#shopify-section-tattoo_popup_option .loop").click(function () {
  
    $("div#shopify-section-tattoo_popup_option").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_back").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_selection").removeClass("hide_div");
    $("div#shopify-section-quntity-popup").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_option .loop").removeClass("active");
    $(this).addClass("active");
    $("div#shopify-section-tattoo_popup_option .loop-all").removeClass(
      "white_option_active"
    );
    $(this).closest(".loop-all").addClass("white_option_active");
    var white_data = $(
      ".tattoo_popup.popup_option .inner_Content_row .loop-all.white_option_active .loop-data span"
    ).text();
  
    $(".white_option_selected").attr("value", white_data);
  
    var white_data2 = $(this).next(".loop-data").find("span").text();
    $(".file_w_option span").text(white_data2);
    $(".tt-tile-white-val").text(white_data2);
    localStorage.setItem("PageLoadOption", white_data);
    $("div#shopify-section-tattoo_popup_option").fadeOut();
    if ($("div#shopify-section-tattoo_popup_option").hasClass("pop_actice")) {
    } else {
      if ($nopopup == false) {
      //  $("div#shopify-section-quntity-popup").fadeIn();
      }
    }
  });
  /*********************On Product Options Click***START******************/
  
  /*********************On Back Options Click***START******************/
  $("div#shopify-section-tattoo_popup_back .cstm-btn").click(function () {
    $("span.cstm-btn.active").removeClass("active");
    $(this).addClass("active");
    $("div#shopify-section-tattoo_popup_back").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup").removeClass("hide_div");
    $("div#shopify-section-tattoo_popup_selection").removeClass("hide_div");
    var cstm_btn = $(this).attr("data-text");
    if (cstm_btn == "No") {
      $(".div_custom_front_back .cmn").removeClass("active");
      $(".canvasmainbody .div_custom_front_back .cmn.back").hide();
      $(".div_custom_front_back .front.cmn").addClass("active");
      var imageData = canvas.toDataURL("image/png");
  
      try {
        localStorage.setItem("canvasImageData", imageData);
      } catch (e) {
        // Storage unavailable (incognito or quota exceeded)
      }
  
      var storedImageData = localStorage.getItem("canvasImageData") || imageData;
      $(".front_tatt").remove();
      $("body").append(
        "<div class='front_tatt' style='display:none;'><img src=" +
          storedImageData +
          "   height='' width='' loading='lazy'></div>"
      );
  
      storeCurrentSet();
  
      // Toggle between sets
      currentSetIndex = 1 - currentSetIndex;
  
      // Restore the current set of objects
      restoreStoredData();
      //  $('.canvasmainbody .div_custom_front_back .cmn.back').hide();
      // var storedImageData = localStorage.getItem('canvasImageData');
      // $(".div_custom_front_back .front").trigger("click");
    } else {
      $(".canvasmainbody .div_custom_front_back .cmn.back").show();
    }
    var active_size = $(
      "div#shopify-section-tattoo_popup_selection .loop-all.selection_active"
    ).attr("id");
  
    $("div#shopify-section-tattoo_popup_back").fadeOut();
    if ($("div#shopify-section-tattoo_popup_back").hasClass("pop_actice")) {
    } else {
      if ($nopopup == false) {
        if (active_size == "qty-classic") {
          $("div#shopify-section-tattoo_popup_option").fadeIn();
        } else {
            $("div#shopify-section-tattoo_popup_back").removeClass("hide_div");
        //  $("div#shopify-section-quntity-popup").fadeIn();
        }
      }
    }
  });
  /*********************On Back Options Click***END******************/
  
  /*********************On Quantity Popup Click Next***START******************/
  $("span.qty_nxt").click(function () {
   // $(this).closest(".tattoo_popup_inner").find(".close").click();
  
    var custom_varinat_size = $(
      "div#shopify-section-tattoo_popup .loop-all.active-new .loop"
    ).attr("size_varinats");
    var varinat_id = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("id");
    var varinat_price = $(
      ".variants_data.matched span[size='" + custom_varinat_size + "']"
    ).attr("price");
    var varinat_title = $(".variants_data.matched").attr("custom_product_title");
    $("form.form_syn").attr("data_price_product", varinat_price);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    $("form.form_syn").attr("size_selected", custom_varinat_size);
    $("form.form_syn").attr("data_title", varinat_title);
  
    $("form.form_syn .custom_varinat_id").attr("value", varinat_id);
  
    var form_qty = $(".sel_qty option:selected").val();
  
    var varinat_price_money = varinat_price;
    $("form.form_syn .actual_price").val(varinat_price_money);
    $(".loop-all-draft_first").removeClass("mm");
    $(".loop-all-draft_first[data-id='" + varinat_id + "']").each(function () {
      $(this).addClass("mm");
      var data_qty = parseInt($(this).attr("data-qty"));
  
      if (form_qty == data_qty) {
        varinat_price_money = $(this).attr("data-price");
      }
    });
  
  
    //alert(varinat_price_money);
    var varinat_price_money_qty = varinat_price_money;
  
    $("form.form_syn .price_selected").val(varinat_price_money);
    $("form.form_syn").attr("data_price_product", varinat_price_money);
    $("form.form_syn").attr(
      "data_price_product_with_symbol",
      varinat_price_money
    );
    var form_qty_update = $(".quantity_selected").val();
    $(".sel_qty_data .insert_data__text").text(form_qty_update);
    (function () {
      var _sym = (typeof get_sym !== 'undefined' && get_sym) ? get_sym : '$';
      var _price = varinat_price_money_qty;
      var _qty = form_qty_update;
      if (!_price || String(_price) === 'undefined' || !_qty || String(_qty) === 'undefined') {
        $(".tatto_price").text('\u2014');
        $(".cmn_right_iner span.price").text('\u2014');
      } else {
        $(".tatto_price").text(_sym + _price);
        $(".cmn_right_iner span.price").text(_sym + _price);
      }
    })();
  
    //$('.inner_Content .loop-all.active-new .loop').click();
  
    var qty_val = $(".sel_qty").val();
    $(".count_update").text(qty_val);
    makevariablefor_atc();
  
    if ($nopopup == false) {
   if(Number(form_qty) < 100){
  $('.tatoo_nav li.file_w_option').hide();
  $('.tt-sheet-tile-item--white-ink').addClass('tt-tile--hidden');
  }else{
    $('.tatoo_nav li.file_w_option').show();
    $('.tt-sheet-tile-item--white-ink').removeClass('tt-tile--hidden');
  }
       if (form_qty == '1' || form_qty == '2' || form_qty == '5' || form_qty == '10' || form_qty == '25' || form_qty == '50') {
  
         $('.white_option_selected').remove();
           $(".div_custom_front_back .cmn").removeClass("active");
      $(".canvasmainbody .div_custom_front_back .cmn.back").hide();
      $(".div_custom_front_back .front.cmn").addClass("active");
      var imageData = canvas.toDataURL("image/png");
  
      try {
        localStorage.setItem("canvasImageData", imageData);
      } catch (e) {
        // Storage unavailable (incognito or quota exceeded)
      }
  
      var storedImageData = localStorage.getItem("canvasImageData") || imageData;
      $(".front_tatt").remove();
      $("body").append(
        "<div class='front_tatt' style='display:none;'><img src=" +
          storedImageData +
          "   height='' width='' loading='lazy'></div>"
      );
  
      storeCurrentSet();
  
      // Toggle between sets
      currentSetIndex = 1 - currentSetIndex;
  
      // Restore the current set of objects
      restoreStoredData();
      //  $('.canvasmainbody .div_custom_front_back .cmn.back').hide();
      // var storedImageData = localStorage.getItem('canvasImageData');
      // $(".div_custom_front_back .front").trigger("click");
   $(this).closest(".tattoo_popup_inner").find(".close").click();
  } else {
  
   if ($('.form_syn .white_option_selected').length === 0) {
    $('.form_syn').append('<input type="hidden" name="properties[White Option:]" class="white_option_selected">');
  }
          $("div#shopify-section-quntity-popup").fadeOut();
          $("div#shopify-section-tattoo_popup_back")
            .removeClass("hide_div")
            .fadeIn();
  }
     // $("div#shopify-section-tattoo_popup_selection").fadeOut();
    }
  });
  /*********************On Quantity Popup Click Next***END******************/
  
  $(".close, .remove").click(function () {
    $("div#shopify-section-tattoo_popup_selection").fadeOut();
    $("div#shopify-section-tattoo_popup").fadeOut();
    $("div#shopify-section-quntity-popup").fadeOut();
    $("div#shopify-section-tattoo_popup_option").fadeOut();
    $("div#shopify-section-tattoo_popup_notes").fadeOut();
    $("div#shopify-section-tattoo_popup_back").fadeOut();
    $(".tattoo_popup.popup_preview").fadeOut();
    $(".cart-popup").fadeOut();
    /* Wizard is also closed by its own delegated listener bound in wizard JS */
  });
  
  $(".cartnote_field").on("keyup", function () {
    var nots = $(this).val();
    $(".nots_selected").attr("value", nots);
    makevariablefor_atc();
  });
  
  $("li.file_size").click(function () {
    if ($nopopup == false) {
      if (typeof ttOpenWizard === 'function') { ttOpenWizard(1); return; }
      $("div#shopify-section-tattoo_popup").fadeIn();
    }
    if ($(".tattoo_popup .inner_Content").length && $(".tattoo_popup .inner_Content").hasClass('slick-initialized')) {
      $(".tattoo_popup .inner_Content")[0].slick.refresh();
    }
    $("div#shopify-section-tattoo_popup").addClass("pop_actice");
  
    var qty_attr = $(
      ".tattoo_popup.popup_selection .loop-all.selection_active"
    ).attr("id");
    if (
      qty_attr == "qty-gliter" ||
      qty_attr == "qty-metalic" ||
      qty_attr == "qty-glow"
    ) {
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").hide();
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").addClass(
        "not-show"
      );
      $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").addClass(
        "not-show"
      );
    } else {
      $("div#shopify-section-tattoo_popup .loop-all").show();
      $("div#shopify-section-tattoo_popup .loop-all").removeClass("not-show");
    }
  });
  
  $("li.file_qty").click(function () {
    if ($nopopup == false) {
      if (typeof ttOpenWizard === 'function') { ttOpenWizard(3); return; }
      $("div#shopify-section-quntity-popup").fadeIn();
    }
    $("div#shopify-section-quntity-popup").addClass("pop_actice");
  });
  
  $("li.file_tgy").click(function () {
    if ($nopopup == false) {
      /* Effect step is permanently hidden — open at Size step instead */
      if (typeof ttOpenWizard === 'function') { ttOpenWizard(1); return; }
      $("div#shopify-section-tattoo_popup_selection").fadeIn();
    }
    $("div#shopify-section-tattoo_popup_selection").addClass("pop_actice");
  });
  
  $("li.file_w_option").click(function () {
    if ($nopopup == false) {
      if (typeof ttOpenWizard === 'function') { ttOpenWizard(2); return; }
      $("div#shopify-section-tattoo_popup_option").fadeIn();
    }
    $("div#shopify-section-tattoo_popup_option").addClass("pop_actice");
  });
  
  $("li.file__note").click(function () {
    if ($nopopup == false) {
      $("div#shopify-section-tattoo_popup_notes").fadeIn();
    }
    $("div#shopify-section-tattoo_popup_notes").addClass("pop_actice");
  });
  
  /* ============================================================
     How-to popup / full-height bottom sheet
     — Replaces the legacy #shopify-section-instruction-popup.
     — Intercepts the "How-to" side-loop click (id="instructions")
       before it bubbles to the old $(document).on handler.
     — Mobile nav button identified by aria-label "how-to".
     ============================================================ */
  (function () {
    var overlay  = document.getElementById('tt-howto-overlay');
    var popup    = document.getElementById('tt-howto-popup');
    var closeBtn = document.getElementById('tt-howto-close');
  
    if (!overlay || !popup) return;
  
    function _openHowto() {
      overlay.classList.add('tt-howto-open');
      popup.classList.add('tt-howto-open');
      overlay.setAttribute('aria-hidden', 'false');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  
    function _closeHowto() {
      overlay.classList.remove('tt-howto-open');
      popup.classList.remove('tt-howto-open');
      overlay.setAttribute('aria-hidden', 'true');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Clear mobile nav active state */
      $('#tt-mob-nav .tt-mob-nav-btn').removeClass('tt-mob-nav-active');
      $howtoLoop.removeClass('active');
    }
  
    /* Expose so the mobile nav handler can call it directly */
    popup._openHowto  = _openHowto;
    popup._closeHowto = _closeHowto;
  
    /* Match the sidebar item by title "How-to" / "How to" OR legacy id "instructions" */
    var $howtoLoop = $('.side-loop').filter(function () {
      var title = $(this).find('.side-loop-title').text().trim().toLowerCase();
      return title === 'how-to' || title === 'how to' || $(this).attr('id') === 'instructions';
    });
    $howtoLoop.addClass('side-loop--howto');
  
    /* Intercept before the legacy $(document).on("click", "div#instructions", …) handler.
       stopPropagation prevents the click from bubbling to document.                       */
    $howtoLoop.on('click.howto', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      _openHowto();
    });
  
    if (closeBtn) closeBtn.addEventListener('click', _closeHowto);
    overlay.addEventListener('click', _closeHowto);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && popup.classList.contains('tt-howto-open')) {
        _closeHowto();
      }
    });
  }());
  
  /* ============================================================
     Disclaimer popup / bottom-sheet
     — Opens instead of the left drawer when "Disclaimer" is clicked.
     — Works on both desktop (centred modal) and mobile (bottom sheet).
     — Content is set in theme settings (disclaimer_title / disclaimer_content).
     ============================================================ */
  (function () {
    var overlay   = document.getElementById('tt-disclaimer-overlay');
    var popup     = document.getElementById('tt-disclaimer-popup');
    var closeX    = document.getElementById('tt-disclaimer-close-x');
    var closeDown = document.getElementById('tt-disclaimer-close-down');
  
    if (!overlay || !popup) return;
  
    function _openDisclaimer() {
      overlay.classList.add('tt-disc-open');
      popup.classList.add('tt-disc-open');
      overlay.setAttribute('aria-hidden', 'false');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  
    function _closeDisclaimer() {
      overlay.classList.remove('tt-disc-open');
      popup.classList.remove('tt-disc-open');
      overlay.setAttribute('aria-hidden', 'true');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Clear mobile nav active state for the disclaimer tab */
      var $nav = $('#tt-mob-nav');
      if ($nav.length) $nav.find('.tt-mob-nav-btn').removeClass('tt-mob-nav-active');
      /* Clear desktop sidebar active state */
      $disclaimerLoop.removeClass('active');
    }
  
    /* Expose on the DOM node so the mobile nav handler can call it directly */
    popup._openDisclaimer  = _openDisclaimer;
    popup._closeDisclaimer = _closeDisclaimer;
  
    /* Find the sidebar item whose title is "Disclaimer" (case-insensitive) */
    var $disclaimerLoop = $('.side-loop').filter(function () {
      return $(this).find('.side-loop-title').text().trim().toLowerCase() === 'disclaimer';
    });
  
    /* Mark it so mobile nav and other code can identify it */
    $disclaimerLoop.addClass('side-loop--disclaimer');
  
    /* Intercept clicks on the disclaimer sidebar item before the drawer handler runs */
    $disclaimerLoop.on('click.disclaimer', function (e) {
      e.stopImmediatePropagation();  /* prevent existing .side-loop handler from firing */
      _openDisclaimer();
    });
  
    /* Close actions */
    if (closeX)    closeX.addEventListener('click',    _closeDisclaimer);
    if (closeDown) closeDown.addEventListener('click', _closeDisclaimer);
    overlay.addEventListener('click', _closeDisclaimer);
  
    /* Keyboard: Escape closes the popup */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && popup.classList.contains('tt-disc-open')) {
        _closeDisclaimer();
      }
    });
  
    /* ── Drag-to-dismiss (mobile only) ──────────────────────────────────────
       Mirrors the same logic as the asset-panel bottom sheet.
       - Listen on the entire popup so the user can drag from anywhere when
         the inner scroll is at the top, or always from the pill area.
       - Animate to translateY(100%) first, then call _closeDisclaimer() so
         the CSS transition takes over cleanly without a visible snap.         */
    (function _disclaimerDrag() {
      if (window.innerWidth >= 750) return;
  
      var pill        = popup.querySelector('.tt-disclaimer-pill');
      var innerScroll = popup.querySelector('.tt-disclaimer-body');
  
      var startY = 0, currentDelta = 0, dragging = false, dragIntent = false;
  
      popup.addEventListener('touchstart', function (e) {
        if (!popup.classList.contains('tt-disc-open')) return;
  
        var isPill      = pill && pill.contains(e.target);
        var scrollAtTop = !innerScroll || innerScroll.scrollTop <= 0;
  
        if (!isPill && !scrollAtTop) return;
  
        startY       = e.touches[0].clientY;
        currentDelta = 0;
        dragIntent   = true;
        dragging     = false;
        popup.style.transition = 'none';
      }, { passive: true });
  
      popup.addEventListener('touchmove', function (e) {
        if (!dragIntent) return;
  
        var delta = e.touches[0].clientY - startY;
  
        if (!dragging) {
          if (delta < 5) return;   /* ignore tiny / upward movements */
          dragging = true;
        }
  
        currentDelta = Math.max(0, delta);
        popup.style.transform = 'translateY(' + currentDelta + 'px)';
  
        /* Fade overlay proportionally */
        var ratio = Math.max(0, 1 - currentDelta / (window.innerHeight * 0.45));
        overlay.style.opacity = (0.45 * ratio).toFixed(3);
      }, { passive: true });
  
      function _onTouchEnd() {
        dragIntent = false;
        if (!dragging) return;
        dragging = false;
  
        if (currentDelta > 80) {
          /* Animate the rest of the way off-screen, then close cleanly */
          popup.style.transition   = 'transform .32s cubic-bezier(.2,.7,.3,1)';
          overlay.style.transition = 'opacity .32s ease';
          popup.style.transform    = 'translateY(100%)';
          overlay.style.opacity    = '0';
  
          setTimeout(function () {
            popup.style.transition   = '';
            overlay.style.transition = '';
            overlay.style.opacity    = '';
            /* popup transform stays at translateY(100%) — same as CSS default —
               so removing .tt-disc-open causes no snap. */
            _closeDisclaimer();
            /* CSS now owns the transform; clear the inline override. */
            popup.style.transform = '';
          }, 340);
        } else {
          /* Snap back to open */
          popup.style.transition = '';
          popup.style.transform  = '';
          overlay.style.opacity  = '';
        }
      }
  
      popup.addEventListener('touchend',    _onTouchEnd, { passive: true });
      popup.addEventListener('touchcancel', _onTouchEnd, { passive: true });
    }());
  }());
  
  $(".side-loop").click(function () {
    $(".tab-content").hide();
   $("#filter-search").val("");
     $("#tabs-nav li").show();
    //$(".canvas-container").removeClass('for-margin');
    $(".drower_search").removeClass("remove_search");
    $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
  
  
    var id = $(this).attr("id");
    $(".card").closest(".body_iner_left").addClass("active");
    $(".card").closest(".left_dwroor").addClass("active");
    $(".body_iner_right").addClass("active");
    $(".side-loop").removeClass("active");
    $(this).addClass("active");
    $(".slid_des li:first-child").addClass("active");
    $(".open_content").hide();
    $(".open_content").removeClass('active');
    $(".open_content[id='" + id + "']").fadeIn();
    $(".open_content[id='" + id + "']").addClass('active');
    if ($(".side-loop").hasClass("active")) {
      $(".tatoo_nav ul").fadeIn();
      $(".my_editor").hide();
    }
    $(".main-secrion .canvas-container").removeClass("height_adjust");
    $(".static_contenet_back").remove();
    $(".main-secrion .canvas-container").removeClass("for-margin");
  
    /* Recalculate canvas hit-test offset after drawer opens on mobile.
       Also reposition the printable-area badge so it stays at the canvas top.
       Run twice: immediately (RAF) and after the CSS transition settles. */
    if (typeof canvas !== 'undefined' && window.innerWidth < 750) {
      requestAnimationFrame(function () {
        canvas.calcOffset();
        if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
      });
      setTimeout(function () {
        canvas.calcOffset();
        if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
      }, 360);
    }
  
    if ($(".cmn.back").hasClass("active")) {
    } else {
      var this_id = $(this).attr("id");
      //$('.front.cmn').attr('id', '');
    }
  
    if ($(window).width() < 749) {
      $(".tatoo_nav.small-hide >ul").hide();
      /* Show backdrop behind bottom sheet */
      if (window._ttDrawerBackdrop) {
        window._ttDrawerBackdrop.classList.add('tt-backdrop-open');
      }
      /* iOS scroll-freeze: save current scroll position then pin body so
         the page cannot scroll behind the sheet while the keyboard is open.
         Restored in the .btn_close handler below. */
      var _iosScrollY = window.scrollY || window.pageYOffset || 0;
      document.body._ttScrollY = _iosScrollY;
      document.body.style.position  = 'fixed';
      document.body.style.top       = '-' + _iosScrollY + 'px';
      document.body.style.width     = '100%';
      document.body.style.overflowY = 'hidden';
    }
    showtoolbardynamic();
  
    /* When the design panel opens, reset category filter to "All" */
    if (id === 'design') {
      ttDlResetFilter();
    }
  
    if (!$svgloaded) {
      $svgloaded = true;
      lazyConvertImages(".svg_item span");
    }
  });
  
  /* ── Auto-activate the first sidebar item on desktop only ──────────────────
     On mobile the user selects a sidebar item manually.
     We defer by one tick so all other $() initialisation has settled.         */
  if (window.innerWidth >= 750) {
    setTimeout(function () {
      var $first = $(".side-loop").first();
      if ($first.length) $first.trigger("click");
    }, 0);
  }
  
  $("div#shopify-section-login_for_save_tattoo span.close").click(function () {
    $("div#shopify-section-login_for_save_tattoo").fadeOut();
    $("div#shopify-section-login_for_save_tattoo").addClass("removepop");
  });
  
  $(".sidebar div#upload").click(function () {
    $(".drower_search").addClass("remove_search");
    // $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
    // $('.front.cmn').trigger('click');
    //$(".loop-all").removeClass('active-new');
    updateHeight();
  });
  
  
  $("div#text").click(function () {
    $(".drower_search").removeClass("remove_search");
    $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
  });
  
  $("div#template").click(function () {
    $(".drower_search").removeClass("remove_search");
    $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
  });
  
  $(".btn_close").click(function () {
    // $(".card").removeClass("active");
    $(".card").closest(".body_iner_left").removeClass("active");
    $(".card").closest(".left_dwroor").removeClass("active");
    $(".body_iner_right").removeClass("active");
    $(".side-loop").removeClass("active");
    $(".tatoo_nav ul").fadeOut();
    $(".my_editor").fadeOut();
   $("#filter-search").val("");
     $("#tabs-nav li").show();
   $(".tab-content").hide();
  
    $(".main-secrion .canvas-container").removeClass("for-margin");
  
    /* Hide mobile backdrop */
    if (window._ttDrawerBackdrop) {
      window._ttDrawerBackdrop.classList.remove('tt-backdrop-open');
    }
  
    /* iOS scroll-restore: undo the scroll-freeze applied when the sheet opened.
       Restore body to normal flow then jump back to the saved scroll position
       so the page (including the header) is exactly where the user left it. */
    if (window.innerWidth < 750) {
      var _savedY = parseInt(document.body._ttScrollY || 0, 10);
      document.body.style.position  = '';
      document.body.style.top       = '';
      document.body.style.width     = '';
      document.body.style.overflowY = '';
      document.body._ttScrollY      = 0;
      window.scrollTo(0, _savedY);
    }
  
    /* Clear mobile nav active state */
    $('#tt-mob-nav .tt-mob-nav-btn').removeClass('tt-mob-nav-active');
  
    /* Recalculate canvas hit-test offset after drawer closes so objects
       (especially IText) remain tappable/selectable on mobile.
       Also reposition the printable-area badge so it stays at the canvas top.
       Run twice: immediately (RAF) and after the CSS transition settles. */
    if (typeof canvas !== 'undefined' && window.innerWidth < 750) {
      requestAnimationFrame(function () {
        canvas.calcOffset();
        if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
      });
      setTimeout(function () {
        canvas.calcOffset();
        if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
      }, 360);
    }
  });
  
  $(".slid_des li").click(function () {
    $('.open_content').removeClass("active");
    $(".slid_des_content").removeClass("for-scroll");
    $(".slid_des li").removeClass("active");
    $(this).addClass("active");
    $(".slid_des_content .tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    $("#live-search input[type='text']").val($(this).text());
    $(".slid_des li").hide();
    $(this).parents('.tabs').find('.slid_des_content span.content-back-arrow').show();
    return false;
  });
  
  $(document).on(
    "click",
    ".edit_bold, .edit_italic, .edit_underline, .edit_color, .edit_font-family",
    function () {
      $(".edits_pop.dropdown").hide();
    }
  );
  
  $(document).on("click", ".edit_drow button, .edit_erase button", function () {
    $(this).siblings(".edits_pop").toggle();
    $(this).removeClass("active");
    $(".edit_item").toggleClass("active");
    $(".drop_down").hide();
    $("span.edit_item.edit_front_back").removeClass("arrows");
  });
  $(document).on("click", ".edit_item", function () {
    if ($(this).hasClass("edit_front_back")) {
      $(".drop_down").toggle();
      $("span.edit_item.edit_front_back").addClass("arrows");
    } else {
      $(".drop_down").hide();
    }
  });
  
  $(document).on(
    "click",
    ".tatoo_nav li:not(:first-child), .tatto_body",
    function () {
      $(".sub-menu-drop").removeClass("active");
    }
  );
  
  $(
    ".edit_drow button, .edit_erase button, .edit_font button, .edit_bold button, .edit_italic button, .edit_underline button, .edit_align > button, .edit_spacing button"
  ).click(function () {
    $(this).toggleClass("active");
  });
  
  $(document).on("click", ".edits_pop button", function () {
    $(".edits_pop button").removeClass("active");
    $(this).addClass("active");
  });
  
  $(".edit_item_pop button").click(function () {
    $(".edits_pop").not($(this).siblings(".edits_pop")).hide(); // Hide all .edits_pop except the sibling of the clicked button
    $(this).siblings(".edits_pop").toggle(); // Toggle the specific .edits_pop sibling
  });
  
  $(".pop_iner span").click(function () {
    $(".pop_iner span").removeClass("active");
    $(this).addClass("active");
  });
  $(".control-Done, .cont-cancel").click(function () {
    $(this).parents(".edit_item").find("button").trigger("click");
  });
  $(document).on("click", "canvas.upper-canvas", function () {
    $(".edits_pop.dropdown").hide();
  });
  
  $(document).on(
    "click",
    ".uploades_imgs_data .updateImg, .uploades_imgs_data_back .updateImg",
    function () {
      $(".uploades_imgs_data .updateImg").removeClass("active");
      $(".uploades_imgs_data_back .updateImg").removeClass("active");
      $(this).addClass("active");
      $(".my_editor#design").fadeIn();
      $(".my_editor#text").hide();
    }
  );
  
  $(document).on(
    "click",
    ".uploades_imgs_data .updateImg span, .uploades_imgs_data_back .updateImg span",
    function () {
      $(this).parent().remove();
    }
  );
  
  $(
    ".cstm_slider, .armband_slider, .face_slider, .sleeves_slider, .tiny_slider, .lower_slider"
  ).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    infinite: false,
    asNavFor:
      ".custom_thumbs, .armband_thumbs, .face_thumbs, .sleeves_thumbs, .tiny_thumbs, .lower_thumbs",
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='78' height='78' viewBox='0 0 78 78' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_567_1328)'><path d='M41.8417 30.4728L33.3154 38.9991L41.8417 30.4728ZM33.3154 38.9991L41.8417 47.5254L33.3154 38.9991Z' fill='#E44459'/><circle cx='27' cy='27' r='27' transform='matrix(1 0 0 -1 12 66)' fill='#E44459'/></g><path d='M42.7982 46.7506L35.6253 38.9992L42.7982 31.2478C42.9266 31.1093 42.9985 30.9234 42.9985 30.7298C42.9985 30.5362 42.9266 30.3503 42.7982 30.2118C42.7358 30.1447 42.6614 30.0915 42.5792 30.0551C42.4971 30.0187 42.4089 30 42.3197 30C42.2306 30 42.1424 30.0187 42.0602 30.0551C41.9781 30.0915 41.9036 30.1447 41.8412 30.2118L34.209 38.4579C34.075 38.6028 34 38.797 34 38.9992C34 39.2014 34.075 39.3957 34.209 39.5405L41.8398 47.7866C41.9022 47.8541 41.9768 47.9078 42.0593 47.9445C42.1417 47.9811 42.2303 48 42.3197 48C42.4092 48 42.4978 47.9811 42.5802 47.9445C42.6626 47.9078 42.7373 47.8541 42.7997 47.7866C42.9281 47.6481 43 47.4622 43 47.2686C43 47.075 42.9266 46.8891 42.7982 46.7506Z' fill='#31303B' stroke='#fff' stroke-width='2'/><defs><filter id='filter0_d_567_1328' x='0' y='0' width='78' height='78' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset/><feGaussianBlur stdDeviation='6'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_567_1328'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_567_1328' result='shape'/></filter></defs></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='78' height='78' viewBox='0 0 78 78' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_567_1626)'><path d='M36.1583 47.5272L44.6846 39.0009L36.1583 47.5272ZM44.6846 39.0009L36.1583 30.4746L44.6846 39.0009Z' fill='#E44459'/><circle cx='27' cy='27' r='27' transform='matrix(-1 0 0 1 66 12)' fill='#E44459'/></g><path d='M35.2018 31.2494L42.3747 39.0008L35.2018 46.7522C35.0734 46.8907 35.0015 47.0766 35.0015 47.2702C35.0015 47.4638 35.0734 47.6497 35.2018 47.7882C35.2642 47.8553 35.3386 47.9085 35.4208 47.9449C35.5029 47.9813 35.5911 48 35.6803 48C35.7694 48 35.8576 47.9813 35.9398 47.9449C36.0219 47.9085 36.0964 47.8553 36.1588 47.7882L43.791 39.5421C43.925 39.3972 44 39.203 44 39.0008C44 38.7986 43.925 38.6043 43.791 38.4595L36.1602 30.2134C36.0978 30.1459 36.0232 30.0922 35.9407 30.0555C35.8583 30.0189 35.7697 30 35.6803 30C35.5908 30 35.5022 30.0189 35.4198 30.0555C35.3374 30.0922 35.2627 30.1459 35.2003 30.2134C35.0719 30.3519 35 30.5378 35 30.7314C35 30.925 35.0734 31.1109 35.2018 31.2494Z' fill='#31303B' stroke='#fff' stroke-width='2'/><defs><filter id='filter0_d_567_1626' x='0' y='0' width='78' height='78' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset/><feGaussianBlur stdDeviation='6'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_567_1626'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_567_1626' result='shape'/></filter></defs></svg></button>",
  });
  
  $(
    ".custom_thumbs, .armband_thumbs, .face_thumbs, .sleeves_thumbs, .tiny_thumbs, .lower_thumbs"
  ).slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    asNavFor:
      ".cstm_slider, .armband_slider, .face_slider, .sleeves_slider, .tiny_slider, .lower_slider",
    focusOnSelect: true,
    arrows: false,
  });
  
  $(document).on("click", ".sel_sizes_data .insert_data", function (event) {
    event.preventDefault();
    if ($nopopup == false) {
      $("#shopify-section-tattoo_popup").fadeIn();
    }
    $(".inner_Content")[0].slick.refresh();
    $("#shopify-section-tattoo_popup").addClass("pop_actice");
  
  var vlhd = $('.sel_tattoo_finish_data .insert_data__text').text();
    if(vlhd === 'Glitter' || vlhd === 'Metallic' || vlhd === 'Glow-in-the-Dark'){
       $('#shopify-section-tattoo_popup .inner_Content .loop-all .loop[size_varinats="1.5 x 1.5"]').closest('.loop-all').hide();
    }else{
      $('#shopify-section-tattoo_popup .inner_Content .loop-all .loop[size_varinats="1.5 x 1.5"]').closest('.loop-all').show();
    }
  
  });
  
  $(document).on("click", ".sel_qty_data .insert_data", function (event) {
    event.preventDefault();
    if ($nopopup == false) {
      $("#shopify-section-quntity-popup").fadeIn();
    }
    $("#shopify-section-quntity-popup").addClass("pop_actice");
  });
  
  $(document).on(
    "click",
    ".sel_tattoo_finish_data .insert_data",
    function (event) {
      event.preventDefault();
      if ($nopopup == false) {
        $("#shopify-section-tattoo_popup_selection").fadeIn();
      }
      $("#shopify-section-tattoo_popup_selection").addClass("pop_actice");
    }
  );
  
  $(".swatch-container").click(function () {
    var tab_id = $(this).attr("id");
    $(".cstm_slides .slide_items").hide();
    $(".cstm_slides .slide_items[id='" + tab_id + "']").fadeIn();
    $(".swatch-container").removeClass("active");
    $(this).addClass("active");
    $(".thumbs_for").hide();
    $(".thumbs_for[id='" + tab_id + "']").fadeIn();
    $(".cstm_slides .slide_items[id='" + tab_id + "']")[0].slick.refresh();
    $(".thumbs_for[id='" + tab_id + "']")[0].slick.refresh();
  });
  
  $(".tatoo_nav li").click(function () {
    var id = $(this).attr("id");
    $(".sub-menu-drop[id='" + id + "']").toggleClass("active");
    $(".main-secrion .canvas-container").removeClass("height_adjust");
    $(".static_contenet_back").remove();
  });
  
  $(".add_to_cart, .slider_add_to_cart").click(function () {
    $(".tattoo_popup.popup_preview").fadeOut();
    $(".tearms_txt").addClass("active");
    // var base64Image = canvas.toDataURL("image/png");
    var $activesize = $(
      "div#shopify-section-tattoo_popup .loop-all .loop.active"
    );
    var height_data = $activesize.attr("height_data");
    var width_data = $activesize.attr("width_data");
    var converted_width = $activesize.attr("converted_width");
    var converted_height = $activesize.attr("converted_height");
    var base64Image = getResizedImage(canvas, converted_width, converted_height);
    var previewW = canvas.getWidth();
    var previewH = canvas.getHeight();
    if ($(".inenr_tearm input").is(":checked")) {
      $(".tearms_txt").removeClass("active");
      setTimeout(function () {
        var class_back_active = $(".front.cmn").hasClass("active");
  
        if (class_back_active) {
          $(".last-cart_page_inner .cmn.left .base_img").remove();
          $(".last-cart_page_inner .cmn.left").append(
            "<img   loading='lazy' class='base_img' height='" +
              previewH +
              "' width='" +
              previewW +
              "' src='" +
              base64Image +
              "'>"
          );
  
          // Check if the canvas has objects
          if (canvas.getObjects().length > 0) {
            $(".cart-popup-empty").fadeOut();
            $(".last-cart_page").fadeIn();
            makevariablefor_atc();
          } else {
            $(".cart-popup-empty").fadeIn();
            $(".last-cart_page").fadeOut();
          }
        } else {
          alert("Front selection required for cart addition.");
        }
      }, 300);
    }
  });
  
  $(document).on("click", ".sign-login", function () {
    var clss_exsit = $(this).hasClass("login-success");
    if (clss_exsit) {
      $(".login-form-tattoo").fadeOut();
      $(".login-form-tattoo").removeClass("active");
      alert("Already Login");
    } else {
      var size_varinats = $(
        "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new .loop"
      ).attr("size_varinats");
  
      if (size_varinats == "6.0 x 6.0") {
        saveCanvas6x6();
        loadCanvas6x6();
      } else if (size_varinats == "4.0 x 6.0") {
        saveCanvas4x6();
        loadCanvas4x6();
      } else if (
        size_varinats == "1.5 x 2.0" ||
        size_varinats == "1.5 x 3.0" ||
        size_varinats == "2.0 x 3.0" ||
        size_varinats == "2.0 x 4.0"
      ) {
        saveCanvasLands();
        loadCanvasLands();
      } else if (
        size_varinats == "1.5 x 1.5" ||
        size_varinats == "2.0 x 2.0" ||
        size_varinats == "3.0 x 3.0" ||
        size_varinats == "4.0 x 4.0"
      ) {
        saveCanvasPotraits();
        loadCanvasPotraits();
      }
    }
  
    // saveCanvasStateLoad();
  });
  
  $(".cart-popup-empty .last-cart_page_flx span.close").click(function () {
    $(".cart-popup-empty").fadeOut();
  });
  $(".close_shopping_cart").click(function () {
    $(".cart-popup").fadeOut();
  });
  $(".close_login_form").click(function () {
    $(".login-form-tattoo").fadeOut();
    $(".login-form-tattoo").removeClass("active");
  });
  
  $(document).on("click", "div#instructions", function () {
    $(".left_dwroor, .body_iner_left, .body_iner_right").removeClass("active");
    $("#shopify-section-instruction-popup").fadeIn();
    $(".main-secrion .canvas-container").removeClass("for-margin");
  });
  $(document).on("click", ".instructions_popup_inner span.close", function () {
    $("#shopify-section-instruction-popup").fadeOut();
    $("div#instructions").removeClass("active");
  });
  
  function closeProductionTimePopup() {
    $("#production-time-modal").fadeOut();
  }
  
  function getProductionTimePageUrl() {
    var config = window.productionTimeModalConfig || {};
    var $content = $("#production-time-modal-content");
    var pageUrl = config.pageUrl || $content.data("pageUrl") || "/pages/production-time";
    if (typeof Shopify !== "undefined" && Shopify.routes && Shopify.routes.root) {
      var root = Shopify.routes.root;
      if (root !== "/" && pageUrl.indexOf(root) !== 0) {
        pageUrl = root.replace(/\/$/, "") + pageUrl;
      }
    }
    return pageUrl;
  }
  
  function extractProductionTimeSectionFromPage(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var selectors = [
      ".shopify-section.section-main-page",
      ".shopify-section.shopify-section--main-page",
      "section.shopify-section[id*='__main']",
    ];
  
    for (var i = 0; i < selectors.length; i++) {
      var section = doc.querySelector(selectors[i]);
      if (section) {
        return section.outerHTML;
      }
    }
  
    return "";
  }
  
  function wrapProductionTimeTables($container) {
    $container.find(".rte table").each(function () {
      var $table = $(this);
      if (!$table.closest(".responsive-table").length) {
        $table.wrap('<div class="responsive-table"></div>');
      }
    });
  }
  
  function setProductionTimeModalTitle($container) {
    var $heading = $container.find(".b-main-title, .h1, h1").first();
    if ($heading.length) {
      var titleId = "production-time-modal-title";
      if (!$heading.attr("id")) {
        $heading.attr("id", titleId);
      }
      $("#production-time-modal").attr("aria-labelledby", $heading.attr("id"));
    }
  }
  
  function fetchProductionTimeSectionHtml() {
    var pageUrl = getProductionTimePageUrl();
    var sectionKey = (window.productionTimeModalConfig && window.productionTimeModalConfig.sectionKey) || "main";
    var cacheBuster = window.Shopify && Shopify.designMode ? "&_=" + Date.now() : "";
  
    return fetch(pageUrl + "?sections=" + sectionKey + cacheBuster)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("sections request failed");
        }
        return response.json();
      })
      .then(function (data) {
        if (data && data[sectionKey]) {
          return data[sectionKey];
        }
        throw new Error("section html missing");
      })
      .catch(function () {
        return fetch(pageUrl + "?section_id=" + sectionKey + cacheBuster).then(function (response) {
          if (!response.ok) {
            throw new Error("section_id request failed");
          }
          return response.text();
        });
      })
      .catch(function () {
        return fetch(pageUrl + cacheBuster).then(function (response) {
          if (!response.ok) {
            throw new Error("page request failed");
          }
          return response.text();
        }).then(extractProductionTimeSectionFromPage);
      });
  }
  
  function openProductionTimePopup() {
    if (!$("#production-time-modal").parent().is("body")) {
      $("#production-time-modal").appendTo("body");
    }
  
    var $modal = $("#production-time-modal");
    var $content = $("#production-time-modal-content");
  
    $modal.fadeIn();
    $content.html('<p class="production-time-modal__loading" aria-live="polite">Loading production times…</p>');
    $("#production-time-modal .production-time-modal__close").trigger("focus");
  
    fetchProductionTimeSectionHtml()
      .then(function (html) {
        if (!html || !html.trim()) {
          throw new Error("empty section html");
        }
        $content.html(html);
        wrapProductionTimeTables($content);
        setProductionTimeModalTitle($content);
      })
      .catch(function () {
        $content.html(
          '<p class="production-time-modal__loading">Unable to load production times. Please try again.</p>'
        );
      });
  }
  
  document.addEventListener(
    "click",
    function (event) {
      if (!event.target.closest("#open-production-time-popup")) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openProductionTimePopup();
    },
    true
  );
  
  $(document).on("click", "#production-time-modal .production-time-modal__dialog", function (event) {
    event.stopPropagation();
  });
  
  $(document).on("click", "#production-time-modal .production-time-modal__close", function (event) {
    event.preventDefault();
    event.stopPropagation();
    closeProductionTimePopup();
  });
  
  $(document).on("click", "#production-time-modal", function (event) {
    if ($(event.target).is("#production-time-modal")) {
      closeProductionTimePopup();
    }
  });
  
  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && $("#production-time-modal").is(":visible")) {
      closeProductionTimePopup();
    }
  });
  
  $(".without_login").click(function () {
    $(".instructions_popup_inner .close").click();
  });
  $(".with_login").click(function () {
    $(".instructions_popup_inner .close").click();
    $("li.sign-login").click();
  });
  
  $(document).on("click", ".imgs_div .imgs", function () {
  
    var class_exsist = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all"
    ).hasClass("active-new");
  
    var svgEl = $(this).find("svg")[0];
    if (!svgEl || svgEl.innerHTML.trim() === "") {
      // SVG not yet inlined (lazy-loaded but not yet in view) —
      // fetch only this card's span, then place on canvas once ready.
      var $clicked = $(this);
      var $span = $clicked.find('[data-src]');
      if ($span.length) {
        var _src = $span.attr('data-src');
        fetch(_src)
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (data) {
            if (data) {
              var _parser = new DOMParser();
              var _svg = _parser.parseFromString(data, 'image/svg+xml').querySelector('svg');
              if (_svg) {
                var _el = $span[0];
                if (_el.id) _svg.id = _el.id;
                if (_el.className) _svg.classList = _el.className;
                _el.parentNode.replaceChild(_svg, _el);
              }
            }
            refreshClickSvg($clicked);
          })
          .catch(function () { refreshClickSvg($clicked); });
      }
    } else {
      refreshClickSvg($(this));
    }
  });

  // Text Click Start
  //var fontFamilySelect = document.getElementById("font-family-select");
  var isEditingText = false;
  
  /* ══════════════════════════════════════════════════════════════════════════
     Text Panel — new UI handlers (font pills, style pills, preview, add btn)
     ══════════════════════════════════════════════════════════════════════════ */
  
  // ── State for the text panel ── //
  var _ttTextFont      = null; // resolved on first pill click; falls back to first active pill
  var _ttTextBold      = false;
  var _ttTextItalic    = false;
  var _ttTextUnderline = false;
  
  // Helper: load a Google Font URL once (no duplicates)
  function ttLoadGoogleFont(url) {
    if (!url || url.trim() === '') return;
    if ($('link[data-tt-gfont="' + url + '"]').length) return; // already loaded
    $('<link rel="stylesheet">')
      .attr({ href: url, 'data-tt-gfont': url })
      .appendTo('head');
  }
  
  // Helper: read active font from the pill row
  function ttGetSelectedFont() {
    var $active = $('.tt-font-pill.active');
    return $active.length ? ($active.data('font') || 'sans-serif') : 'sans-serif';
  }
  
  // Helper: sync preview text styling from current pill/style state
  function ttSyncPreview() {
    var $preview = $('#tt-text-preview-text');
    $preview.css({
      'font-family':    ttGetSelectedFont(),
      'font-weight':    _ttTextBold      ? 'bold'   : 'normal',
      'font-style':     _ttTextItalic    ? 'italic' : 'normal',
      'text-decoration':_ttTextUnderline ? 'underline' : 'none'
    });
  }
  
  // ── iOS Safari viewport-zoom reset on input blur ──────────────────────────────
  // iOS Safari auto-zooms when an input receives focus. Even with font-size:16px
  // set on the inputs, this fallback snaps the viewport back to initial-scale=1
  // after the keyboard is dismissed, preventing the residual-zoom bug on older iOS.
  $(document).on('blur', '#tt-text-input, .dl-search-input', function () {
    if (window.innerWidth < 750) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=1');
        setTimeout(function () {
          viewport.setAttribute('content', 'width=device-width,initial-scale=1');
        }, 300);
      }
    }
  });
  
  // ── Text input → update preview + enable/disable "Add to design" ── //
  $(document).on('input', '#tt-text-input', function () {
    var val = $(this).val();
    var $previewText = $('#tt-text-preview-text');
    var $placeholder = $('#tt-text-preview-placeholder');
    var $addBtn      = $('#tt-add-to-design-btn');
  
    if (val.length > 0) {
      $placeholder.hide();
      $previewText.text(val).show();
      $addBtn.prop('disabled', false).attr('aria-disabled', 'false');
    } else {
      $placeholder.show();
      $previewText.hide().text('');
      $addBtn.prop('disabled', true).attr('aria-disabled', 'true');
    }
    ttSyncPreview();
  });
  
  // Prevent Enter key from causing 404 or page navigation inside the text panel
  $(document).on('keydown', '#tt-text-input', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Trigger "Add to design" if text is present
      var val = $(this).val().trim();
      if (val) $('#tt-add-to-design-btn').trigger('click');
    }
  });
  
  // ── Font pill click ── //
  $(document).on('click', '.tt-font-pill', function () {
    var $pill = $(this);
  
    // Update active state
    $('.tt-font-pill').removeClass('active').attr('aria-pressed', 'false');
    $pill.addClass('active').attr('aria-pressed', 'true');
  
    // Dynamically load Google Font if provided and not yet loaded
    var fontUrl = $pill.data('font-url');
    if (fontUrl) ttLoadGoogleFont(fontUrl);
  
    // Sync preview
    ttSyncPreview();
  });
  
  // ── Style pill click (toggle B / I / U) ── //
  $(document).on('click', '.tt-style-pill', function () {
    var $pill  = $(this);
    var style  = $pill.data('style');
    var isNowActive = !$pill.hasClass('active');
  
    $pill.toggleClass('active').attr('aria-pressed', isNowActive ? 'true' : 'false');
  
    if      (style === 'bold')      _ttTextBold      = isNowActive;
    else if (style === 'italic')    _ttTextItalic    = isNowActive;
    else if (style === 'underline') _ttTextUnderline = isNowActive;
  
    ttSyncPreview();
  });
  
  // ── "Add to design" button click — create fabric.IText and add to canvas ── //
  $(document).on('click', '#tt-add-to-design-btn', function () {
    var userText = $('#tt-text-input').val().trim();
    if (!userText) return;
  
    var selectedFont = ttGetSelectedFont();
  
    // Center text on canvas
    var _cx = canvas.getWidth()  / 2;
    var _cy = canvas.getHeight() / 2;
  
    var text = new fabric.IText(userText, {
      left:       _cx,
      top:        _cy,
      originX:    'center',
      originY:    'center',
      fontFamily: selectedFont,
      fontSize:   28,
      fill:       'black',
      fontWeight: _ttTextBold      ? 'bold'   : 'normal',
      fontStyle:  _ttTextItalic    ? 'italic' : 'normal',
      underline:  _ttTextUnderline,
      erasable:   false,
    });
  
    text.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false, mtr: true });
  
    $(".main-secrion .canvas-container").addClass("for-margin");
    $(".my_editor#design").hide();
    $(".my_editor#text").fadeIn();
  
    canvas.add(text);
    canvas.setActiveObject(text);
    canvas.requestRenderAll();
    set1Objects.push(text.toJSON());
  
    if (typeof showtoolbardynamic === 'function') showtoolbardynamic();
  
    // On mobile, close the drawer after adding
    if ($(window).width() < 749) {
      $("span.btn_close").trigger('click');
      $(".my_editor.for_text").fadeIn();
    }
  
    // Reset input + preview
    $('#tt-text-input').val('');
    $('#tt-text-preview-text').hide().text('');
    $('#tt-text-preview-placeholder').show();
    $('#tt-add-to-design-btn').prop('disabled', true).attr('aria-disabled', 'true');
  });
  /* ── End text panel handlers ── */
  
  $(document).on("click", ".fonts_load span", function () {
    var class_exsist = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all"
    ).hasClass("active-new");
    $(".main-secrion .canvas-container").addClass("for-margin");
    $(".my_editor#design").hide();
    $(".my_editor#text").fadeIn();
    var selectedFont = $(this).attr("value");
  
    var activeObject = canvas.getActiveObject();
  
    if (activeObject && activeObject.type === "i-text") {
      activeObject.set("fontFamily", selectedFont);
      canvas.requestRenderAll();
    } else {
      if (class_exsist == true) {
        var canvas_object_height = $(
          "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new"
        ).attr("obj_height");
        var text = new fabric.IText(selectedFont, {
          left: 30,
          top: 100,
          fontFamily: selectedFont,
          fontSize: 18,
          fill: "black",
          erasable: false,
        });
      } else {
        var text = new fabric.IText(selectedFont, {
          left: 300,
          top: 340,
          fontFamily: selectedFont,
          fontSize: 24,
          fill: "black",
          erasable: false,
        });
      }
  
      text.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        mtr: true,
      });
  
      canvas.add(text);
      canvas.setActiveObject(text);
      set1Objects.push(text.toJSON()); // Save image data
    }
  });
  
  document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById("imageInput");
  
    // Tracks the last uploaded image ID so "Choose another" can remove it
    var _lastUploadFabricId = null;
  
    // ── Render recent-uploads gallery from localStorage on load ── //
    ttRenderUploadGallery();
  
    // ── Shared upload handler: DPI check + fabric upload ── //
    function handleUploadFile(file) {
      if (!file) return;
      $('.up_loder').show();
  
      // Inline DPI / resolution check via natural image dimensions
      var _objUrl = URL.createObjectURL(file);
      var _checkImg = new Image();
      _checkImg.onload = function () {
        URL.revokeObjectURL(_objUrl);
        // Flag images < 600px in any dimension as potentially too low-res for 300 dpi printing
        if (_checkImg.naturalWidth < 600 || _checkImg.naturalHeight < 600) {
          $('#tt-dpi-warning').addClass('tt-dpi-visible');
        } else {
          $('#tt-dpi-warning').removeClass('tt-dpi-visible');
        }
      };
      _checkImg.src = _objUrl;
  
      uploadToFabric(file);
      $('.up_loder').hide();
    }
  
    // Wire all three inputs to the same handler
    ['imageInput', 'tt-camera-input', 'tt-files-input'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('change', function () {
        var file = this.files[0];
        if (file) handleUploadFile(file);
      });
    });
  
    // ── DPI warning: "Use anyway" — keep image, dismiss warning ── //
    $(document).on('click', '#tt-dpi-use-anyway', function () {
      $('#tt-dpi-warning').removeClass('tt-dpi-visible');
    });
  
    // ── DPI warning: "Choose another" — remove image, dismiss, reopen picker ── //
    $(document).on('click', '#tt-dpi-choose-another', function () {
      $('#tt-dpi-warning').removeClass('tt-dpi-visible');
  
      // Remove the last uploaded image from the canvas
      if (_lastUploadFabricId) {
        var objs = canvas.getObjects();
        for (var _i = 0; _i < objs.length; _i++) {
          if (objs[_i].id === _lastUploadFabricId) {
            canvas.remove(objs[_i]);
            break;
          }
        }
        canvas.discardActiveObject();
        canvas.requestRenderAll();
  
        // Remove its thumbnail from the session panel
        $('.uploades_imgs_data [data-id="' + _lastUploadFabricId + '"]').remove();
        $('.uploades_imgs_data_back [data-id="' + _lastUploadFabricId + '"]').remove();
  
        // Remove from localStorage gallery
        ttRemoveUploadFromGallery(_lastUploadFabricId);
        _lastUploadFabricId = null;
  
        ttUpdateYourUploads();
      }
  
      // Re-open the main file picker (user gesture = allowed by browsers)
      var mainInput = document.getElementById('imageInput');
      if (mainInput) {
        mainInput.value = '';
        mainInput.click();
      }
    });
  
    $('.tattoo_popup_dpi .dpi_mg .btn_outr span').click(function(){
      $(".tattoo_popup_dpi").fadeOut();
      $("#shopify-section-instruction-popup").fadeIn();
    });
  
    $('.tattoo_popup_dpi .close_out').click(function(){
      $(".tattoo_popup_dpi").fadeOut();
    });
  
  
    /* ---------------- FABRIC IMAGE UPLOAD ---------------- */
    function uploadToFabric(file) {
  
      $(".main-secrion .canvas-container").addClass("for-margin");
  
      const reader = new FileReader();
  
      reader.onload = function (event) {
  
        const imageUrl = event.target.result;
        const imageUrl2 = event.target.result;
        const containerWidth = 180;
        const containerHeight = 180;
  
        fabric.Image.fromURL(imageUrl, function (fabricImg) {
  
          const aspectRatio = fabricImg.width / fabricImg.height;
  
          if (aspectRatio > containerWidth / containerHeight) {
            fabricImg.scaleToWidth(containerWidth);
          } else {
            fabricImg.scaleToHeight(containerHeight);
          }
  
          if ($(".loop-all.selection_active").attr("id") === "qty-classic") {
            fabricImg.filters.push(new fabric.Image.filters.Grayscale());
            fabricImg.applyFilters();
          }
  
            fabricImg.applyFilters();
  
         var imageDataURL = fabricImg.toDataURL("png");
         var btn_back = $(".cmn.back").hasClass("active");
         var uniqueaddress = new Date().getTime(); // Unique timestamp
         var image__uniqaddress = "UploadedImg_" + uniqueaddress;
  
         if (btn_back == true) {
           $(".uploades_imgs_data_back").append(
             "<div class='updateImg '  data-id='" +
               image__uniqaddress +
               "'><span class='close'>" +
               $vrsvg +
               "</span><img class='clickable_img' src='" +
               imageDataURL +
               "'></div>"
           );
         } else {
           $(".uploades_imgs_data").append(
             "<div class='updateImg'   data-id='" +
               image__uniqaddress +
               "'><span class='close'>" +
               $vrsvg +
               "</span><img data_img='"+imageUrl2+"' class='clickable_img' src='" +
               imageDataURL +
               "'></div>"
           );
           // Save thumbnail to localStorage gallery (last 5 uploads)
           // imageUrl is the original full-res FileReader DataURL; imageDataURL is
           // the 180×180 downscaled thumbnail used only for the chip preview.
           ttSaveUploadToGallery(imageDataURL, image__uniqaddress, imageUrl);
         }
  
         // Show "Your uploads" section once first upload exists
         ttUpdateYourUploads();
  
          // Auto-fit to printable area (85% of canvas) and center
          var _padFactor = 0.85;
          var _maxW = canvas.getWidth() * _padFactor;
          var _maxH = canvas.getHeight() * _padFactor;
          var _imgAr = fabricImg.width / fabricImg.height;
          if (_imgAr > _maxW / _maxH) {
            fabricImg.scaleToWidth(_maxW);
          } else {
            fabricImg.scaleToHeight(_maxH);
          }
          var _sw = fabricImg.getScaledWidth();
          var _sh = fabricImg.getScaledHeight();
  
          fabricImg.set({
            left: (canvas.getWidth() - _sw) / 2,
            top:  (canvas.getHeight() - _sh) / 2,
            hasBorders: false,
            id: image__uniqaddress
          });
          fabricImg.setCoords();
  
          fabricImg.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            mtr: true
          });
  
          canvas.add(fabricImg);
          canvas.setActiveObject(fabricImg);
          canvas.requestRenderAll();
          $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
  
          // Track the last added image for "Choose another" removal
          _lastUploadFabricId = image__uniqaddress;
  
          set1Objects.push(fabricImg.toJSON());
          showtoolbardynamic();
          resetInput();
        });
      };
  
      reader.readAsDataURL(file);
    }
  
    function resetInput() {
      ['imageInput', 'tt-camera-input', 'tt-files-input'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.value = '';
      });
    }
  
  }); // end DOMContentLoaded
  
  /* ──────────────────────────────────────────────────────────────────────────
     Upload Gallery — localStorage helpers (Card 09)
     ─────────────────────────────────────────────────────────────────────────── */
  var TT_GALLERY_KEY = 'tt_upload_gallery';
  var TT_GALLERY_MAX = 5;
  
  /**
   * Save a thumbnail dataUrl to the persistent gallery (front uploads only).
   * Keeps the most-recent TT_GALLERY_MAX entries.
   * @param {string} dataUrl   - 180×180 thumbnail DataURL (display only)
   * @param {string} id        - unique upload id
   * @param {string} [fullSrc] - original full-resolution DataURL for canvas re-add
   */
  function ttSaveUploadToGallery(dataUrl, id, fullSrc) {
    var gallery = [];
    try { gallery = JSON.parse(localStorage.getItem(TT_GALLERY_KEY) || '[]'); } catch (e) {}
    var entry = { id: id, src: dataUrl, ts: Date.now() };
    if (fullSrc) entry.fullSrc = fullSrc;
    gallery.unshift(entry);
    gallery = gallery.slice(0, TT_GALLERY_MAX);
    try {
      localStorage.setItem(TT_GALLERY_KEY, JSON.stringify(gallery));
    } catch (e) {
      // Quota exceeded (full-res images are large) — retry saving thumbnail-only entries
      try {
        var fallback = gallery.map(function (item) { return { id: item.id, src: item.src, ts: item.ts }; });
        localStorage.setItem(TT_GALLERY_KEY, JSON.stringify(fallback));
      } catch (e2) {}
    }
    ttRenderUploadGallery();
  }
  
  /**
   * Remove a single entry from the persistent gallery by id.
   */
  function ttRemoveUploadFromGallery(id) {
    var gallery = [];
    try { gallery = JSON.parse(localStorage.getItem(TT_GALLERY_KEY) || '[]'); } catch (e) {}
    gallery = gallery.filter(function (item) { return item.id !== id; });
    try { localStorage.setItem(TT_GALLERY_KEY, JSON.stringify(gallery)); } catch (e) {}
    ttRenderUploadGallery();
  }
  
  /**
   * Read the gallery from localStorage and render thumbnail chips inside
   * #tt-upload-recent-grid (which lives inside #tt-your-uploads).
   */
  function ttRenderUploadGallery() {
    var gallery = [];
    try { gallery = JSON.parse(localStorage.getItem(TT_GALLERY_KEY) || '[]'); } catch (e) {}
  
    var $grid = $('#tt-upload-recent-grid');
    if (!$grid.length) return;
  
    $grid.empty();
  
    gallery.forEach(function (item) {
      // data-src  = thumbnail (display only)
      // data-full-src = original full-res DataURL used when re-adding to canvas
      var fullAttr = item.fullSrc ? ' data-full-src="' + item.fullSrc + '"' : '';
      $grid.append(
        '<div class="tt-recent-thumb" data-src="' + item.src + '"' + fullAttr + ' data-id="' + item.id + '" title="Re-add to canvas" aria-label="Re-add recent upload">' +
        '<img src="' + item.src + '" alt="Recent upload" loading="lazy">' +
        '</div>'
      );
    });
  
    ttUpdateYourUploads();
  }
  
  /**
   * Show or hide the "Your uploads" section based on whether there is any
   * content (localStorage gallery OR current-session thumbnails).
   */
  function ttUpdateYourUploads() {
    var hasRecent = (function () {
      try { return JSON.parse(localStorage.getItem(TT_GALLERY_KEY) || '[]').length > 0; } catch (e) { return false; }
    })();
    var hasSession = $('.uploades_imgs_data .updateImg').length > 0;
    if (hasRecent || hasSession) {
      $('#tt-your-uploads').show();
    } else {
      $('#tt-your-uploads').hide();
    }
  }
  
  /* Click on a localStorage recent-upload thumbnail → re-add to canvas at full quality */
  $(document).on('click', '.tt-recent-thumb', function () {
    // Prefer full-res original; fall back to thumbnail for old gallery entries
    var src = $(this).data('full-src') || $(this).data('src');
    if (src) addImageToCanvas(src);
  });
  
  
  
  // Capture active object on mousedown so canvas deselection between
  // mousedown and click cannot lose the reference for the overlay button
  var _bgRemovePendingObj = null;
  $(document).on("mousedown", "#tt-bg-remove-btn", function () {
    _bgRemovePendingObj = canvas.getActiveObject();
  });
  
  $(document).on("click", ".btn_bg_click", function () {
    console.log("btn_bg_click");
    const activeObject = canvas.getActiveObject() || _bgRemovePendingObj;
    _bgRemovePendingObj = null;
    if (!activeObject) return;
    $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
  
    // Get the bounding box of the active object
    const boundingBox = activeObject.getBoundingRect();
  
    // Create a temporary canvas
    const tempCanvas = new fabric.Canvas();
  
    // Set the dimensions of the temporary canvas
    tempCanvas.setDimensions({
      width: boundingBox.width,
      height: boundingBox.height,
    });
  
    // Clone the active object to avoid modifying the original object
    const clonedObject = fabric.util.object.clone(activeObject);
  
    // Adjust the position of the cloned object based on the bounding box
    clonedObject.set({
      left: activeObject.left - boundingBox.left,
      top: activeObject.top - boundingBox.top,
    });
  
    // Add the cloned object to the temporary canvas
    tempCanvas.add(clonedObject);
  
    // Get the image data URL from the temporary canvas
    const imageDataURL = tempCanvas.toDataURL({
      format: "png",
      multiplier: window.innerWidth < 750 ? 1 : 4,
      quality: 1, // optional quality setting (0 to 1)
    });
  
    // Release the temporary canvas immediately — keeping it alive leaks a GPU
    // texture + DOM element + Fabric event listeners on every bg-removal call.
    tempCanvas.dispose();
  
    // Convert data URL to binary data
    const binaryData = atob(imageDataURL.split(",")[1]);
  
    // Convert binary data to ArrayBuffer
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }
  
    // Create a Blob from the ArrayBuffer
    const blob = new Blob([arrayBuffer], { type: "image/png" });
  
    // Now you can use the blob as needed
    //console.log("binary" + imageDataURL);
  
    if (activeObject) {
      const activeObjectId = activeObject.id;
      //console.log(activeObjectId);
      if (
        typeof activeObjectId === "string" &&
        activeObjectId.trim().length > 0 &&
        activeObjectId.includes("UploadedImg_")
      ) {
        //const file = activeObject;
        var formData = new FormData();
        formData.append("file", blob, "canvas_image.png");
  
        $(".app-data").remove();
        $.ajax({
          url: "/apps/tattoo/upload.php",
          type: "POST",
          data: formData,
          contentType: false,
          cache: false,
          processData: false,
          success: function (res) {
            $("body").append(
              "<div class='app-data' style='display:none;'>" + res + "</div>"
            );
  
            var bg_img = $(".base_url_final").attr("src");
            if (bg_img) {
              setTimeout(function () {
                $(".bg_done_img img").attr("src", bg_img);
              }, 200);
            }
  
            const containerWidth = 180; // Set your desired container width
            const containerHeight = 180; // Set your desired container height
  
            // Add the image to the canvas with object-fit: contain simulation
            fabric.Image.fromURL(bg_img, function (fabricImg) {
              const imgWidth = fabricImg.width;
              const imgHeight = fabricImg.height;
              const aspectRatio = imgWidth / imgHeight;
  
              if (aspectRatio > containerWidth / containerHeight) {
                fabricImg.scaleToWidth(containerWidth);
              } else {
                fabricImg.scaleToHeight(containerHeight);
              }
  
              var gray_var = $(".loop-all.selection_active").attr("id");
              if (gray_var == "qty-semi-permanent") {
                fabricImg.filters.push(new fabric.Image.filters.Grayscale());
              }
  
              fabricImg.applyFilters();
              var imageDataURL = fabricImg.toDataURL("png");
              if (imageDataURL.startsWith("data:image/png;base64,")) {
                var btn_back = $(".cmn.back").hasClass("active");
                if (btn_back == true) {
                  $(
                    ".uploades_imgs_data_back [data-id='" + activeObjectId + "']"
                  ).html(
                    "<span class='close'>" +
                      $vrsvg +
                      "</span><img class='clickable_img' src='" +
                      imageDataURL +
                      "'>"
                  );
                } else {
                  $(
                    ".uploades_imgs_data [data-id='" + activeObjectId + "']"
                  ).html(
                    "<span class='close'>" +
                      $vrsvg +
                      "</span><img class='clickable_img' src='" +
                      imageDataURL +
                      "'>"
                  );
                }
              }
              var class_exsist = $(
                "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all"
              ).hasClass("active-new");
  
              if (class_exsist == true) {
                var $activeSizeBg = $(
                  "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new"
                );
                var canvas_object_height = parseFloat($activeSizeBg.attr("obj_height")) || 200;
                var desktopCanvasHeightBg = parseFloat($activeSizeBg.find(".loop").attr("height_data")) || canvas.height;
                if (desktopCanvasHeightBg > canvas.height) {
                  canvas_object_height = Math.round(canvas_object_height * (canvas.height / desktopCanvasHeightBg));
                }
                fabricImg
                  .scaleToHeight(canvas.height - canvas_object_height)
                  .set({
                    left: canvas.width / 3,
                    top: canvas.height / 3.3,
                    src: imageDataURL,
                  })
                  .setCoords();
              }
              fabricImg.setControlsVisibility({
                mt: false,
                mb: false,
                ml: false,
                mr: false,
                mtr: true
              });
              canvas.add(fabricImg);
              canvas.setActiveObject(fabricImg);
              canvas.requestRenderAll();
              set1Objects.push(fabricImg.toJSON()); // Save image data
            });
            var has_credits = $(".error_credits").hasClass("error_credit_done");
  
            if (has_credits == true) {
              alert("Api Credits Finished");
            } else {
              var objects = canvas.getObjects();
              var obj = objects.find((obj) => obj.id === activeObjectId);
  
              if (obj) {
                // Remove the object from the canvas
                canvas.remove(obj);
                canvas.renderAll();
              }
            }
          },
          error: function (xhr, status, error) {},
        });
      }
    }
  });
  $(document).on("click", ".removebg", function () {
    var base64String = $(".bg_img_final").attr("src");
    fabric.Image.fromURL(base64String, function (img) {
      // Set image properties if needed
      img.set({
        left: 10,
        top: 10,
        scaleX: 0.5,
        scaleY: 0.5,
      });
  
      img.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        mtr: true
      });
  
      // Add the image to the canvas
      canvas.add(img);
  
      // Render the canvas
      canvas.renderAll();
    });
  });
  $(document).on("click", ".updateImg img", function () {
    var clickedImageUrl = $(this).attr("data_img");
    var updateImg = $(this).closest(".updateImg");
    // Check if an object with the same URL exists on the canvas
    const existingObject = matchAndSelectObject(clickedImageUrl);
  
    if (existingObject) {
      // If a match is found, select the object
      canvas.setActiveObject(existingObject);
    } else {
      // If no match is found, add the image to the canvas
      addImageToCanvas(clickedImageUrl, updateImg.attr("data-id"));
    }
  
    canvas.requestRenderAll();
  });
  
  $(
    ".uploades_imgs_data .updateImg .close, .uploades_imgs_data_back .updateImg .close"
  ).click(function () {
    var close_div = $(this).closest(".updateImg").remove();
  });
  
  // File Upload End
  
  // Button click event to delete selected image
  
  document.getElementById("deleteButton").addEventListener("click", () => {
    const selectedObjects = canvas.getActiveObjects();
  
    // Iterate through selected objects and remove them from the canvas
    selectedObjects.forEach((object) => {
      canvas.remove(object);
    });
    $(".upload_input_wrap input").val("");
    // Clear the selection
    canvas.discardActiveObject();
    canvas.renderAll();
  });
  
  // Button click event to delete selected text
  
  document.getElementById("deleteButtontext").addEventListener("click", () => {
    const selectedObjects = canvas.getActiveObjects();
  
    // Iterate through selected objects and remove them from the canvas
    selectedObjects.forEach((object) => {
      canvas.remove(object);
    });
  
    // Clear the selection
    canvas.discardActiveObject();
    canvas.renderAll();
  });
  
  // Button click event to duplicate selected image
  document.getElementById("duplicateButton").addEventListener("click", () => {
    const selectedObject = canvas.getActiveObject().toObject();
  
    if (selectedObject) {
      fabric.util.enlivenObjects([selectedObject], function (objects) {
        objects.forEach(function (o) {
          o.set("top", o.top + 20);
          o.set("left", o.left + 20);
          if (canvas.getActiveObject().type == "image") {
            var uniqueaddress = new Date().getTime(); // Unique timestamp
            var image__uniqaddress = "UploadedImg_" + uniqueaddress;
            o.id = image__uniqaddress;
          }
          canvas.add(o);
        });
        canvas.renderAll();
      });
    }
  });
  
  // Button click event to flip the selected SVG object horizontally
  document
    .getElementById("flipHorizontalButton")
    .addEventListener("click", () => {
      const selectedObject = canvas.getActiveObject();
  
      if (selectedObject) {
        selectedObject.flipX = !selectedObject.flipX;
        canvas.renderAll();
      }
    });
  
  // Button click event to flip the selected SVG object vertically
  document.getElementById("flipVerticalButton").addEventListener("click", () => {
    const selectedObject = canvas.getActiveObject();
  
    if (selectedObject) {
      selectedObject.flipY = !selectedObject.flipY;
      canvas.renderAll();
    }
  });
  
  // Function to save the current canvas state
  const undoStack = [];
  const redoStack = [];
  
  // Button click event to undo the last action
  document.getElementById("undoButton").addEventListener("click", () => {
    if (undoStack.length > 1) {
      redoStack.push(undoStack.pop()); // Move current state to redo stack
      const prevState = undoStack[undoStack.length - 1];
      canvas.loadFromJSON(prevState, () => {
        canvas.renderAll();
      });
    }
  });
  
  // Button click event to redo the last undone action
  document.getElementById("redoButton").addEventListener("click", () => {
    if (redoStack.length > 0) {
      const nextState = redoStack.pop();
      undoStack.push(nextState); // Move next state to undo stack
      canvas.loadFromJSON(nextState, () => {
        canvas.renderAll();
      });
    }
  });
  // Listen for object selection and save canvas state when an object is selected
  canvas.on("selection:created", saveCanvasState);
  canvas.on("selection:updated", saveCanvasState);
  canvas.on("selection:cleared", saveCanvasState);
  canvas.on("selection:cleared", function () {
    $("#tt-bg-remove-btn").hide();
  });
  
  let isDrawingMode = false;
  let lineThickness = 1; // Default line thickness
  
  // Button click event to toggle drawing mode
  document.getElementById("drawButton").addEventListener("click", () => {
    isDrawingMode = !isDrawingMode;
  
    if (isDrawingMode) {
      // Enable drawing mode
      canvas.isDrawingMode = true;
      canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
      canvas.freeDrawingBrush.color = $("input#color-input").val();
    } else {
      // Disable drawing mode
      canvas.isDrawingMode = false;
      canvas.freeDrawingBrush = null;
    }
    $(".edit_item button").removeClass("active");
  });
  
  // Listen for changes in line thickness select box
  $(document).on("click", "#lineThicknessSelect span", function () {
    var thikval = $(this).attr("value");
    lineThickness = parseInt(thikval);
    canvas.freeDrawingBrush.width = lineThickness;
  });
  
  let isErasingMode = false;
  let eraserSize = 1; // Default eraser size
  
  // Button click event to toggle erasing mode
  document.getElementById("eraseButton").addEventListener("click", () => {
    isErasingMode = !isErasingMode;
  
    if (isErasingMode) {
      canvas.freeDrawingBrush = new fabric.EraserBrush(canvas);
      canvas.isDrawingMode = true;
    } else {
      // Disable erasing mode
      canvas.isDrawingMode = false;
      canvas.freeDrawingBrush = null;
    }
    $(".edit_item button").removeClass("active");
  });
  
  $(document).on("click", "#eraserSizeSelect span", function () {
    var thikval = $(this).attr("value");
    eraserSize = parseInt(thikval);
  
    // Update brush line width for erasing
    canvas.freeDrawingBrush.width = eraserSize;
  });
  
  // Update font size as user adjusts the range input
  document.getElementById("fontSizeRange").addEventListener("input", () => {
    const fontSizeOutput = document.getElementById("fontSizeOutput");
    const selectedObject = canvas.getActiveObject();
    if (selectedObject instanceof fabric.Text) {
      const fontSize = parseInt(event.target.value);
      fontSizeOutput.textContent = fontSize;
      selectedObject.set("fontSize", fontSize);
      canvas.renderAll();
    }
  });
  
  // Toggle active class for style buttons
  
  // Toggle font weight (bold) on button click
  document.getElementById("boldButton").addEventListener("click", () => {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject instanceof fabric.Text) {
      const currentFontWeight = selectedObject.get("fontWeight");
      selectedObject.set(
        "fontWeight",
        currentFontWeight === "bold" ? "normal" : "bold"
      );
      canvas.renderAll();
    }
  });
  
  // Toggle italic style on button click
  document.getElementById("italicButton").addEventListener("click", () => {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject instanceof fabric.Text) {
      const currentFontStyle = selectedObject.get("fontStyle");
      selectedObject.set(
        "fontStyle",
        currentFontStyle === "italic" ? "normal" : "italic"
      );
      canvas.renderAll();
    }
  });
  
  // Toggle underline style on button click
  document.getElementById("underlineButton").addEventListener("click", () => {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject instanceof fabric.Text) {
      const currentUnderline = selectedObject.get("underline");
      selectedObject.set("underline", !currentUnderline);
      canvas.renderAll();
    }
  });
  
  // Toggle text alignment on button click
  document.getElementById("alignLeftButton").addEventListener("click", () => {
    setTextAlignment("left");
  });
  
  document.getElementById("alignCenterButton").addEventListener("click", () => {
    setTextAlignment("center");
  });
  
  document.getElementById("alignRightButton").addEventListener("click", () => {
    setTextAlignment("right");
  });
  
  // Update letter spacing for the selected text object
  document.getElementById("letterSpacingRange").addEventListener("input", () => {
    const letterSpacingOutput = document.getElementById("letterSpacingOutput");
    const selectedObject = canvas.getActiveObject();
  
    if (selectedObject instanceof fabric.Text) {
      const letterSpacingValue = parseFloat(event.target.value);
      letterSpacingOutput.textContent = letterSpacingValue.toFixed(1);
      selectedObject.set("charSpacing", letterSpacingValue);
      canvas.renderAll();
    }
  });
  
  // Update line height for the selected text object
  document.getElementById("lineHeightRange").addEventListener("input", () => {
    const lineHeightOutput = document.getElementById("lineHeightOutput");
    const selectedObject = canvas.getActiveObject();
  
    if (selectedObject instanceof fabric.Text) {
      const lineHeightValue = parseFloat(event.target.value);
      lineHeightOutput.textContent = lineHeightValue.toFixed(1);
      selectedObject.set("lineHeight", lineHeightValue);
      canvas.renderAll();
    }
  });
  
  const colorInput = document.getElementById("color-input");
  const selectedColor = document.getElementById("color-value");
  
  // Update the selected object's fill color when the input changes
  colorInput.addEventListener("input", function () {
    const selectedHexColor = colorInput.value;
    setTextFillColor(selectedHexColor);
    if (canvas.getActiveObject() && canvas.getActiveObject().type === "path") {
      canvas.getActiveObject().set({ fill: selectedHexColor });
      canvas.renderAll();
      selectedColor.textContent = selectedHexColor;
    } else if (
      canvas.getActiveObject() &&
      canvas.getActiveObject().type === "group"
    ) {
      canvas
        .getActiveObject()
        .getObjects()
        .forEach(function (obj) {
          obj.set({ fill: selectedHexColor });
        });
      canvas.renderAll();
      selectedColor.textContent = selectedHexColor;
    }
  });
  
  const colorInputText = document.getElementById("color-input-text");
  const selectedColorText = document.getElementById("color-value-text");
  
  // Update the selected text object's fill color when the input changes
  colorInputText.addEventListener("input", function () {
    const selectedHexColor = colorInputText.value;
    setTextFillColorText(selectedHexColor);
    if (canvas.getActiveObject()) {
      canvas.getActiveObject().set({ fill: selectedHexColor });
      canvas.renderAll();
      selectedColorText.textContent = selectedHexColor;
    }
  });
  
  $(document).on("change", ".edit_font-family select", function () {
    var fonts_val = $(this).find("option:selected").attr("value");
    if (isTextAdded == true) {
    } else {
      addText(fonts_val);
    }
  
    selectedText.set({ fontFamily: fonts_val });
    canvas.renderAll();
  });
  
  const bringToFrontBtn = document.getElementById("bringToFront");
  const sendToBackBtn = document.getElementById("sendToBack");
  const bringForwardBtn = document.getElementById("bringForward");
  const sendBackwardBtn = document.getElementById("sendBackward");
  // Event listeners for the buttons
  bringToFrontBtn.addEventListener("click", function () {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject) {
      canvas.bringToFront(selectedObject);
    }
  });
  
  sendToBackBtn.addEventListener("click", function () {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject) {
      canvas.sendToBack(selectedObject);
    }
  });
  
  bringForwardBtn.addEventListener("click", function () {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject) {
      canvas.bringForward(selectedObject);
    }
  });
  
  sendBackwardBtn.addEventListener("click", function () {
    const selectedObject = canvas.getActiveObject();
    if (selectedObject) {
      canvas.sendBackwards(selectedObject);
    }
  });
  
  $(document).on("change", ".edit_font-family select", function () {
    var fonts_val = $(this).find("option:selected").attr("value");
    if (isTextAdded == true) {
    } else {
      addText(fonts_val);
    }
  
    selectedText.set({ fontFamily: fonts_val });
    canvas.renderAll();
  });
  
  // Button click event to convert base64 to PNG
  $(document).on(
    "click",
    ".mob_new_nav .preview,.header_tattoo  .preview",
    function () {
      setTimeout(function () {
        var class_back_active = $(".front.cmn").hasClass("active");
  
        if (class_back_active == true) {
          refreshTattooPosition();
          $(
            ".cstm_slider, .armband_slider, .face_slider, .sleeves_slider, .tiny_thumbs, .lower_thumbs"
          )[0].slick.refresh();
          $(
            ".custom_thumbs, .armband_thumbs, .face_thumbs, .sleeves_thumbs, .tiny_thumbs, .lower_thumbs"
          )[0].slick.refresh();
  
          $(".popup_preview").fadeIn();
          $(".swatch-container.tshow")[0].click();
          var $activesize = $(
            "div#shopify-section-tattoo_popup .loop-all .loop.active"
          );
  
          var tatto_height = $activesize.attr("data-tatto_height");
          var tatto_width = $activesize.attr("data-tatto_width");
  
          $(".cstm_slides.cstm_slides_sticker").css({
            "height": tatto_height + "%",
            "width": tatto_width + "%"
          });
  
  
  
          var height_data = $activesize.attr("height_data");
          var width_data = $activesize.attr("width_data");
          var converted_width = $activesize.attr("converted_width");
          var converted_height = $activesize.attr("converted_height");
          var base64Image = getResizedImage(
            canvas,
            converted_width,
            converted_height
          );
          var previewW = canvas.getWidth();
          var previewH = canvas.getHeight();
          $(".last-cart_page_inner .cmn.left .base_img").remove();
          $(".cstm_slides_sticker .canvas_img_slider").remove();
          $(".cstm_slides_sticker").append(
            "<img class='canvas_img_slider'   height='' width='' loading='lazy' src='" +
              base64Image +
              "'>"
          );
          $(".last-cart_page_inner .cmn.left").append(
            "<img class='base_img'  loading='lazy' height='" +
              previewH +
              "' width='" +
              previewW +
              "' src='" +
              base64Image +
              "'>"
          );
        } else {
          alert("Only view front design");
        }
      }, 200);
    }
  );
  
  $(".last-cart_page span.close").click(function () {
    $(".last-cart_page").fadeOut();
  });
  
  $("span.close_preview").click(function () {
    $(".tattoo_popup.popup_preview").fadeOut();
  });
  
  $(".tattoo_popup_inner, .login-form-tattoo_container").click(function (e) {
    if (
      $(e.target).closest(
        "#open-production-time-popup, #production-time-modal, .production-time-modal__dialog"
      ).length
    ) {
      return;
    }
    e.stopPropagation();
  });
  
  $(".tattoo_popup:not(.cstm_qty_pop)").click(function (e) {
    if (
      $(e.target).closest(
        "#open-production-time-popup, #production-time-modal, .production-time-modal__dialog"
      ).length
    ) {
      return;
    }
    $(this).parent("div").fadeOut();
  });
  
  $(".login-form-tattoo").click(function () {
    $(this).fadeOut();
    $(this).removeClass("active");
  });
  
  $(".hamburger").on("click", function () {
    $("div#shopify-section-custom-hamburger").toggleClass("active");
    $(".hamburger").toggleClass("open-menu");
    $(".tattoo-custom-drawer").toggleClass("open-drawer");
    $(".wrapper").toggleClass("open-wrapper");
  });
  
  $(document).on("click", "span.add_product_to_cart", function () {
    $(this).addClass("active");
  
    makevariablefor_atc().then(function () {
    console.log('formdata', $formdata);
  
    $.ajax({
      url: "/apps/tattoo/api_fnnew.php",
      type: "POST",
      data: $formdata,
      processData: false,
      contentType: false,
      dataType: "json",
    }).done(function (respond) {
     console.log('product_create Done');
      if (respond.variant_id) {
        var cartItem = {};
  
        // Add quantity and variant_id
        cartItem.quantity = 1;
        cartItem.id = respond.variant_id;
  
        // Check if properties array is not empty
        if (respond.properties && respond.properties.length > 0) {
          // Add properties
  
          var properties = {};
          properties["Quantity"] = respond.quantity;
          respond.properties.forEach((item) => {
            properties[item.name] = item.value;
          });
  
          cartItem.properties = properties;
        }
        // Create a new form and set it to display none
        var $form = $("<form>", {
          style: "display:none;",
          method: "POST",
          action: "/cart/add",
        });
  
        // Add hidden input for quantity
        $form.append(
          $("<input>", {
            type: "hidden",
            name: "quantity",
            value: cartItem.quantity,
          })
        );
  
        // Add hidden input for variant ID
        $form.append(
          $("<input>", {
            type: "hidden",
            name: "id",
            value: cartItem.id,
          })
        );
  
        // If properties exist, add hidden inputs for each property
     if (cartItem.properties) {
    for (var key in cartItem.properties) {
      if (cartItem.properties.hasOwnProperty(key)) {
  
        var value = cartItem.properties[key];
  
  
        if (value === null || value === "" || value === undefined) {
          continue;
        }
  
        $form.append(
          $("<input>", {
            type: "hidden",
            name: "properties[" + key + "]",
            value: value,
          })
        );
      }
    }
  }
  
        // Append the form to the body
        $("body").append($form);
  
        setTimeout(function () {
         $form.submit();
  
  
        }, 500);
      } else {
        $("span.add_product_to_cart").removeClass("active");
        alert("Error adding product to cart.");
      }
    });
    }).catch(function (err) {
      // makevariablefor_atc() rejects (e.g. missing size for SKU) — it already
      // resets the button state and alerts the user, just log for diagnostics.
      console.error("Add to cart aborted:", err);
    }); // end makevariablefor_atc().then()
  });
  
  $(document).on("click", ".checkout_redirect", function () {
    window.location.href = "/cart";
  });
  
  // Event listener for the "Clear Canvas" button
  document.getElementById("clearButton").addEventListener("click", clearCanvas);
  
  // Search Functionality
  $("#filter-search").keyup(function () {
    // Retrieve the input field text and reset the count to zero
    var filter = $(this).val(),
      count = 0;
    var filter_l = $(this).val().length;
    if (filter_l == 0) {
      $(".slid_des_content").removeClass("for-scroll");
    }
    if ($(this).val() == "") {
      $("div#tabs-content .tab-content").hide();
      setTimeout(function () {
        //$("#tabs-nav li:first-child").click();
        $("div#font-family div").show();
      }, 100);
  
      $("#no-count").text("");
      $("#tabs-nav li").show();
  
    } else {
        $("#tabs-nav li").hide();
  
      // Loop through the comment list
      $("div#tabs-content .tab-content, div#font-family div").each(function () {
        // If the list item does not contain the text phrase fade it out
  
        if ($(this).text().search(new RegExp(filter, "i")) < 0) {
          $(this).fadeOut();
  
          // Show the list item if the phrase matches and increase the count by 1
        } else {
          $(this).show();
          $(".slid_des_content").addClass("for-scroll");
  
          count++;
        }
      });
  
      // Update the count
      var numberItems = count;
      $("#filter-count").text("Number of Comments = " + count);
      if (count < 1) {
        $("#no-count").text("No result");
      } else {
        $("#no-count").text("");
      }
    }
  });
  
  canvas.on("mouse:up", function (options) {
    if ($(window).width() < 749) {
      $(".tatoo_nav.small-hide >ul").hide();
    }
    if (options.target) {
      if (options.target.type === "i-text") {
        $("span.edit_item.edit_color").show();
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
        if ($(".canvas-container").hasClass("for-margin")) {
        } else {
          $(".main-secrion .canvas-container").addClass("for-margin");
        }
  
        // Handle the click event for a text object
        $(".my_editor.for_text").show();
  
        $(".my_editor.for_img").hide();
        // Open the text section or perform a text-related action
      } else if (options.target.type === "path") {
        $("span.edit_item.edit_color").show();
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").hide();
        if ($(".canvas-container").hasClass("for-margin")) {
        } else {
          $(".main-secrion .canvas-container").addClass("for-margin");
        }
  
        // Handle the click event for an SVG object
        $(".my_editor.for_img").show();
        $(".my_editor.for_text").hide();
        // Open the SVG section or perform an SVG-related action
      } else if (options.target.type === "image") {
        $("span.edit_item.edit_bgremove, #tt-bg-remove-btn").show();
        $("span.edit_item.edit_color").hide();
        if ($(".canvas-container").hasClass("for-margin")) {
        } else {
          $(".main-secrion .canvas-container").addClass("for-margin");
        }
  
        // Handle the click event for an SVG object
        $(".my_editor.for_img").show();
        $(".my_editor.for_text").hide();
        // Open the SVG section or perform an SVG-related action
      }
    }
    $(".drop_down").hide();
    $("span.edit_item.edit_front_back").removeClass("arrows");
    $(".sub-menu-drop").removeClass("active");
  });
  $("div#font-family span, #font-family-select option").each(function () {
    var fontFamily = $(this).attr("value");
    $(this).css("font-family", fontFamily);
  });
  $("button#flipVerticalButton, button#flipHorizontalButton").click(function () {
    $(this).toggleClass("active");
  });
  
  // Function to save canvas data to local storage 6x6inches
  const canvasDataDiv = document.getElementById("canvasDataContainer");
  let allCanvasDataf = [];
  
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  // Function to save canvas data to local storage 4x6inches
  
  const canvasDataDivSmall = document.getElementById("canvasDataContainerSmall");
  let allCanvasDatafSmall = [];
  
  // Function to save canvas data to local storage landscape
  
  const canvasDataDivlandscape = document.getElementById(
    "canvasDataContainerlandscap"
  );
  
  // Function to save canvas data to local storage potrait
  
  const canvasDataDivpotrait = document.getElementById(
    "canvasDataContainerPotrait"
  );
  let allCanvasDatafpotrait = [];
  
  loadCanvasNext6x6();
  loadCanvasNext4x6();
  loadCanvasNextLands();
  loadCanvasNextPotraits();
  setTimeout(function () {
    loadCanvasNextNext6x6();
    loadCanvasNextNext4x6();
    loadCanvasNextNextLands();
    loadCanvasNextNextPotraits();
  }, 300);
  
  var clss_exist_saved = $(".save_after_login").hasClass("saved");
  if (clss_exist_saved == true) {
    // Add an event listener to the "Save" button
    $(document).on("click", ".save_after_login", function () {
      if (canvas.getObjects().length > 0) {
        var size_varinats = $(
          "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new .loop"
        ).attr("size_varinats");
        if (size_varinats == "6.0 x 6.0") {
          saveCanvas6x6();
          loadCanvas6x6();
        } else if (size_varinats == "4.0 x 6.0") {
          saveCanvas4x6();
          loadCanvas4x6();
        } else if (
          size_varinats == "1.5 x 2.0" ||
          size_varinats == "1.5 x 3.0" ||
          size_varinats == "2.0 x 3.0" ||
          size_varinats == "2.0 x 4.0"
        ) {
          saveCanvasLands();
          loadCanvasLands();
        } else if (
          size_varinats == "1.5 x 1.5" ||
          size_varinats == "2.0 x 2.0" ||
          size_varinats == "3.0 x 3.0" ||
          size_varinats == "4.0 x 4.0"
        ) {
          saveCanvasPotraits();
          loadCanvasPotraits();
        }
  
        $(".popup_previous_data").addClass("active");
      } else {
        alert("Canvas is blank");
      }
    });
  }
  $(".designs_tatoo_designs span").click(function () {
    var ids = $(this).attr("data-id");
    $(".designs_tatoo_designs span").removeClass("active_layout");
    $(this).addClass("active_layout");
    $(".popup_previous_data .designs_tatoo .cmn").hide();
    $(".popup_previous_data .designs_tatoo .cmn[data-id=" + ids + "]").show();
  });
  
  $(document).on("click", ".popup_previous_data.active .loop-svg", function () {
    canvas.clear();
    var active_canvas_save = $(".designs_tatoo_designs .active_layout").attr(
      "data-canvas-size"
    );
    $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .loop-all"
    ).removeClass("active-new");
    $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .loop-all .loop[size_varinats='" +
        active_canvas_save +
        "']"
    )
      .closest(".loop-all")
      .addClass("active-new");
    $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .loop-all.active-new .loop"
    ).click();
    $("div#shopify-section-tattoo_popup_selection").hide();
  
    var svgEl = $(this).find("svg")[0];
    var serializer = new XMLSerializer();
    var svgStr = serializer.serializeToString(svgEl);
  
    var path = fabric.loadSVGFromString(svgStr, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      obj.set({ flipX: false, flipY: false });
  
      canvas.add(obj);
      canvas.setActiveObject(obj);
      $(".btn_disgard").click();
      canvas.renderAll();
    });
  
    $(".popup_previous_data").fadeOut();
    $(".popup_previous_data").removeClass("active");
  });
  
  $(document).on("click", ".add-cart-save", function () {
    $(".header-right span.add_to_cart").click();
  });
  $(".popup_previous_data span.crose_design").click(function () {
    $(".popup_previous_data").removeClass("active");
    $(".popup_previous_data").fadeOut();
    var get_size = localStorage.getItem("PageLoadSize");
    if (get_size == "6.0 x 6.0") {
      $(".data-chk").removeClass("active_layout");
      $(".large_design").addClass("active_layout");
      var active_clas = $(".data-chk.active_layout").attr("data-id");
      $(".designs_tatoo .cmn").hide();
      $('.designs_tatoo .cmn[data-id="' + active_clas + '"]').show();
    } else if (get_size == "4.0 x 6.0") {
      $(".data-chk").removeClass("active_layout");
      $(".small_design").addClass("active_layout");
      var active_clas = $(".data-chk.active_layout").attr("data-id");
      $(".designs_tatoo .cmn").hide();
      $('.designs_tatoo .cmn[data-id="' + active_clas + '"]').show();
    } else if (
      get_size == "1.5 x 2.0" ||
      get_size == "1.5 x 3.0" ||
      get_size == "2.0 x 3.0" ||
      get_size == "2.0 x 4.0"
    ) {
      $(".data-chk").removeClass("active_layout");
      $(".lands_design ").addClass("active_layout");
      var active_clas = $(".data-chk.active_layout").attr("data-id");
      $(".designs_tatoo .cmn").hide();
      $('.designs_tatoo .cmn[data-id="' + active_clas + '"]').show();
    } else if (
      size_varinats == "1.5 x 1.5" ||
      size_varinats == "2.0 x 2.0" ||
      size_varinats == "3.0 x 3.0" ||
      size_varinats == "4.0 x 4.0"
    ) {
      $(".data-chk").removeClass("active_layout");
      $(".potrait_design ").addClass("active_layout");
      var active_clas = $(".data-chk.active_layout").attr("data-id");
      $(".designs_tatoo .cmn").hide();
      $('.designs_tatoo .cmn[data-id="' + active_clas + '"]').show();
    }
  });
  
  $(document).on(
    "click",
    "div#shopify-section-tatoo_design_left_sidebar .sidebar_Content_row div#tatoosaved",
    function () {
      var clss_exsit = $(".save_after_login").hasClass("saved");
      if (clss_exsit) {
        $("div#design").click();
        $(".popup_previous_data").addClass("active");
      }
    }
  );
  
  // Call the function for each tab when needed (e.g., on scroll or button click)
  $(document).ready(function () {
    var designtabs = $(
      "#shopify-section-slide_drower .slid_des_content [id^=tab]"
    ); // Select all tabs
  
    designtabs.each(function () {
      var tabIndex = $(this).attr("id").replace("tab", ""); // Get tab index from the id
  
      // Example trigger: load more images when the user scrolls near the bottom of the page
      $(window).scroll(function () {
        if (
          $(window).scrollTop() + $(window).height() >=
          $(document).height() - 100
        ) {
          loadMoreImages(tabIndex); // Load more images for the current tab
        }
      });
      loadMoreImages(tabIndex);
      // Optionally, add manual load more buttons if required
      $("#loadMoreButton" + tabIndex).on("click", function () {
        loadMoreImages(tabIndex);
      });
    });
  });
  
  // Load More Images End
  var dynamic_loads_fonts = $(".dynamic_loads_fonts").attr("data_fonts");
  var imagesPerPage5 = 50; // Number of images to load per request
  function loadMoreText() {
    isLoading = true;
    // Simulate an AJAX request (replace this with your actual server request)
    setTimeout(function () {
      for (var i = 1; i <= imagesPerPage5; i++) {
        var dataget1 = $(".fonts_load.static_fonts div:first-child").html();
        var valget1 = $(".fonts_load.static_fonts div:first-child").text();
        if (valget1) {
          var $imageSet = $(
            '<div class="fnt_item" value="' +
              valget1 +
              '" ></div>'
          );
          $imageSet.append(dataget1);
          $(".dynamic_loads_fonts").append($imageSet);
          $(".fonts_load.static_fonts div:first-child").remove();
        }
      }
  
      isLoading = false;
    }, 1000); // Simulating a delay for demonstration purposes
  }
  
  $(".dynamic_loads_fonts").scroll(function () {
    var sidebarContent = $(".dynamic_loads_fonts");
    if (
      sidebarContent.scrollTop() + sidebarContent.innerHeight() >=
        sidebarContent[0].scrollHeight - 100 &&
      !isLoading
    ) {
      loadMoreText();
    }
  });
  loadMoreText();
  
  $(".custom_login_submit button").click(function () {
    var email_val =
      $(".customer-form input#input-main-login--customeremail").val() != "";
    var pswd_val =
      $(".customer-form input#input-main-login--customerpassword").val() != "";
  
    if (email_val == true && pswd_val == true) {
      $(".login-form-tattoo.active .login-form-tattoo_container button").trigger(
        "click"
      );
    }
  });
  
  if ($(window).width() < 749) {
    $(document).on(
      "click",
      ".svg_item, div#font-family span, .updateImg",
      function () {
        $("span.btn_close").click();
        $(".my_editor").css("transition", "none");
      }
    );
    $(document).on("click", ".svg_item", function () {
      $(".my_editor.for_img").fadeIn();
    });
    $(document).on("click", "div#font-family span", function () {
      $(".my_editor.for_text").fadeIn();
    });
  }
  
  var currentSetIndex = 0;
  
  $(document).on("click", ".div_custom_front_back .back", function () {
    setTimeout(function () {
      var canvasObjects = canvas.getObjects();
  
      var $imageContainer = $(".uploades_imgs_data_back");
      var $images = $imageContainer.find("img.clickable_img");
  
      for (var i = 0; i < canvasObjects.length; i++) {
        if (canvasObjects[i].type === "image") {
          // Compare images based on source URL
          var imageUrl = canvasObjects[i].src;
          $images.eq(i).attr("src", imageUrl);
        }
      }
    }, 300);
  
    // clearCanvas();
    $(".uploades_imgs_data_back").css("display", "flex");
    $(".uploades_imgs_data").hide();
    var imageData = canvas.toDataURL("image/png");
  
    // Store the image data in localStorage — wrapped in try/catch so a full
    // storage quota or incognito block silently skips the save instead of crashing.
    try {
      localStorage.setItem("canvasImageData", imageData);
    } catch (e) {
      // Storage unavailable (incognito or quota exceeded) — in-memory state still intact
    }
  
    var storedImageData = localStorage.getItem("canvasImageData") || imageData;
    $(".front_tatt").remove();
    $("body").append(
      "<div class='front_tatt' style='display:none;'><img   height='' width='' loading='lazy' src=" +
        storedImageData +
        "></div>"
    );
  
    storeCurrentSet();
  
    // Toggle between sets
    currentSetIndex = 1 - currentSetIndex;
  
    // Restore the current set of objects
    restoreStoredData();
  
    /* Sync active state — skip visual update when called from resizeCanvasv2()
       to prevent the button pills flickering to "Back" on page load. */
    if (!_resizingCanvas) {
      $(".div_custom_front_back .front").removeClass("active");
      $(".div_custom_front_back .back").addClass("active");
    }
    _syncCanvasBadges(false);
    $(".static_contenet_back").remove();
    var canvas_cls = $(".canvas-container").hasClass("for-margin");
    if (canvas_cls == true) {
      $(".static_contenet_back").addClass("for-margin-bottom");
    } else {
      $(".static_contenet_back").removeClass("for-margin-bottom");
    }
  });
  
  $(document).on("click", ".div_custom_front_back .front", function () {
    setTimeout(function () {
      var canvasObjects = canvas.getObjects();
  
      var $imageContainer = $(".uploades_imgs_data");
      var $images = $imageContainer.find("img.clickable_img");
  
      for (var i = 0; i < canvasObjects.length; i++) {
        if (canvasObjects[i].type === "image") {
          // Compare images based on source URL
          var imageUrl = canvasObjects[i].src;
          $images.eq(i).attr("src", imageUrl);
        }
      }
    }, 300);
    $(".uploades_imgs_data_back").hide();
    $(".uploades_imgs_data").css("display", "flex");
  
    var $activesize = $(
      "div#shopify-section-tattoo_popup .loop-all .loop.active"
    );
    var height_data = $activesize.attr("height_data");
    var width_data = $activesize.attr("width_data");
    var converted_width = $activesize.attr("converted_width");
    var converted_height = $activesize.attr("converted_height");
    var imageData = getResizedImage(canvas, converted_width, converted_height);
  
    // Wrapped in try/catch — incognito mode has near-zero quota and will throw
    // without this guard, crashing the tab silently.
    try {
      localStorage.setItem("canvasImageData1", imageData);
    } catch (e) {
      // Storage unavailable — in-memory set1Objects state is preserved
    }
  
    $(".back_tatt").remove();
    $("body").append(
      "<div class='back_tatt' style='display:none;'><img   height='' width='' loading='lazy' data-elm=" +
        canvas.getObjects().length +
        " src=" +
        imageData +
        "></div>"
    );
    storeCurrentSet();
  
    // Toggle between sets
    currentSetIndex = 1 - currentSetIndex;
  
    // Restore the current set of objects
    restoreStoredData();
  
    $(".canvas-container").removeClass("height_adjust");
    $(".back_tatoo").removeAttr("value");
    $(".static_contenet_back").remove();
    /* Sync active state across all .div_custom_front_back instances (canvas + header) */
    $(".div_custom_front_back .back").removeClass("active");
    $(".div_custom_front_back .front").addClass("active");
    _syncCanvasBadges(true);
  });
  
  /* ── Canvas-area printable-area badge sync ─────────────────────────────────
     Shows "Front · printable area" or "Back · printable area" above the canvas
     depending on which side is currently active.
     isFront = true  → Front badge visible, Back badge hidden
     isFront = false → Back badge visible,  Front badge hidden          ────── */
  function _syncCanvasBadges(isFront) {
    var front = document.querySelector('.wf-badge-wrap--front');
    var back  = document.querySelector('.wf-badge-wrap--back');
    if (front) { if (isFront)  front.removeAttribute('hidden'); else front.setAttribute('hidden', ''); }
    if (back)  { if (!isFront) back.removeAttribute('hidden');  else back.setAttribute('hidden', '');  }
  }
  
  // Add a click event listener to the trigger image
  $(".template_back .imgs").on("click", function () {
    var class_exsist = $(
      "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all"
    ).hasClass("active-new");
  
    var svgEl = $(this).find("svg")[0];
    var serializer = new XMLSerializer();
    var svgStr = serializer.serializeToString(svgEl);
  
    var path = fabric.loadSVGFromString(svgStr, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      obj.set({ flipX: false, flipY: false });
      if (class_exsist == true) {
        var $activeSizeSvg2 = $(
          "div#shopify-section-tattoo_popup .tattoo_popup_inner .inner_Content .loop-all.active-new"
        );
        var canvas_object_height = parseFloat($activeSizeSvg2.attr("obj_height")) || 200;
        var desktopCanvasHeightSvg2 = parseFloat($activeSizeSvg2.find(".loop").attr("height_data")) || canvas.height;
        if (desktopCanvasHeightSvg2 > canvas.height) {
          canvas_object_height = Math.round(canvas_object_height * (canvas.height / desktopCanvasHeightSvg2));
        }
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 8.1, top: canvas.height / 3.3 })
          .setCoords();
      } else {
        var canvas_object_height = 200;
        obj
          .scaleToHeight(canvas.height - canvas_object_height)
          .set({ left: canvas.width / 8.1, top: canvas.height / 3.3 })
          .setCoords();
      }
      canvas.add(obj).renderAll();
      canvas.setActiveObject(obj);
  
      set1Objects.push(obj.toJSON()); // Save image data
      set2Objects.push(obj.toJSON()); // Save image data
    });
    $(".my_editor#design").fadeIn();
    $(".my_editor#text").fadeOut();
    $(".main-secrion .canvas-container").addClass("for-margin");
  });
  
  $(".inenr_tearm input").click(function () {
    if ($(this).is(":checked")) {
      $(".tearms_txt").removeClass("active");
      setTimeout(function () {
        var class_back_active = $(".front.cmn").hasClass("active");
  
        if (class_back_active == true) {
          //     var base64Image = canvas.toDataURL("png");
          var $activesize = $(
            "div#shopify-section-tattoo_popup .loop-all .loop.active"
          );
          var height_data = $activesize.attr("height_data");
          var width_data = $activesize.attr("width_data");
          var converted_width = $activesize.attr("converted_width");
          var converted_height = $activesize.attr("converted_height");
          var base64Image = getResizedImage(
            canvas,
            converted_width,
            converted_height
          );
          var previewW = canvas.getWidth();
          var previewH = canvas.getHeight();
  
          $(".last-cart_page_inner .cmn.left .base_img").remove();
          $(".last-cart_page_inner .cmn.left").append(
            "<img  loading='lazy'class='base_img' height='" +
              previewH +
              "' width='" +
              previewW +
              "' src='" +
              base64Image +
              "'>"
          );
          // Check if the canvas has objects
          if (canvas.getObjects().length > 0) {
            $(".cart-popup-empty").fadeOut();
            $(".last-cart_page").fadeIn();
            makevariablefor_atc();
          } else {
            $(".cart-popup-empty").fadeIn();
            $(".last-cart_page").fadeOut();
          }
        } else {
          alert("Front selection required for cart addition.");
        }
      }, 300);
    } else {
      alert("Checkbox Is not checked");
    }
  });
  $(".tearms_txt .inenr_tearm .close_div, .tearms_txt").click(function () {
    $(".tearms_txt").removeClass("active");
    // $('.front.cmn').trigger('click');
  });
  
  $(".inenr_tearm").click(function (e) {
    e.stopPropagation();
  });
  
  /***************************************************/
  /************* by default selections  ***START***********/
  /***************************************************/
  var canvasData = localStorage.getItem("canvasData");
  var canvasDataSmall = localStorage.getItem("canvasDataSmall");
  var canvasDatalandscape = localStorage.getItem("canvasDatalandscape");
  var canvasDatapotrait = localStorage.getItem("canvasDatapotrait");
  var savedsize = localStorage.getItem("PageLoadSize");
  var PageLoadTechnology = localStorage.getItem("PageLoadTechnology");
  var PageLoadOption = localStorage.getItem("PageLoadOption");
  var PageLoadQuantity = localStorage.getItem("PageLoadQuantity");
  var PageLoadQuantityId = localStorage.getItem("PageLoadId");
  var defaultsel = false;
  $nopopup = true;
  
  if (savedsize !== null) {
    var $thsfirstsize = $(
      "div#shopify-section-tattoo_popup .tattoo_popup .loop[size_varinats='" +
        savedsize +
        "']"
    );
  } else {
    var $thsfirstsize = $(
      "div#shopify-section-tattoo_popup .loop-all:last .loop"
    );
  }
  
  var height_data = $thsfirstsize.attr("height_data");
  var width_data = $thsfirstsize.attr("width_data");
  const obj_height = $thsfirstsize.attr("obj_height");
  var defaultEditingDims = getEditingCanvasDims(width_data, height_data);
  var newWidth = defaultEditingDims.width;
  var newHeight = defaultEditingDims.height;
  resizeCanvas(newWidth, newHeight, obj_height);
  addclass_aaccdingto_size_variants($thsfirstsize.attr("size_varinats"));
  
  
  
  let sizeIndex = parseInt(getUrlParam('size'), 10);
  let defaultSizeset = false;
  
  
  
  
  $(window).on("load", function () {
  
  if (!isNaN(sizeIndex)) {
    sizeIndex=sizeIndex-1;
      // Select all valid .loop-all elements (excluding .slick-cloned)
      let targetElement = $('#shopify-section-tattoo_popup .tattoo_popup .loop-all:not(.slick-cloned):eq('+sizeIndex+') .loop');
  
  
      if (targetElement.length != 0) {
        defaultSizeset=true;
  
          targetElement.trigger("click");
          // Perform any action on the target element here
      }
  }
    if (
      savedsize !== null ||
      PageLoadTechnology !== null ||
      PageLoadOption !== null ||
      PageLoadQuantity !== null ||
      PageLoadQuantityId !== null
    ) {
      setTimeout(function () {
        /**********default show size***********/
        var qty_attr = $(
          ".tattoo_popup.popup_selection .loop-all.selection_active"
        ).attr("id");
        if (
          qty_attr == "qty-gliter" ||
          qty_attr == "qty-metalic" ||
          qty_attr == "qty-glow"
        ) {
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").hide();
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").hide();
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").hide();
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(2)").addClass(
            "not-show"
          );
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(1)").addClass(
            "not-show"
          );
          $("div#shopify-section-tattoo_popup .loop-all:nth-child(3)").addClass(
            "not-show"
          );
        } else {
          $("div#shopify-section-tattoo_popup .loop-all").show();
          $("div#shopify-section-tattoo_popup .loop-all").removeClass("not-show");
        }
        /**********default show size***********/
      }, 400);
  
      setTimeout(function () {
        if (typeof savedsize !== "undefined" && savedsize !== null && !defaultSizeset) {
          $(
            "div#shopify-section-tattoo_popup .tattoo_popup .loop[size_varinats='" +
              savedsize +
              "']"
          ).click();
          //alert(1);
        } else {
  
          if (!defaultSizeset) {
             //alert(2);
            $(
              "div#shopify-section-tattoo_popup .tattoo_popup .loop-all:not(.slick-cloned):eq(0) .loop"
            ).click();
          }
        }
  
        var data_loop = $("div#shopify-section-tattoo_popup .loop-all").hasClass(
          "active-new"
        );
  
        if (data_loop == true && !defaultSizeset) {
        // alert(3);
          $(
            "div#shopify-section-tattoo_popup .loop-all.active-new .loop"
          ).click();
        }
  
        if (
          typeof PageLoadTechnology !== "undefined" &&
          PageLoadTechnology !== null
        ) {
          $(
            "div#shopify-section-tattoo_popup_selection .inner_Content_row .loop-all[custom_product='" +
              PageLoadTechnology +
              "'] .loop"
          ).click();
        } else {
          $(
            "div#shopify-section-tattoo_popup_selection .inner_Content_row .loop-all:eq(0) .loop"
          ).click();
        }
  
        if (typeof PageLoadOption !== "undefined" && PageLoadOption !== null) {
          $(
            "div#shopify-section-tattoo_popup_option .tattoo_popup.popup_option .loop-all[option_data='" +
              PageLoadOption +
              "'] .loop"
          ).click();
        } else {
          $(
            "div#shopify-section-tattoo_popup_option .tattoo_popup.popup_option .loop-all:eq(0) .loop"
          ).click();
        }
  
        $(
          ".loop-all.selection_active[id='" + PageLoadQuantityId + "'] .loop"
        ).click();
      }, 100);
    } else {
      if (!defaultSizeset) {
       // alert(4);
          $("div#shopify-section-tattoo_popup .loop-all:not(.slick-cloned):last .loop").click();
      }
    }
    setTimeout(function () {
      $("div#shopify-section-tattoo_popup").hide();
      $("div#shopify-section-tattoo_popup_selection").hide();
      $("div#shopify-section-quntity-popup").hide();
      $("div#shopify-section-tattoo_popup_option").hide();
      $("div#shopify-section-tattoo_popup_back").hide();
      $nopopup = false;
      /* Wizard open is triggered by the window.load handler in wizard JS
         (runs at 450ms, after this 400ms block, so state is fully settled) */
    }, 400);
  });
  /***************************************************/
  /************* by default selections  ***END***********/
  /***************************************************/
  
  $(document).on("click", "span.edit_item.edit_bringToFront", function () {
    $(".drop_down").hide();
    $(".edit_bringToFront").removeClass("active");
    $(this).addClass("active");
  });
  
  $(".btn_disgard").click(function () {
    var activeObject = canvas.getActiveObject();
    if (activeObject.type == "group") {
      var items = activeObject._objects;
      activeObject._restoreObjectsState();
      canvas.remove(activeObject);
      for (var i = 0; i < items.length; i++) {
        canvas.add(items[i]);
        canvas.item(canvas.size() - 1).hasControls = true;
      }
  
      canvas.renderAll();
    }
  });
  $(document).on("click", "#tabs-content span.content-back-arrow", function () {
    $(this).parents('#tabs-content').find('.tab-content').hide();
    $(this).parents('.tabs').find('ul.slid_des li').show();
    $(this).hide();
  });
  $(document).ready(function () {
    // Make the .movable divs draggable and resizable within their parent .container
    $(".cstm_slides_sticker").draggable({
      containment: "parent",
    });
  
    setInterval(function () {
      $(
        "*[draggable!=true], .custom_thumbs .slick-track, .armband_slider .slick-track, .face_slider .slick-track, .sleeves_slider .slick-track, .tiny_slider .slick-track, .lower_slider .slick-track"
      ).unbind("dragstart");
    }, 500);
  
    $(".checkout_redirect_ctm").on("click", function () {
      var checkoutElement = document.querySelector('[name="checkout"]');
  
      // Check if the element is found
      if (checkoutElement) {
        // Trigger a click event on the element
        checkoutElement.click();
      }
    });
  });
  
  $(document).ready(function () {
    const $dropZone_tatto = $("#dropZone_tatto");
    const $imageInput = $("#imageInput");
  
    $dropZone_tatto.on("dragover", function (event) {
      event.preventDefault();
      $dropZone_tatto.addClass("dragover");
    });
  
    $dropZone_tatto.on("dragleave", function () {
      $dropZone_tatto.removeClass("dragover");
    });
  
    $dropZone_tatto.on("drop", function (event) {
      event.preventDefault();
      $dropZone_tatto.removeClass("dragover");
  
      const files = event.originalEvent.dataTransfer.files;
      if (files.length) {
        $imageInput[0].files = files;
        $imageInput.trigger("change");
      }
    });
  
    $(".backbtn").on("click", function (e) {
      e.preventDefault();
      var backpopup = "#" + $(this).attr("data-back_nowhite");
      if (
        $(".loop-all.selection_active").attr("custom_product") ==
        "copy-of-classic-custom-tattoo"
      ) {
        backpopup = "#" + $(this).attr("data-back");
      }
  
      $(this).closest(".shopify-section").hide();
      $(backpopup).show();
    });
    refreshTattooPosition();
  });
  
  window.onload = function () {
    document.querySelectorAll("img").forEach(function (img) {
      // Get the src attribute of the image
      let src = img.getAttribute("src");
  
      // Extract the image file name from the src
      let imageName = src.split("/").pop().split(".").shift();
  
      // Check if the alt attribute is missing or blank
      if (!img.hasAttribute("alt") || img.getAttribute("alt").trim() === "") {
        // Set the alt attribute to the image name
        img.setAttribute("alt", imageName);
      }
    });
  };
  
  
  // -----------bar_hide_click---------
  $(document).on('click', 'span.bar_hide', function () {
      $('div#shopify-section-tatoo_design_left_sidebar').hide();
      $('.open_drwar_bt').show();
  });
  
  $(document).on('click', '.open_drwar_bt', function () {
      $('div#shopify-section-tatoo_design_left_sidebar').show();
      $('.open_drwar_bt').hide();
  });
  
  /* ================================================================
     TATTOO SETUP WIZARD — Card 0
     All wizard UI logic lives here. Business logic (pricing, canvas
     resize, form attributes) is still owned by the original hidden
     popup-section handlers; we proxy clicks to them.
     ================================================================ */
  /* Record when the wizard JS starts so the init overlay minimum display
     time calculation in the $(window).on('load') callback is accurate. */
  window._ttOverlayShownAt = Date.now();
  
  (function ($) {
    'use strict';
  
    /* ── State ── */
    var ttStep = 0;
    var ttIsClassic = true;   // drives whether White Ink step is visible
    var ttQtyValue = 100;
    var ttWizardCompleted = false; // true after user finishes wizard once (enables edit-mode reset)
    var ttCartEditMode = false;   // true when wizard was opened from the cart review popup Edit buttons
    /* Tracks the wizard-selected var_label when the hidden popup has no matching .loop element.
       Window-scoped so the qty_selected_row.change handler (outside this IIFE) can read it. */
    window._ttWizardActiveVarLabel = null;
  
    /* Steps available: indices into the step panel IDs array.
       White ink (index 2) is conditional — only for Classic. */
    var TT_PANEL_IDS = ['#tt-step-effect', '#tt-step-size', '#tt-step-white', '#tt-step-qty'];
  
    /* ── Helpers ── */
  
    /* Read the active effect from the DOM — this is always the ground truth.
       Never rely solely on ttIsClassic variable to determine if white ink
       step is in the flow, because variable state can drift from DOM state. */
    function ttEffectIsClassic() {
      var $active = $('.tt-effect-card--active');
      /* If the wizard has a selected effect card, use its data attribute */
      if ($active.length) {
        return $active.data('eff-id') === 'qty-classic';
      }
      /* Fallback: check the hidden original section for the selection_active class */
      var origId = $('div#shopify-section-tattoo_popup_selection .loop-all.selection_active').attr('id');
      if (origId) {
        return origId === 'qty-classic';
      }
      /* Ultimate fallback: the variable */
      return ttIsClassic;
    }
  
    function ttActivePanels() {
      /* Sync variable from DOM first, then use it */
      ttIsClassic = ttEffectIsClassic();
      return [1, 3];              // Effect (0) and White Ink (2) steps permanently hidden
    }
  
    function ttTotalSteps() { return ttActivePanels().length; }
  
    function ttPanelStepNumber(panelIdx) {
      return ttActivePanels().indexOf(panelIdx) + 1; // 1-based
    }
  
    /* ── Reset helper for Effect edit mode ──
       Called when the wizard re-opens at step 0 after a previous completion.
       Clears all downstream selections so the user must re-choose. */
    function ttResetForEffectEdit() {
      /* Deselect all effect cards — user must re-pick */
      $('.tt-effect-card').removeClass('tt-effect-card--active');
      /* Deselect all size cards */
      $('.tt-size-card').removeClass('tt-size-card--active');
      /* Remove unavailable state — will be re-applied once effect is chosen */
      $('.tt-size-card').removeClass('tt-size-card--unavailable');
      /* Reset white ink to first option */
      $('.tt-white-option').removeClass('tt-white-option--active');
      $('.tt-white-option').first().addClass('tt-white-option--active');
      /* Reset qty display */
      ttQtyValue = 0;
      $('.tt-qty-stepper__val').text('—');
      /* Wipe stored price so footer shows "—" */
      $('form.form_syn').removeAttr('data_price_product');
      ttUpdateWizardPrice();
      /* Clear downstream localStorage keys */
      localStorage.removeItem('PageLoadId');
      localStorage.removeItem('PageLoadSize');
      localStorage.removeItem('PageLoadOption');
      localStorage.removeItem('PageLoadQuantity');
    }
  
    /* ── Open / close ── */
    /* isEditMode: pass true when re-opening from a breadcrumb pill so the Effect
       step resets all downstream state (size/qty/white/price/localStorage).
       The auto-open on page load does NOT pass this flag, so saved state is kept. */
    window.ttOpenWizard = function (panelIdx, isEditMode) {
      /* Effect step is permanently hidden — always default to Size (1) */
      panelIdx = (panelIdx != null && panelIdx !== 0) ? panelIdx : 1;
      /* Use class toggle instead of jQuery show/hide to avoid display cache issues */
      $('#tt-wizard').addClass('tt-wizard--open').css('display', 'block');
      $('body').css('overflow', 'hidden');
      ttShowPanel(panelIdx);
    };
  
    function ttCloseWizard() {
      $('#tt-wizard').removeClass('tt-wizard--open').css('display', 'none');
      $('body').css('overflow', '');
    }
  
    /* ── Show panel ── */
    function ttShowPanel(panelIdx) {
      ttStep = panelIdx;
  
      /* Clear any lingering validation errors when navigating between steps */
      ttClearStepErrors();
  
      /* Hide all panels: remove active class and strip any inline display so
         CSS !important rules take full control */
      $.each(TT_PANEL_IDS, function (i, id) {
        var el = $(id)[0];
        if (el) {
          el.classList.remove('tt-wizard__panel--active');
          el.style.removeProperty('display');
        }
      });
      /* Show target: add active class — CSS .tt-wizard__panel--active { display: block !important }
         will make it visible without any jQuery inline-style interference */
      var targetEl = $(TT_PANEL_IDS[panelIdx])[0];
      if (targetEl) {
        targetEl.classList.add('tt-wizard__panel--active');
        targetEl.style.removeProperty('display');
      }
  
      /* update step-label string */
      var activePanels = ttActivePanels();
      var currentNum   = activePanels.indexOf(panelIdx) + 1;
      var total        = ttTotalSteps();
  
      /* mobile top-bar label + desktop panel label */
      var labelText = 'Step ' + currentNum + ' of ' + total;
      $('.tt-wizard__step-label-mob').text(labelText);
      $(TT_PANEL_IDS[panelIdx] + ' .tt-panel__step-label').text(labelText);
  
      /* mobile back-btn (topbar) — hide on the first active step */
      var isFirstStep = ttActivePanels().indexOf(panelIdx) === 0;
      if (isFirstStep) {
        $('.tt-wizard__back-btn').css('display', 'none');
        $('.tt-wizard__footer-back').css('display', 'none');
      } else {
        $('.tt-wizard__back-btn').removeClass('hidden').css('display', 'flex');
        $('.tt-wizard__footer-back').removeClass('hidden').css('display', 'flex');
      }
  
      /* footer CTA label */
      var isLast = (currentNum === total);
      $('.tt-wizard__footer-next').html(
        isLast
          ? 'Start designing <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : 'Continue <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );
  
      /* progress bar */
      ttUpdateProgress(panelIdx);
  
      /* sidebar nav */
      ttUpdateSidebar(panelIdx);
  
      /* show/hide white-ink step in sidebar and progress bar */
      ttToggleWhiteInkVisibility();
  
      /* if landing on qty step, sync display with current sel_qty value */
      if (panelIdx === 3) {
        ttSyncQtyFromSelect();
      }
  
      /* update footer price */
      ttUpdateWizardPrice();
    }
  
    /* ── Toggle white-ink visibility in sidebar & progress bar ── */
    function ttToggleWhiteInkVisibility() {
      /* White Ink step permanently hidden — always run the hide branch */
      $('.tt-step-nav--conditional').removeClass('tt-step-nav--visible');
      $('.tt-progress__seg[data-seg="2"]').addClass('tt-progress__seg--hidden').hide();
      $('.tt-wizard__step-nav-item[data-step="3"] .tt-step-nav__num').text('2');
    }
  
    /* ── Progress bar ── */
    function ttUpdateProgress(panelIdx) {
      var activePanels = ttActivePanels();
      var currentPos   = activePanels.indexOf(panelIdx); // 0-based position in active set

      /* Update segment colors using data-seg attribute matching so hidden segments
         (Effect=0, White Ink=2) are skipped — mirrors actUpdateProgress logic */
      $.each(activePanels, function (pos, step) {
        var $seg = $('.tt-progress__seg[data-seg="' + step + '"]');
        $seg.removeClass('tt-progress__seg--active tt-progress__seg--done');
        if (pos < currentPos) {
          $seg.addClass('tt-progress__seg--done');
        } else if (pos === currentPos) {
          $seg.addClass('tt-progress__seg--active');
        }
      });

      /* Show/hide conditional segment */
      ttToggleWhiteInkVisibility();
    }
  
    /* ── Sidebar nav ── */
    function ttUpdateSidebar(panelIdx) {
      var activePanels = ttActivePanels();
      var currentPos   = activePanels.indexOf(panelIdx);
  
      $('.tt-wizard__step-nav-item').each(function () {
        var itemStep  = parseInt($(this).data('step'), 10);
        var itemPos   = activePanels.indexOf(itemStep);
        $(this).removeClass('tt-step-nav--active tt-step-nav--done');
  
        if (itemPos < 0) return; // not in active set — leave as-is (hidden via CSS)
        if (itemPos < currentPos) {
          $(this).addClass('tt-step-nav--done');
        } else if (itemPos === currentPos) {
          $(this).addClass('tt-step-nav--active');
        }
      });
    }
  
    /* ── Size availability check ──────────────────────────────────────────────
       Reads the actual variant data rendered by section-main.liquid
       (.variants_data[custom_product='...'] > span[size='...']) for the
       currently active effect and marks any size card whose data-var-label is
       NOT in that product's variant list as unavailable (strikethrough, no click).
       Called after every effect selection and on page-load restore.            */
    function ttUpdateSizeAvailability() {
      var $activeEffect = $('.tt-effect-card--active');
  
      /* No effect selected yet — clear all unavailable states and bail */
      if (!$activeEffect.length) {
        $('.tt-size-card').removeClass('tt-size-card--unavailable');
        return;
      }
  
      var productHandle = $activeEffect.data('product');
      var $variantsData = $('.variants_data[custom_product="' + productHandle + '"]');
  
      /* Variants data not found — show all sizes to avoid blocking the user */
      if (!$variantsData.length) {
        $('.tt-size-card').removeClass('tt-size-card--unavailable');
        return;
      }
  
      /* Build a set of available size labels from the variant spans */
      var availableSizes = [];
      $variantsData.find('span[size]').each(function () {
        var s = $(this).attr('size');
        if (s) availableSizes.push(s);
      });
  
      /* Mark each size card as available or unavailable */
      $('.tt-size-card').each(function () {
        var $card    = $(this);
        var varLabel = $card.data('var-label');
        var available = varLabel && availableSizes.indexOf(varLabel) !== -1;
  
        if (!available) {
          /* Unavailable: show with strikethrough, block interaction, deselect */
          $card.addClass('tt-size-card--unavailable').removeClass('tt-size-card--active');
        } else {
          $card.removeClass('tt-size-card--unavailable');
        }
      });
    }
  
    /* ── Step validation helpers ── */
    function ttShowStepError(panelId, msg) {
      /* Remove any existing error in this panel first */
      $(panelId + ' .tt-step-error').remove();
      var $err = $('<p class="tt-step-error"></p>').text(msg);
      /* Insert after the panel heading so the error appears above the grid */
      var $heading = $(panelId + ' .tt-panel__heading');
      if ($heading.length) {
        $heading.after($err);
      } else {
        $(panelId).prepend($err);
      }
    }
  
    function ttClearStepErrors() {
      $('.tt-step-error').remove();
    }
  
    function ttValidateStep(stepIdx) {
      ttClearStepErrors();
      if (stepIdx === 0) {
        /* Effect step: an effect card must be selected */
        if (!$('.tt-effect-card--active').length) {
          ttShowStepError('#tt-step-effect', 'Please select an effect to continue.');
          return false;
        }
      } else if (stepIdx === 1) {
        /* Size step: a non-unavailable size card must be selected */
        if (!$('.tt-size-card--active').length) {
          ttShowStepError('#tt-step-size', 'Please select a size to continue.');
          return false;
        }
      }
      return true;
    }
  
    /* ── Advance to next step ── */
    function ttNextStep() {
      /* Validate current step before advancing */
      if (!ttValidateStep(ttStep)) return;
  
      var activePanels = ttActivePanels();
      var currentPos   = activePanels.indexOf(ttStep);
      if (currentPos < 0) currentPos = 0;
      if (currentPos < activePanels.length - 1) {
        ttShowPanel(activePanels[currentPos + 1]);
      } else {
        /* Last step — "Start designing" */
        ttFinishWizard();
      }
    }
  
    /* ── Go back one step ── */
    function ttPrevStep() {
      var activePanels = ttActivePanels();
      var currentPos   = activePanels.indexOf(ttStep);
      if (currentPos > 0) {
        ttShowPanel(activePanels[currentPos - 1]);
      }
    }
  
    /* ── Sync all desktop header breadcrumb pills after wizard completes ── */
    function ttSyncHeaderBreadcrumbs() {
      /* Effect */
      var $effCard = $('.tt-effect-card--active');
      if ($effCard.length) {
        var effName = $effCard.find('.tt-effect-card__name').text().trim();
        if (effName) {
          $('.tatoo_nav li.file_tgy').text('Effect: ' + effName);
          $('.tt-tile-effect-val').text(effName);
        }
      }
  
      /* Size */
      var $sizeCard = $('.tt-size-card--active');
      if ($sizeCard.length) {
        var sizeLabel = $sizeCard.find('.tt-size-card__label').text().trim() ||
                        $sizeCard.data('var-label') || '';
        if (sizeLabel) {
          $('li.file_size.size span').text(sizeLabel);
          $('.tt-tile-size-val').text(sizeLabel);
        }
      }
  
      /* White Ink */
      var $whiteOpt = $('.tt-white-option--active');
      if ($whiteOpt.length) {
        var whiteName = $whiteOpt.find('.tt-white-option__name').text().trim() ||
                        $whiteOpt.data('opt-label') || '';
        if (whiteName) {
          $('.file_w_option span').text(whiteName);
          $('.tt-tile-white-val').text(whiteName);
        }
      }
  
      /* Qty */
      var qtyVal = $('.sel_qty option:selected').val() || ttQtyValue;
      if (qtyVal) {
        $('li.file_qty span').text(qtyVal);
        $('.tt-tile-qty-val').text(qtyVal);
      }
  
      /* White Ink pill + edit tile — permanently hidden */
      $('li.file_w_option').hide();
      $('.tt-sheet-tile-item--white-ink').addClass('tt-tile--hidden');
      $('.file--white-ink').addClass('hidden');
    }
  
    /* ── Update cart review popup values after a wizard edit ── */
    function ttUpdateCartReviewValues() {
      var $section = $('#shopify-section-add_cart_tattoo');
      if (!$section.length) return;
  
      /* Size */
      var sizeLabel = $('.tt-size-card--active').data('var-label') || '';
      $section.find('.sel_sizes_data .insert_data__text').text(sizeLabel);
  
      /* Quantity */
      var qty = ttQtyValue || parseInt($('.sel_qty option:selected').val(), 10) || '';
      $section.find('.sel_qty_data .insert_data__text').text(qty + (qty == 1 ? ' Tattoo' : ' Tattoos'));
  
      /* Effect */
      var effName = $('.tt-effect-card--active .tt-effect-card__name').text().trim();
      $section.find('.sel_tattoo_finish_data .insert_data__text').text(effName);
  
      /* White Ink — conditional on Classic */
      if (ttIsClassic) {
        var whiteLabel = $('.tt-white-option--active .tt-white-option__name').text().trim();
        $section.find('.sel_white_data').show();
        $section.find('.sel_white_data .insert_data__text').text(whiteLabel || '—');
      } else {
        $section.find('.sel_white_data').hide();
      }
    }
  
    /* ── Finish wizard (last step CTA) ── */
    function ttFinishWizard() {
      /* Run the qty_nxt logic from the hidden section so price/form attrs
         are final, then close the wizard.                               */
      var form_qty = parseInt($('.sel_qty option:selected').val(), 10) || ttQtyValue;
  
      /* Sync breadcrumbs into header pills before closing */
      ttSyncHeaderBreadcrumbs();
  
      /* Cart-edit mode: wizard was opened from the review popup Edit buttons.
         Just close the wizard and refresh the cart popup values — no two-sided
         popup, no canvas navigation. */
      if (ttCartEditMode) {
        ttCartEditMode = false;
        ttCloseWizard();
        ttUpdateCartReviewValues();
        return;
      }
  
      /* For low-qty orders, directly close */
      if (form_qty <= 50) {
        ttCloseWizard();
        return;
      }
  
      /* qty >= 100: if classic, show two-sided popup AFTER wizard closes */
      ttCloseWizard();
  
      if (ttIsClassic && form_qty >= 100) {
        setTimeout(function () {
          $('div#shopify-section-tattoo_popup_back').removeClass('hide_div').fadeIn();
        }, 280);
      }
  
      /* Mark wizard as completed so re-opening Effect step triggers edit-mode reset */
      ttWizardCompleted = true;
    }
  
    /* ── Price update ── */
    function ttUpdateWizardPrice() {
      var rawPrice = $('form.form_syn').attr('data_price_product');
      var sym = (typeof get_sym !== 'undefined' && get_sym) ? get_sym : '$';
  
      if (!rawPrice || rawPrice === 'undefined') {
        $('.tt-wizard__footer-price-val, .tt-order-total').text('—');
        $('.tt-unit-price').text('—');
        return;
      }
  
      /* data_price_product is already the full order total for the selected
         qty tier (set by the theme's variant-price logic). No multiplication. */
      var price = parseFloat(String(rawPrice).replace(/,/g, '')) || 0;
      var qty   = parseInt($('.sel_qty option:selected').val(), 10) || ttQtyValue;
  
      /* Format with thousands separator and 2 decimal places to match theme */
      function fmtMoney(val) {
        return val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
  
      var unitPrice = qty > 0 ? price / qty : price;
  
      $('.tt-wizard__footer-price-val').text(sym + fmtMoney(price));
      $('.tt-unit-price').text(sym + fmtMoney(unitPrice));
      $('.tt-qty-display').text(qty);
      $('.tt-order-total').text(sym + fmtMoney(price));
    }
  
    /* ── Qty stepper / presets ── */
  
    /* Reads the valid options from the hidden .sel_qty select (rebuilt by
       the existing updateqty_html() on every combination change) and marks
       any preset whose qty is NOT in that list as struck-through / disabled.
       Old JS never touches .tt-qty-preset--unavailable so this is safe. */
    function ttSyncPresetAvailability() {
      var validQtys = $('.sel_qty').find('option').map(function () {
        return parseInt($(this).val(), 10);
      }).get().filter(function (v) { return !isNaN(v); });
  
      $('.tt-qty-preset').each(function () {
        var presetQty = parseInt($(this).data('qty'), 10);
        /* When no options loaded yet, treat all presets as available */
        var unavailable = validQtys.length > 0 && validQtys.indexOf(presetQty) === -1;
        $(this).toggleClass('tt-qty-preset--unavailable', unavailable);
        if (unavailable) {
          $(this).attr('disabled', true);
        } else {
          $(this).removeAttr('disabled');
        }
      });
    }
  
    function ttSetQty(newQty) {
      /* Clamp to valid options in the hidden select */
      var $sel = $('.sel_qty');
      var options = $sel.find('option').map(function () {
        return parseInt($(this).val(), 10);
      }).get().filter(function (v) { return !isNaN(v); });
  
      if (options.length > 0) {
        var closest = options.reduce(function (prev, curr) {
          return (Math.abs(curr - newQty) < Math.abs(prev - newQty)) ? curr : prev;
        });
        newQty = closest;
      }
  
      ttQtyValue = newQty;
      $('.tt-qty-stepper__val').text(newQty);
      $('.tt-qty-display').text(newQty);
  
      /* highlight matching preset */
      $('.tt-qty-preset').each(function () {
        $(this).toggleClass('tt-qty-preset--active', parseInt($(this).data('qty'), 10) === newQty);
      });
  
      /* sync unavailable preset states after clamp */
      ttSyncPresetAvailability();
  
      /* update hidden select & trigger existing change handler */
      $sel.val(newQty).trigger('change');
      setTimeout(ttUpdateWizardPrice, 60);
    }
  
    /* Sync wizard display from current sel_qty value (e.g. after init auto-clicks) */
    function ttSyncQtyFromSelect() {
      var val = parseInt($('.sel_qty option:selected').val(), 10);
      if (!isNaN(val) && val > 0) {
        ttQtyValue = val;
        $('.tt-qty-stepper__val').text(val);
        $('.tt-qty-display').text(val);
        $('.tt-qty-preset').each(function () {
          $(this).toggleClass('tt-qty-preset--active', parseInt($(this).data('qty'), 10) === val);
        });
      }
      /* Reflect which presets are valid for this new combination */
      ttSyncPresetAvailability();
      setTimeout(ttUpdateWizardPrice, 80);
    }
  
    /* ================================================================
       PROXY CLICK HANDLERS
       Clicking wizard cards delegates to the hidden original section
       elements so existing custom.js handlers fire and set all state.
       ================================================================ */
  
    /* Effect card clicked */
    $(document).on('click', '.tt-effect-card', function () {
      var $card   = $(this);
      var effId   = $card.data('eff-id');
      var product = $card.data('product');
      var opval   = $card.data('opval');
      var desc    = $card.data('desc') || '';
      var minTxt  = $card.data('min') || '';
      var prodTime = $card.data('prod-time') || '';
  
      /* Capture previous effect before changing — used to detect an actual change */
      var prevEffId = $('.tt-effect-card--active').data('eff-id');
  
      /* Mark active in wizard */
      $('.tt-effect-card').removeClass('tt-effect-card--active');
      $card.addClass('tt-effect-card--active');
  
      /* If the effect actually changed, reset all downstream selections to prevent
         stale size/qty/price from an incompatible combination. */
      if (prevEffId && prevEffId !== effId) {
        $('.tt-size-card').removeClass('tt-size-card--active');
        $('.tt-white-option').removeClass('tt-white-option--active');
        $('.tt-white-option').first().addClass('tt-white-option--active');
        ttQtyValue = 0;
        $('.tt-qty-stepper__val').text('—');
        $('form.form_syn').removeAttr('data_price_product');
        ttUpdateWizardPrice();
        localStorage.removeItem('PageLoadSize');
        localStorage.removeItem('PageLoadOption');
        localStorage.removeItem('PageLoadQuantity');
      }
  
      /* Determine if Classic for conditional white-ink step */
      ttIsClassic = (effId === 'qty-classic');
      ttToggleWhiteInkVisibility();
  
      /* Immediately update the step labels so "Step 1 of 3/4" reflects the chosen
         effect's total without waiting for the user to click Continue. */
      var _newTotal = ttActivePanels().length;
      $('.tt-wizard__step-label-mob').text('Step 1 of ' + _newTotal);
      $('#tt-step-effect .tt-panel__step-label').text('Step 1 of ' + _newTotal);
  
      /* Proxy click to hidden original section — sets all custom.js state.
         NOTE: do not filter out .slick-cloned nodes here — slick clones slides
         via $.clone(true) (see assets/slick.min.js), which copies the bound
         click handler along with the element, so clones fire this same logic
         correctly. Restricting the selector previously risked zeroing out the
         match set in edge cases and skipping resizeCanvas()/getEditingCanvasDims()
         entirely, which caused the canvas to keep a stale aspect ratio and the
         export to look squished. */
      var $origLoop = $('div#shopify-section-tattoo_popup_selection .loop-all[id="' + effId + '"] .loop');
      if ($origLoop.length) {
        $origLoop.trigger('click');
      }
  
      /* Update size availability based on actual variant data for the chosen effect */
      ttUpdateSizeAvailability();
  
      /* Update inline description panel (class selector covers both wizard + popup clone) */
      if (desc) {
        $('.tt-effect-desc-panel').show();
        var $name = $card.find('.tt-effect-card__name').text();
        $('.tt-effect-desc-panel__name').text($name);
        $('.tt-effect-desc-panel__text').text(desc);
        /* tags */
        var $tags = $('.tt-effect-desc-panel__tags').empty();
        if (prodTime) {
          $tags.append('<span class="tt-effect-desc-tag">' + prodTime + '</span>');
        }
        if (minTxt) {
          $tags.append('<span class="tt-effect-desc-tag">' + minTxt + '</span>');
        }
      } else {
        $('.tt-effect-desc-panel').hide();
      }
  
      /* Reflect effect card selection in sidebar/progress */
      ttUpdateSidebar(0);
      ttUpdateProgress(0);
    });
  
    /* Size card clicked */
    $(document).on('click', '.tt-size-card', function () {
      var $card = $(this);
  
      /* Mark active */
      $('.tt-size-card').removeClass('tt-size-card--active');
      $card.addClass('tt-size-card--active');
  
      /* Proxy to hidden section by var-label match. Always keep this global in
         sync with the last-clicked size card BEFORE attempting the proxy click:
         every downstream price/SKU reader (see makevariablefor_atc() and the
         .qty_selected_row change handler) treats it as a fallback source of
         truth, so it must never go stale — even when the legacy-popup proxy
         below succeeds. */
      var varLabel = $card.data('var-label');
      window._ttWizardActiveVarLabel = varLabel;
      localStorage.setItem('PageLoadSize', varLabel);

      /* NOTE: do not filter out .slick-cloned nodes here — slick clones slides
         via $.clone(true) (see assets/slick.min.js), which copies the bound
         click handler along with the element, so clones fire this same logic
         correctly. Restricting the selector previously risked zeroing out the
         match set in edge cases and skipping resizeCanvas()/getEditingCanvasDims()
         entirely, which caused the canvas to keep a stale aspect ratio and the
         export to look squished. */
      var $origLoop = $('div#shopify-section-tattoo_popup .loop-all .loop[size_varinats="' + varLabel + '"]');
      if ($origLoop.length) {
        $origLoop.trigger('click');
      } else {
        /* Direct fallback for sizes that have no matching .loop in the hidden popup.
           Look up the variant directly from variants_data and update all state
           without going through the hidden popup click handler. */
  
        var $matchedData = $('.variants_data.matched');
        var $sizeSpan    = $matchedData.find('span[size="' + varLabel + '"]');
        var variantId    = $sizeSpan.attr('id');
        var variantPrice = $sizeSpan.attr('price');
  
        /* Update the hidden form so downstream handlers have correct state */
        if (variantId) {
          $('form.form_syn .custom_varinat_id').val(variantId);
        }
        if (variantPrice) {
          $('form.form_syn').attr('data_price_product', variantPrice);
          $('form.form_syn').attr('data_price_product_with_symbol', variantPrice);
          $('form.form_syn .price_selected').val(variantPrice);
          $('form.form_syn .actual_price').val(variantPrice);
        }
        $('form.form_syn').attr('size_selected', varLabel);
  
        /* Rebuild qty dropdown for the correct variant */
        if (typeof updateqty_html === 'function') {
          updateqty_html(variantId || null);
        }
      }
  
      setTimeout(ttUpdateWizardPrice, 80);
      ttUpdateSidebar(1);
      ttUpdateProgress(1);
    });
  
    /* White ink option clicked */
    $(document).on('click', '.tt-white-option', function () {
      var $opt = $(this);
  
      $('.tt-white-option').removeClass('tt-white-option--active');
      $opt.addClass('tt-white-option--active');
  
      /* Proxy to hidden section */
      var idx = $opt.data('opt-idx');
      $('div#shopify-section-tattoo_popup_option .loop-all').eq(idx).find('.loop').trigger('click');
  
      ttUpdateSidebar(2);
      ttUpdateProgress(2);
    });
  
    /* ── Qty stepper buttons ── */
    $(document).on('click', '.tt-qty-stepper__btn--inc', function () {
      var $sel   = $('.sel_qty');
      var opts   = $sel.find('option').map(function () { return parseInt($(this).val(), 10); }).get();
      opts.sort(function (a, b) { return a - b; });
      var curIdx = opts.indexOf(ttQtyValue);
      if (curIdx < opts.length - 1) ttSetQty(opts[curIdx + 1]);
    });
  
    $(document).on('click', '.tt-qty-stepper__btn--dec', function () {
      var $sel   = $('.sel_qty');
      var opts   = $sel.find('option').map(function () { return parseInt($(this).val(), 10); }).get();
      opts.sort(function (a, b) { return a - b; });
      var curIdx = opts.indexOf(ttQtyValue);
      if (curIdx > 0) ttSetQty(opts[curIdx - 1]);
    });
  
    /* ── Qty preset pills ── */
    $(document).on('click', '.tt-qty-preset', function () {
      if ($(this).hasClass('tt-qty-preset--unavailable') || $(this).prop('disabled')) return;
      ttSetQty(parseInt($(this).data('qty'), 10));
    });
  
    /* ── Footer Back button ── */
    $(document).on('click', '.tt-wizard__footer-back', function () {
      ttPrevStep();
    });
  
    /* ── Topbar Back button (mobile) ── */
    $(document).on('click', '.tt-wizard__back-btn', function () {
      if (ttStep === 0) {
        ttCloseWizard();
      } else {
        ttPrevStep();
      }
    });
  
    /* ── Footer Next / Start designing ── */
    $(document).on('click', '.tt-wizard__footer-next', function () {
      ttNextStep();
    });
  
    /* ── Cart review popup: Edit buttons ──
       Opens the self-contained cart edit popup at the correct step. */
    $(document).on('click', '#shopify-section-add_cart_tattoo .insert_data__edit-btn', function () {
      var step = parseInt($(this).data('edit-step'), 10);
      actOpenPopup(step);
    });
  
    /* ── Closing: add wizard to existing .close handler fallback ── */
    $(document).on('click', '.close, .remove', function () {
      ttCloseWizard();
    });
  
    /* Overlay click to close (optional — matches typical modal UX) */
    $(document).on('click', '.tt-wizard__overlay', function () {
      /* Do nothing on the first active step so user can't accidentally dismiss */
      if (ttActivePanels().indexOf(ttStep) > 0) ttCloseWizard();
    });
  
    /* ── Hook into the existing qty_selected_row change to refresh wizard price ── */
    $(document).on('change', '.qty_selected_row', function () {
      setTimeout(ttUpdateWizardPrice, 50);
    });
  
    /* ── Restore active state from wizard on page load ── */
    /* After existing init auto-clicks settle, reflect active selections back into wizard */
    $(window).on('load', function () {
      setTimeout(function () {
        /* Restore active effect card */
        var savedEffId = localStorage.getItem('PageLoadId');
        if (savedEffId) {
          $('.tt-effect-card[data-eff-id="' + savedEffId + '"]').addClass('tt-effect-card--active')
            .siblings('.tt-effect-card').removeClass('tt-effect-card--active');
          ttIsClassic = (savedEffId === 'qty-classic');
          ttToggleWhiteInkVisibility();
          /* Apply unavailable state based on actual variant data for the restored effect */
          ttUpdateSizeAvailability();
          /* White ink header pill + edit tile — permanently hidden */
          $('li.file_w_option').hide();
          $('.tt-sheet-tile-item--white-ink').addClass('tt-tile--hidden');
        }
  
        /* Restore active size card — skip if the saved size is unavailable for the restored effect */
        var savedSize = localStorage.getItem('PageLoadSize');
        if (savedSize) {
          var $match = $('.tt-size-card[data-var-label="' + savedSize + '"]');
          if ($match.length && !$match.hasClass('tt-size-card--unavailable')) {
            $match.addClass('tt-size-card--active').siblings('.tt-size-card').removeClass('tt-size-card--active');
          } else if ($match.hasClass('tt-size-card--unavailable')) {
            /* Saved size is not valid for the restored effect — clear it */
            localStorage.removeItem('PageLoadSize');
          }
        }
  
        /* Restore active white ink */
        var savedOpt = localStorage.getItem('PageLoadOption');
        if (savedOpt) {
          $('.tt-white-option').each(function () {
            $(this).toggleClass('tt-white-option--active', $(this).data('opt-label') === savedOpt);
          });
        }
        /* Safety fallback: if nothing is active (stale localStorage value or
           fresh visit with no match), always activate the first option. */
        if (!$('.tt-white-option--active').length) {
          $('.tt-white-option').first().addClass('tt-white-option--active');
        }
  
        /* Sync qty */
        ttSyncQtyFromSelect();

        /* Effect step permanently hidden — hide its sidebar nav item, progress
           segment, and the Effect edit tile in the tattoo header on every load */
        $('.tt-wizard__step-nav-item[data-step="0"]').hide();
        $('.tt-progress__seg[data-seg="0"]').addClass('tt-progress__seg--hidden').hide();
        $('.tt-sheet-tile[data-edit-step="effect"]').closest('.tt-sheet-tile__item').hide();

        /* Dismiss the init overlay once JS is ready */
        var _ttOverlayEl  = document.getElementById('tt-init-overlay');
        var _ttOverlayMin = 0; /* no minimum — remove immediately when ready */
        var _ttElapsed    = window._ttOverlayShownAt
                              ? Date.now() - window._ttOverlayShownAt
                              : _ttOverlayMin;
        var _ttWait = Math.max(0, _ttOverlayMin - _ttElapsed);
  
        setTimeout(function () {
          if (_ttOverlayEl) {
            _ttOverlayEl.classList.add('tt-init-overlay--out');
            /* Remove from DOM after the CSS transition finishes (550 ms) */
            setTimeout(function () {
              if (_ttOverlayEl && _ttOverlayEl.parentNode) {
                _ttOverlayEl.parentNode.removeChild(_ttOverlayEl);
              }
            }, 600);
          }
          /* Proxy-click the default Classic effect into the hidden original section
             so pricing, variant state, and ttIsClassic are initialised before the
             wizard opens at the Size step */
          var $defaultEff = $('div#shopify-section-tattoo_popup_selection .loop-all[id="qty-classic"] .loop');
          if ($defaultEff.length) { $defaultEff.trigger('click'); }
          /* Reveal wizard starting at Size (Effect step is permanently hidden) */
          ttOpenWizard(1);
        }, _ttWait);
  
      }, 450); /* slightly after the 400ms init timeout in main custom.js */
    });
  
    /* ================================================================
       CART EDIT POPUP (act*)
       A self-contained step popup inside add_cart_tattoo.liquid.
       Panels are cloned from the wizard DOM at open time so no Liquid
       data duplication is needed. All card-click state handlers (effect,
       size, white ink, qty) are document-delegated and fire for clones
       automatically — only the popup shell navigation is managed here.
       ================================================================ */
  
    var actStep = 0;
  
    /* Return the ordered list of panel indices that are active (mirrors
       ttActivePanels but references actStep). */
    function actActivePanels() {
      return [1, 3]; // Effect (0) and White Ink (2) steps permanently hidden
    }
  
    /* Build popup panels by cloning from the wizard, renaming IDs to avoid
       duplicates, and injecting into the popup container. Called on every
       open so the clones reflect the latest wizard state (size availability
       etc. is synced below via actSyncActiveStates). */
    function actBuildPanels() {
      var $container = $('#act-edit-popup .act-popup__panels');
      $container.empty();
      var sourceIds = ['#tt-step-effect', '#tt-step-size', '#tt-step-white', '#tt-step-qty'];
      $.each(sourceIds, function (i, sourceId) {
        var $source = $(sourceId);
        if (!$source.length) return;
        var $clone = $source.clone();
        /* Rename IDs to avoid conflicts */
        $clone.find('[id]').each(function () {
          $(this).attr('id', 'act-' + $(this).attr('id'));
        });
        /* Replace wizard panel classes with popup panel classes */
        $clone.removeAttr('id')
              .removeClass('tt-wizard__panel tt-wizard__panel--active')
              .addClass('act-wizard-panel')
              .attr('data-act-step', i)
              .hide();
        /* Strip static step-label text — popup manages its own labels */
        $clone.find('.tt-panel__step-label').text('');
        $container.append($clone);
      });
    }
  
    /* Mirror current selections into the cloned popup panels. */
    function actSyncActiveStates() {
      /* Effect */
      var savedId = localStorage.getItem('PageLoadId');
      $('#act-edit-popup .tt-effect-card').removeClass('tt-effect-card--active');
      if (savedId) {
        $('#act-edit-popup .tt-effect-card[data-eff-id="' + savedId + '"]').addClass('tt-effect-card--active');
      }
  
      /* Size */
      var savedSize = localStorage.getItem('PageLoadSize');
      $('#act-edit-popup .tt-size-card').removeClass('tt-size-card--active');
      if (savedSize) {
        var $sizeMatch = $('#act-edit-popup .tt-size-card[data-var-label="' + savedSize + '"]');
        if ($sizeMatch.length && !$sizeMatch.hasClass('tt-size-card--unavailable')) {
          $sizeMatch.addClass('tt-size-card--active');
        }
      }
  
      /* White Ink */
      var savedOpt = localStorage.getItem('PageLoadOption');
      $('#act-edit-popup .tt-white-option').removeClass('tt-white-option--active');
      if (savedOpt) {
        var $optMatch = $('#act-edit-popup .tt-white-option[data-opt-label="' + savedOpt + '"]');
        if ($optMatch.length) {
          $optMatch.addClass('tt-white-option--active');
        } else {
          $('#act-edit-popup .tt-white-option').first().addClass('tt-white-option--active');
        }
      } else {
        $('#act-edit-popup .tt-white-option').first().addClass('tt-white-option--active');
      }
  
      /* Qty — delegate to the exact same function the wizard uses so preset
         availability, stepper value, and ttQtyValue all stay in sync.
         ttSyncQtyFromSelect reads .sel_qty option:selected and updates ALL
         .tt-qty-stepper__val elements on the page (including the popup clone). */
      ttSyncQtyFromSelect();
  
      /* White ink step visibility */
      actToggleWhiteInkVisibility();
  
      /* Price — delay matches the 80ms setTimeout inside ttSyncQtyFromSelect
         so data_price_product has been refreshed before we read it. */
      setTimeout(actUpdatePopupPrice, 100);
    }
  
    /* Show/hide the White Ink progress segment in the popup. */
    function actToggleWhiteInkVisibility() {
      /* White Ink step permanently hidden — always hide */
      $('#act-edit-popup .act-progress__seg[data-seg="2"]').addClass('act-progress__seg--hidden').hide();
    }
  
    /* Update popup progress bar segments. */
    function actUpdateProgress(panelIdx) {
      var activePanels = actActivePanels();
      var currentPos   = activePanels.indexOf(panelIdx);
      $.each(activePanels, function (pos, step) {
        var $seg = $('#act-edit-popup .act-progress__seg[data-seg="' + step + '"]');
        $seg.removeClass('act-progress__seg--done act-progress__seg--active');
        if (pos < currentPos) {
          $seg.addClass('act-progress__seg--done');
        } else if (pos === currentPos) {
          $seg.addClass('act-progress__seg--active');
        }
      });
      actToggleWhiteInkVisibility();
    }
  
    /* Show a specific popup panel; update label, progress, and button states. */
    function actShowPanel(panelIdx) {
      actStep = panelIdx;
      var activePanels = actActivePanels();
      var currentNum   = activePanels.indexOf(panelIdx) + 1;
      var total        = activePanels.length;
  
      /* Step label */
      var labelText = 'Step ' + currentNum + ' of ' + total;
      $('.act-popup__step-label').text(labelText);

      /* Panel visibility */
      $('#act-edit-popup .act-wizard-panel').hide().removeClass('act-wizard-panel--active');
      $('#act-edit-popup .act-wizard-panel[data-act-step="' + panelIdx + '"]')
        .show().addClass('act-wizard-panel--active');

      /* Progress bar */
      actUpdateProgress(panelIdx);

      /* Back button — hide on the first active step */
      if (actActivePanels().indexOf(panelIdx) === 0) {
        $('.act-popup__back-btn, .act-popup__footer-back').hide();
      } else {
        $('.act-popup__back-btn, .act-popup__footer-back').show();
      }
  
      /* Continue / Save button text */
      var isLast = activePanels.indexOf(panelIdx) === activePanels.length - 1;
      $('.act-popup__next-btn').html(
        isLast
          ? 'Save changes <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : 'Continue <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );
  
      /* Clear any step errors */
      $('#act-edit-popup .tt-step-error').remove();
    }
  
    /* Validate the current popup step before advancing. */
    function actValidateStep() {
      if (actStep === 0 && !$('#act-edit-popup .tt-effect-card--active').length) {
        var $panel = $('#act-edit-popup .act-wizard-panel[data-act-step="0"]');
        $panel.find('.tt-step-error').remove();
        $('<p class="tt-step-error" role="alert">Please select a tattoo effect.</p>')
          .insertAfter($panel.find('.tt-panel__heading'));
        return false;
      }
      if (actStep === 1 && !$('#act-edit-popup .tt-size-card--active:not(.tt-size-card--unavailable)').length) {
        var $panel = $('#act-edit-popup .act-wizard-panel[data-act-step="1"]');
        $panel.find('.tt-step-error').remove();
        $('<p class="tt-step-error" role="alert">Please select a size.</p>')
          .insertAfter($panel.find('.tt-panel__heading'));
        return false;
      }
      return true;
    }
  
    /* Advance to the next popup step; finish on the last step. */
    function actNextStep() {
      if (!actValidateStep()) return;
      var activePanels = actActivePanels();
      var currentPos   = activePanels.indexOf(actStep);
      if (currentPos < activePanels.length - 1) {
        actShowPanel(activePanels[currentPos + 1]);
      } else {
        actFinishPopup();
      }
    }
  
    /* Go back one popup step. */
    function actPrevStep() {
      var activePanels = actActivePanels();
      var currentPos   = activePanels.indexOf(actStep);
      if (currentPos > 0) {
        actShowPanel(activePanels[currentPos - 1]);
      }
    }
  
    /* Close the popup and restore body scroll. */
    function actClosePopup() {
      $('#act-edit-popup').hide();
      $('body').css('overflow', '');
    }
  
    /* Finish editing: sync header breadcrumbs, update cart review values, close. */
    function actFinishPopup() {
      ttSyncHeaderBreadcrumbs();
      ttUpdateCartReviewValues();
      actClosePopup();
    }
  
    /* Read current price from form attrs and update popup footer price display. */
    function actUpdatePopupPrice() {
      /* Read from the ORIGINAL wizard qty panel only.
         Using .tt-order-total without scope would match the cloned popup panel too
         and jQuery's .text() concatenates all matches → "$20.00$20.00". */
      var orderTotal = $('#tt-step-qty .tt-order-total').text().trim();
      $('.act-popup__footer-price-val').text(orderTotal || '\u2014');
    }
  
    /* Open the popup: rebuild panels, sync state, show at the requested step. */
    function actOpenPopup(stepIdx) {
      stepIdx = stepIdx || 0;
      actBuildPanels();
      actSyncActiveStates();
      $('#act-edit-popup').show();
      $('body').css('overflow', 'hidden');
      actShowPanel(stepIdx);
    }
  
    /* ── Popup event handlers ── */
  
    /* Topbar back button */
    $(document).on('click', '#act-edit-popup .act-popup__back-btn', function () {
      actPrevStep();
    });
  
    /* Close button */
    $(document).on('click', '#act-edit-popup .act-popup__close-btn', function () {
      actClosePopup();
    });
  
    /* Overlay click to close */
    $(document).on('click', '#act-edit-popup .act-popup__overlay', function () {
      actClosePopup();
    });
  
    /* Footer back button */
    $(document).on('click', '#act-edit-popup .act-popup__footer-back', function () {
      actPrevStep();
    });
  
    /* Footer next / save button */
    $(document).on('click', '#act-edit-popup .act-popup__next-btn', function () {
      actNextStep();
    });
  
    /* Effect card clicked inside popup — update popup label + white ink + progress */
    $(document).on('click', '#act-edit-popup .tt-effect-card', function () {
      setTimeout(function () {
        var total = actActivePanels().length;
        $('.act-popup__step-label').text('Step 1 of ' + total);
        actToggleWhiteInkVisibility();
        actUpdateProgress(0);
        actUpdatePopupPrice();
      }, 30);
    });
  
    /* Size card clicked inside popup — refresh price */
    $(document).on('click', '#act-edit-popup .tt-size-card', function () {
      setTimeout(actUpdatePopupPrice, 150);
    });
  
    /* Qty changes inside popup — refresh price after ttUpdateWizardPrice fires */
    $(document).on('click',
      '#act-edit-popup .tt-qty-stepper__btn--inc, ' +
      '#act-edit-popup .tt-qty-stepper__btn--dec, ' +
      '#act-edit-popup .tt-qty-preset',
      function () {
        /* ttSetQty → setTimeout(ttUpdateWizardPrice, 60) updates #tt-step-qty .tt-order-total;
           wait an extra tick beyond that before reading it */
        setTimeout(actUpdatePopupPrice, 120);
      }
    );
  
  }(jQuery));
  
  /* ============================================================
     Canvas Phase 1 & 2 — Zoom controls + Touch gestures
     ============================================================ */
  (function () {
    var ZOOM_MIN  = 0.5;
    var ZOOM_MAX  = 4;
    var ZOOM_STEP = 0.25;
  
    /* ── helpers ── */
    function clampZoom(z) { return Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, z)); }
  
    function applyZoom(newZoom, pivotX, pivotY) {
      newZoom = clampZoom(newZoom);
      var cx = pivotX != null ? pivotX : canvas.getWidth()  / 2;
      var cy = pivotY != null ? pivotY : canvas.getHeight() / 2;
      canvas.zoomToPoint({ x: cx, y: cy }, newZoom);
      canvas.renderAll();
      _syncZoomButtons(newZoom);
    }
  
    function fitCanvas() {
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      canvas.renderAll();
      _syncZoomButtons(1);
    }
  
    function _syncZoomButtons(z) {
      var inBtn  = document.getElementById('tt-zoom-in-btn');
      var outBtn = document.getElementById('tt-zoom-out-btn');
      if (inBtn)  inBtn.disabled  = z >= ZOOM_MAX;
      if (outBtn) outBtn.disabled = z <= ZOOM_MIN;
    }
  
    /* ── zoom-in / zoom-out / fit buttons ── */
    var zoomInBtn  = document.getElementById('tt-zoom-in-btn');
    var zoomOutBtn = document.getElementById('tt-zoom-out-btn');
    var fitBtn     = document.getElementById('tt-fit-btn');
  
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        applyZoom(canvas.getZoom() + ZOOM_STEP);
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        applyZoom(canvas.getZoom() - ZOOM_STEP);
      });
    }
    if (fitBtn) {
      fitBtn.addEventListener('click', fitCanvas);
    }
  
  
    /* ── pinch-to-zoom + two-finger pan + double-tap to fit ── */
    var wrapper = document.querySelector('.canvasmainbody');
    if (!wrapper) return;
  
    var _pinchDist = null;
    var _pinchMid  = null;
  
    function _dist(t1, t2) {
      var dx = t1.clientX - t2.clientX;
      var dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function _mid(t1, t2) {
      return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }
  
    wrapper.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        _pinchDist = _dist(e.touches[0], e.touches[1]);
        _pinchMid  = _mid(e.touches[0],  e.touches[1]);
      }
    }, { passive: false });
  
    wrapper.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2) return;
      e.preventDefault();
  
      var t1 = e.touches[0], t2 = e.touches[1];
      var newDist = _dist(t1, t2);
      var newMid  = _mid(t1,  t2);
      var rect    = wrapper.getBoundingClientRect();
  
      /* pinch zoom — pivot on the midpoint between fingers */
      if (_pinchDist && newDist) {
        var scale   = newDist / _pinchDist;
        var newZoom = clampZoom(canvas.getZoom() * scale);
        var pt = { x: newMid.x - rect.left, y: newMid.y - rect.top };
        canvas.zoomToPoint(pt, newZoom);
        _syncZoomButtons(newZoom);
      }
  
      /* two-finger pan */
      if (_pinchMid) {
        var dx = newMid.x - _pinchMid.x;
        var dy = newMid.y - _pinchMid.y;
        var vt = canvas.viewportTransform;
        canvas.setViewportTransform([vt[0], vt[1], vt[2], vt[3], vt[4] + dx, vt[5] + dy]);
      }
  
      _pinchDist = newDist;
      _pinchMid  = newMid;
      canvas.renderAll();
    }, { passive: false });
  
    wrapper.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) {
        _pinchDist = null;
        _pinchMid  = null;
      }
    }, { passive: true });
  
    /* ── double-tap to fit ── */
    var _lastTapTime = 0;
    var _lastTapX    = 0;
    var _lastTapY    = 0;
  
    wrapper.addEventListener('touchend', function (e) {
      if (e.touches.length > 0) return; // ignore if fingers still on screen
      if (e.changedTouches.length !== 1) return;
      var now = Date.now();
      var t   = e.changedTouches[0];
      var dt  = now - _lastTapTime;
      var dx  = Math.abs(t.clientX - _lastTapX);
      var dy  = Math.abs(t.clientY - _lastTapY);
      if (dt < 350 && dx < 40 && dy < 40) {
        fitCanvas();
      }
      _lastTapTime = now;
      _lastTapX    = t.clientX;
      _lastTapY    = t.clientY;
    }, { passive: true });
  
  })();
  
  /* ============================================================
     Object Controls Bar — Size & Rotate sliders
     ============================================================ */
  (function () {
  
    var bar        = document.getElementById('tt-object-controls');
    var nameEl     = document.getElementById('tt-obj-name');
    var sizeSlider = document.getElementById('tt-size-slider');
    var sizeVal    = document.getElementById('tt-size-val');
    var rotSlider  = document.getElementById('tt-rotate-slider');
    var rotVal     = document.getElementById('tt-rotate-val');
  
    if (!bar || !sizeSlider || !rotSlider) return;
  
    var SIZE_MIN = 5, SIZE_MAX = 300;
  
    /* ── label helper ── */
    function _objectLabel(obj) {
      if (!obj) return '—';
      if (obj.type === 'i-text' || obj.type === 'text') return 'Text';
      if (obj.type === 'path')  return 'Drawing';
      if (obj.type === 'group') return 'Group';
      if (obj.type === 'image') {
        return (obj.id || '').indexOf('UploadedImg_') === 0 ? 'Upload' : 'Design';
      }
      return 'Object';
    }
  
    /* Fabric stores angle as 0-360; normalise to -180..180 for the centred slider */
    function _normAngle(angle) {
      angle = ((angle % 360) + 360) % 360;
      return angle > 180 ? angle - 360 : angle;
    }
  
    /* Integer percentage of the larger axis scale */
    function _scalePct(obj) {
      return Math.round(Math.max(obj.scaleX || 1, obj.scaleY || 1) * 100);
    }
  
    /* ── track-fill helpers ──
       Both sliders use a CSS gradient on the element style so the "filled"
       portion left of the thumb is always visible (accent-color alone is
       unreliable on Safari / older Chrome).                                 */
  
    function _updateSizeTrack(val) {
      var pct = ((Number(val) - SIZE_MIN) / (SIZE_MAX - SIZE_MIN)) * 100;
      sizeSlider.style.background =
        'linear-gradient(to right, #1a1a1a 0%, #1a1a1a ' + pct + '%, #ddd ' + pct + '%, #ddd 100%)';
    }
  
    /* Rotate: filled region runs from the 50%-midpoint (= 0°) toward the thumb */
    function _updateRotTrack(val) {
      var pct  = ((Number(val) + 180) / 360) * 100; // -180..180 → 0..100
      var from = Math.min(50, pct);
      var to   = Math.max(50, pct);
      rotSlider.style.background =
        'linear-gradient(to right, #ddd 0%, #ddd ' + from + '%, #1a1a1a ' + from +
        '%, #1a1a1a ' + to + '%, #ddd ' + to + '%, #ddd 100%)';
    }
  
    /* ── show / hide ── */
    function ttShowControls(obj) {
      if (!obj) { ttHideControls(); return; }
  
      nameEl.textContent = _objectLabel(obj);
  
      var pct = Math.max(SIZE_MIN, Math.min(SIZE_MAX, _scalePct(obj)));
      sizeSlider.value    = pct;
      sizeVal.textContent = pct + '%';
      _updateSizeTrack(pct);
  
      var deg = _normAngle(obj.angle || 0);
      rotSlider.value    = deg;
      rotVal.textContent = deg + '°';
      _updateRotTrack(deg);
  
      bar.classList.add('tt-active');
      bar.setAttribute('aria-hidden', 'false');
    }
  
    function ttHideControls() {
      bar.classList.remove('tt-active');
      bar.setAttribute('aria-hidden', 'true');
    }
  
    /* ── canvas events ── */
    canvas.on('selection:created', function (e) { ttShowControls(e.selected && e.selected[0]); });
    canvas.on('selection:updated', function (e) { ttShowControls(e.selected && e.selected[0]); });
    canvas.on('selection:cleared', ttHideControls);
  
    /* Keep sliders live-synced while dragging handles on canvas */
    canvas.on('object:scaling', function (e) {
      var pct = Math.max(SIZE_MIN, Math.min(SIZE_MAX, Math.round(
        Math.max(e.target.scaleX, e.target.scaleY) * 100
      )));
      sizeSlider.value    = pct;
      sizeVal.textContent = pct + '%';
      _updateSizeTrack(pct);
    });
  
    canvas.on('object:rotating', function (e) {
      var deg = _normAngle(e.target.angle || 0);
      rotSlider.value    = deg;
      rotVal.textContent = deg + '°';
      _updateRotTrack(deg);
    });
  
    /* ── Size slider → uniform scale (aspect-ratio preserved) ── */
    sizeSlider.addEventListener('input', function () {
      var obj = canvas.getActiveObject();
      if (!obj) return;
      var scale = Number(this.value) / 100;
      obj.set({ scaleX: scale, scaleY: scale });
      obj.setCoords();
      canvas.requestRenderAll();
      sizeVal.textContent = this.value + '%';
      _updateSizeTrack(this.value);
    });
  
    /* ── Rotate slider → rotate in place around the object's visual centre ──
       Fabric's `left`/`top` track the origin point (default: top-left corner).
       Simply setting `angle` pivots around that corner, making the object appear
       to orbit.  Fix: snapshot the centre, change angle, then restore centre.   */
    rotSlider.addEventListener('input', function () {
      var obj = canvas.getActiveObject();
      if (!obj) return;
      var deg = Number(this.value);
  
      var centre = obj.getCenterPoint();   // save current visual centre
      obj.set({ angle: deg });             // change angle (moves origin-relative position)
      obj.setPositionByOrigin(centre, 'center', 'center'); // restore centre
      obj.setCoords();
      canvas.requestRenderAll();
  
      rotVal.textContent = deg + '°';
      _updateRotTrack(deg);
    });
  
  })();
  
  /* ============================================================
     Floating Object Toolbar (#tt-float-toolbar)
     — Duplicate · Flip · Layer · Color · Delete
     ============================================================ */
  (function () {
  
    /* Only initialise on desktop (≥ 750px) */
    if (window.innerWidth < 750) return;
  
    /* ── DOM refs ── */
    var tb          = document.getElementById('tt-float-toolbar');
    var dupBtn      = document.getElementById('tt-ftb-duplicate');
    var flipBtn     = document.getElementById('tt-ftb-flip');
    var layerBtn    = document.getElementById('tt-ftb-layer');
    var layerMenu   = document.getElementById('tt-ftb-layer-menu');
    var colorBtn    = document.getElementById('tt-ftb-color-btn');
    var colorInput  = document.getElementById('tt-ftb-color-input');
    var deleteBtn   = document.getElementById('tt-ftb-delete');
  
    if (!tb) return;
  
    /* ── State ── */
    var _obj       = null;  // currently bound Fabric object
    var _curAngle  = 0;     // current rotation angle in degrees
    var TB_GAP     = 10;    // gap (px) between toolbar bottom and element's top edge
  
    /* ══════════════════════════════════════════
       Position helpers
       ══════════════════════════════════════════ */
  
    function _positionToolbar(obj) {
      if (!obj || !tb) return;
  
      var canvasEl = canvas.getElement();
      var mainbody = document.querySelector('.canvasmainbody');
      if (!mainbody) return;
  
      /* Use getBoundingClientRect on the actual <canvas> element (not the wrapper div)
         so the offset is correct regardless of how CSS positions the inner canvas.     */
      var mainRect   = mainbody.getBoundingClientRect();
      var canvasRect = canvasEl.getBoundingClientRect();
  
      /* Offset of the canvas element's top-left corner within .canvasmainbody */
      var canvasOffX = canvasRect.left - mainRect.left;
      var canvasOffY = canvasRect.top  - mainRect.top;
  
      /* CSS scale: how many screen-px equal one canvas-unit (usually 1, but handles
         cases where the canvas is CSS-scaled to a different display size).            */
      var cssScaleX = canvasRect.width  > 0 ? canvasRect.width  / canvasEl.width  : 1;
      var cssScaleY = canvasRect.height > 0 ? canvasRect.height / canvasEl.height : 1;
  
      /* Apply the Fabric viewport transform (zoom + pan) to a canvas-unit point,
         then scale to CSS pixels and add the canvas offset within mainbody.           */
      var vt     = canvas.viewportTransform;
      var coords = obj.aCoords;
  
      function toMainbody(pt) {
        var vpX = vt[0] * pt.x + vt[2] * pt.y + vt[4];
        var vpY = vt[1] * pt.x + vt[3] * pt.y + vt[5];
        return {
          x: canvasOffX + vpX * cssScaleX,
          y: canvasOffY + vpY * cssScaleY
        };
      }
  
      /* Rotated top-left and top-right corners → mainbody-relative CSS coordinates */
      var tl = toMainbody(coords.tl);
      var tr = toMainbody(coords.tr);
  
      /* Anchor = midpoint of the element's (rotated) top edge */
      var anchorX = (tl.x + tr.x) / 2;
      var anchorY = (tl.y + tr.y) / 2;
  
      /* Toolbar dimensions — always readable because the element uses visibility:hidden */
      var tbW   = tb.offsetWidth  || 252;
      var tbH   = tb.offsetHeight || 48;
      var angle = obj.angle || 0;
  
      /* Position the toolbar centred above the anchor point.
         When the element is rotated, we orbit the toolbar around the anchor so it
         tracks the element's top edge. The vector (0, -(gap + tbH/2)) is rotated
         by the element's angle to find where the toolbar centre ends up.              */
      var angleRad = angle * Math.PI / 180;
      var dist     = TB_GAP + tbH / 2;
      var tbCX     = anchorX + dist * Math.sin(angleRad);
      var tbCY     = anchorY - dist * Math.cos(angleRad);
  
      tb.style.left            = (tbCX - tbW / 2) + 'px';
      tb.style.top             = (tbCY - tbH / 2) + 'px';
      /* Only apply CSS rotation when the element is actually rotated; avoid a
         redundant rotate(0deg) that can cause sub-pixel rendering artefacts.         */
      tb.style.transform       = angle ? 'rotate(' + angle + 'deg)' : 'none';
      tb.style.transformOrigin = 'center center';
  
      /* Counter-rotate the layer submenu so its text stays upright */
      _curAngle = angle;
      if (layerMenu && !layerMenu.hidden) {
        layerMenu.style.transform = 'translateX(-50%) rotate(' + (-angle) + 'deg)';
      }
    }
  
    /* ══════════════════════════════════════════
       Show / Hide
       ══════════════════════════════════════════ */
  
    function _showToolbar(obj) {
      if (!obj) { _hideToolbar(); return; }
      _obj = obj;
      _closeLayerMenu();
      _positionToolbar(obj);
      tb.classList.add('tt-ftb-active');
      tb.setAttribute('aria-hidden', 'false');
    }
  
    function _hideToolbar() {
      _obj = null;
      tb.classList.remove('tt-ftb-active');
      tb.setAttribute('aria-hidden', 'true');
      _closeLayerMenu();
    }
  
    /* ── Layer submenu ── */
    function _closeLayerMenu() {
      if (layerMenu) layerMenu.hidden = true;
      if (layerBtn)  layerBtn.classList.remove('tt-ftb-menu-open');
    }
  
    function _openLayerMenu() {
      if (!layerMenu) return;
      layerMenu.hidden = false;
      layerMenu.style.transform = 'translateX(-50%) rotate(' + (-_curAngle) + 'deg)';
      layerBtn.classList.add('tt-ftb-menu-open');
    }
  
    /* ══════════════════════════════════════════
       Canvas event hooks
       ══════════════════════════════════════════ */
  
    canvas.on('selection:created', function (e) {
      _showToolbar(e.selected && e.selected[0]);
    });
    canvas.on('selection:updated', function (e) {
      _showToolbar(e.selected && e.selected[0]);
    });
    canvas.on('selection:cleared', _hideToolbar);
  
    /* Live-follow the object while user drags/scales/rotates it */
    function _onTransform(e) {
      if (_obj) _positionToolbar(_obj);
    }
    canvas.on('object:moving',   _onTransform);
    canvas.on('object:scaling',  _onTransform);
    canvas.on('object:rotating', _onTransform);
    canvas.on('object:modified', _onTransform);
  
    /* ══════════════════════════════════════════
       Button actions
       ══════════════════════════════════════════ */
  
    /* Duplicate — clone the active object, offset by 20px, select the clone */
    if (dupBtn) {
      dupBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var obj = canvas.getActiveObject();
        if (!obj) return;
        var serialized = obj.toObject();
        fabric.util.enlivenObjects([serialized], function (clones) {
          clones.forEach(function (clone) {
            clone._skipAutoCenter = true;  // preserve cloned scaleX/scaleY — skip object:added auto-resize
            clone.set({ left: obj.left + 20, top: obj.top + 20 });
            if (obj.type === 'image') clone.id = 'dup_' + Date.now();
            clone.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false, mtr: true });
            canvas.add(clone);
            canvas.setActiveObject(clone);   /* toolbar follows the NEW clone */
          });
          canvas.renderAll();
        });
      });
    }
  
    /* Flip Horizontal */
    if (flipBtn) {
      flipBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var obj = canvas.getActiveObject();
        if (!obj) return;
        obj.set('flipX', !obj.flipX);
        canvas.renderAll();
      });
    }
  
    /* Layer — toggle submenu */
    if (layerBtn) {
      layerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (layerMenu && layerMenu.hidden) {
          _openLayerMenu();
        } else {
          _closeLayerMenu();
        }
      });
    }
  
    /* Layer submenu item clicks */
    if (layerMenu) {
      layerMenu.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = e.target.closest('[data-layer]');
        if (!item) return;
        var obj = canvas.getActiveObject();
        if (!obj) return;
        switch (item.getAttribute('data-layer')) {
          case 'front':    canvas.bringToFront(obj);   break;
          case 'forward':  canvas.bringForward(obj);   break;
          case 'backward': canvas.sendBackwards(obj);  break;
          case 'back':     canvas.sendToBack(obj);     break;
        }
        canvas.renderAll();
        _closeLayerMenu();
      });
    }
  
    /* Color — trigger native color picker, apply result to active object */
    if (colorBtn && colorInput) {
      colorBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        colorInput.click();
      });
  
      colorInput.addEventListener('input', function () {
        var obj = canvas.getActiveObject();
        if (!obj) return;
        var hex = colorInput.value;
        if (obj.type === 'i-text' || obj.type === 'text') {
          obj.set({ fill: hex });
        } else if (obj.type === 'group') {
          obj._objects.forEach(function (o) { o.set({ fill: hex }); });
        } else {
          obj.set({ fill: hex });
        }
        canvas.renderAll();
        /* Update the existing legacy color input so other listeners stay in sync */
        var legacyInput = document.getElementById('color-input');
        if (legacyInput) legacyInput.value = hex;
      });
    }
  
    /* Delete — remove all active objects */
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var objs = canvas.getActiveObjects();
        objs.forEach(function (o) { canvas.remove(o); });
        canvas.discardActiveObject();
        canvas.renderAll();
        _hideToolbar();
      });
    }
  
    /* Close layer menu when clicking anywhere outside the toolbar */
    document.addEventListener('click', function (e) {
      if (tb && !tb.contains(e.target)) {
        _closeLayerMenu();
      }
    });
  
  })();
  
  /* ============================================================
     Mobile Bottom Bar  (#tt-mob-bar)
     — Toolbar (Adjust / Duplicate / Flip / Layer / Color / Delete)
     — ATC strip (units · total price · Add to Cart)
     — Adjust panel (Size & Rotate sliders)
     Only initialises on mobile (< 750 px). Desktop logic is untouched.
     ============================================================ */
  (function () {
    if (window.innerWidth >= 750) return;
  
    /* ── DOM refs ── */
    var adjustBtn    = document.getElementById('tt-mob-adjust-btn');
    var adjustPanel  = document.getElementById('tt-mob-adjust-panel');
    var mobSizeSlider= document.getElementById('tt-mob-size-slider');
    var mobSizeVal   = document.getElementById('tt-mob-size-val');
    var mobRotSlider = document.getElementById('tt-mob-rot-slider');
    var mobRotVal    = document.getElementById('tt-mob-rot-val');
    var dupBtn       = document.getElementById('tt-mob-dup-btn');
    var flipBtn      = document.getElementById('tt-mob-flip-btn');
    var layerBtn     = document.getElementById('tt-mob-layer-btn');
    var layerMenu    = document.getElementById('tt-mob-layer-menu');
    var layerWrap    = document.getElementById('tt-mob-layer-wrap');
    var colorBtn     = document.getElementById('tt-mob-color-btn');
    var colorInput   = document.getElementById('tt-mob-color-input');
    var delBtn       = document.getElementById('tt-mob-del-btn');
    var atcBtn       = document.getElementById('tt-mob-atc-btn');
    var qtyValEl     = document.getElementById('tt-mob-qty-val');
    var priceValEl   = document.getElementById('tt-mob-price-val');
  
    /* Desktop slider refs — mobile sliders proxy into these */
    var deskSizeSlider = document.getElementById('tt-size-slider');
    var deskRotSlider  = document.getElementById('tt-rotate-slider');
  
    /* ── Slider track fill helpers ── */
    function _sizeTrack(slider) {
      var val = parseFloat(slider.value), min = 5, max = 300;
      var pct = ((val - min) / (max - min)) * 100;
      slider.style.background = 'linear-gradient(to right,#1a1a1a 0%,#1a1a1a ' + pct + '%,#d8d8d8 ' + pct + '%,#d8d8d8 100%)';
    }
    function _rotTrack(slider) {
      var val = parseFloat(slider.value);
      var pct    = ((val + 180) / 360) * 100;
      var midPct = 50;
      var lo = Math.min(pct, midPct), hi = Math.max(pct, midPct);
      slider.style.background = 'linear-gradient(to right,#d8d8d8 0%,#d8d8d8 ' + lo + '%,#1a1a1a ' + lo + '%,#1a1a1a ' + hi + '%,#d8d8d8 ' + hi + '%,#d8d8d8 100%)';
    }
  
    /* ── Adjust panel toggle ── */
    var _adjustOpen = false;
    if (adjustBtn && adjustPanel) {
      adjustBtn.addEventListener('click', function () {
        _adjustOpen = !_adjustOpen;
        if (_adjustOpen) { adjustPanel.removeAttribute('hidden'); }
        else             { adjustPanel.setAttribute('hidden', ''); }
        adjustBtn.classList.toggle('tt-mob-btn--active', _adjustOpen);
        adjustBtn.setAttribute('aria-pressed', _adjustOpen ? 'true' : 'false');
      });
    }
  
    /* ── Proxy mobile Size slider → desktop slider ── */
    if (mobSizeSlider && deskSizeSlider) {
      mobSizeSlider.addEventListener('input', function () {
        deskSizeSlider.value = this.value;
        deskSizeSlider.dispatchEvent(new Event('input', { bubbles: true }));
        if (mobSizeVal) mobSizeVal.textContent = this.value + '%';
        _sizeTrack(this);
      });
      _sizeTrack(mobSizeSlider);
    }
  
    /* ── Proxy mobile Rotate slider → desktop slider ── */
    if (mobRotSlider && deskRotSlider) {
      mobRotSlider.addEventListener('input', function () {
        deskRotSlider.value = this.value;
        deskRotSlider.dispatchEvent(new Event('input', { bubbles: true }));
        if (mobRotVal) mobRotVal.textContent = this.value + '°';
        _rotTrack(this);
      });
      _rotTrack(mobRotSlider);
    }
  
    /* ── Show / hide toolbar based on canvas selection (mirrors desktop behaviour) ── */
    var toolbar = document.getElementById('tt-mob-toolbar');
  
    function _showMobToolbar() {
      if (toolbar) toolbar.classList.add('tt-mob-active');
      /* Sync slider values from desktop sliders whenever toolbar becomes visible */
      _syncFromDesk();
    }
  
    function _hideMobToolbar() {
      if (toolbar) toolbar.classList.remove('tt-mob-active');
      /* Collapse the adjust panel and reset its button state */
      if (adjustPanel) adjustPanel.setAttribute('hidden', '');
      if (adjustBtn)   { adjustBtn.classList.remove('tt-mob-btn--active'); adjustBtn.setAttribute('aria-pressed', 'false'); }
      _adjustOpen = false;
      _resetSliders();
    }
  
    /* ── Sync desktop sliders → mobile sliders when canvas state changes ── */
    function _syncFromDesk() {
      if (deskSizeSlider && mobSizeSlider) {
        mobSizeSlider.value = deskSizeSlider.value;
        if (mobSizeVal) mobSizeVal.textContent = deskSizeSlider.value + '%';
        _sizeTrack(mobSizeSlider);
      }
      if (deskRotSlider && mobRotSlider) {
        mobRotSlider.value = deskRotSlider.value;
        if (mobRotVal) mobRotVal.textContent = deskRotSlider.value + '°';
        _rotTrack(mobRotSlider);
      }
    }
    function _resetSliders() {
      if (mobSizeSlider) { mobSizeSlider.value = 100; _sizeTrack(mobSizeSlider); }
      if (mobSizeVal)    mobSizeVal.textContent = '100%';
      if (mobRotSlider)  { mobRotSlider.value = 0; _rotTrack(mobRotSlider); }
      if (mobRotVal)     mobRotVal.textContent = '0°';
    }
  
    if (typeof canvas !== 'undefined') {
      canvas.on('selection:created',  _showMobToolbar);
      canvas.on('selection:updated',  _showMobToolbar);
      canvas.on('object:scaling',     _syncFromDesk);
      canvas.on('object:rotating',    _syncFromDesk);
      canvas.on('selection:cleared',  _hideMobToolbar);
    }
  
    /* ── Duplicate ── */
    if (dupBtn) {
      dupBtn.addEventListener('click', function () {
        var obj = canvas.getActiveObject();
        if (!obj) return;
        var serialized = obj.toObject();
        fabric.util.enlivenObjects([serialized], function (clones) {
          clones.forEach(function (clone) {
            clone._skipAutoCenter = true;  // preserve cloned scaleX/scaleY — skip object:added auto-resize
            clone.set({ left: obj.left + 20, top: obj.top + 20 });
            if (obj.type === 'image') clone.id = 'dup_' + Date.now();
            clone.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false, mtr: true });
            canvas.add(clone);
            canvas.setActiveObject(clone);
          });
          canvas.renderAll();
        });
      });
    }
  
    /* ── Flip (Horizontal) ── */
    if (flipBtn) {
      flipBtn.addEventListener('click', function () {
        var obj = canvas.getActiveObject();
        if (!obj) return;
        obj.set('flipX', !obj.flipX);
        canvas.renderAll();
      });
    }
  
    /* ── Layer ── */
    if (layerBtn && layerMenu) {
      layerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !layerMenu.hidden;
        layerMenu.hidden = open;
        layerBtn.setAttribute('aria-expanded', !open ? 'true' : 'false');
      });
      layerMenu.addEventListener('click', function (e) {
        var item = e.target.closest('[data-layer]');
        if (!item) return;
        var obj = canvas.getActiveObject();
        if (obj) {
          switch (item.dataset.layer) {
            case 'front':    canvas.bringToFront(obj);  break;
            case 'back':     canvas.sendToBack(obj);    break;
            case 'forward':  canvas.bringForward(obj);  break;
            case 'backward': canvas.sendBackwards(obj); break;
          }
          canvas.renderAll();
        }
        layerMenu.hidden = true;
        layerBtn.setAttribute('aria-expanded', 'false');
      });
    }
  
    /* ── Custom inline color picker ── */
    if (colorBtn) {
      var _cpPanel  = document.getElementById('tt-mob-color-panel');
      var _cpSwatch = document.getElementById('tt-cp-swatch');
      var _cpHex    = document.getElementById('tt-cp-hex');
      var _cpHue    = document.getElementById('tt-cp-hue');
      var _cpSat    = document.getElementById('tt-cp-sat');
      var _cpLit    = document.getElementById('tt-cp-lit');
      var _cpClose  = document.getElementById('tt-mob-color-close');
      var _cpSwWrap = document.getElementById('tt-cp-swatches');
  
      if (_cpPanel && _cpSwatch && _cpHex && _cpHue && _cpSat && _cpLit) {
  
        /* ── Preset colour swatches ── */
        ['#000000','#ffffff','#ef4444','#f97316','#eab308','#22c55e',
         '#3b82f6','#8b5cf6','#ec4899','#6b7280','#78350f','#134e4a'
        ].forEach(function (c) {
          var sw = document.createElement('button');
          sw.type = 'button';
          sw.className = 'tt-cp-sw';
          sw.style.background = c;
          sw.setAttribute('aria-label', c);
          sw.addEventListener('click', function () { _cpApply(c); });
          _cpSwWrap.appendChild(sw);
        });
  
        /* ── Colour math helpers ── */
        function _hslToHex(h, s, l) {
          s /= 100; l /= 100;
          var a = s * Math.min(l, 1 - l);
          var f = function (n) {
            var k = (n + h / 30) % 12;
            var v = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            var hex = Math.round(255 * v).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          };
          return '#' + f(0) + f(8) + f(4);
        }
  
        function _hexToHsl(hex) {
          var r = parseInt(hex.slice(1, 3), 16) / 255;
          var g = parseInt(hex.slice(3, 5), 16) / 255;
          var b = parseInt(hex.slice(5, 7), 16) / 255;
          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var h = 0, s = 0, l = (max + min) / 2;
          if (max !== min) {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            if      (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
            else if (max === g) h = ((b - r) / d + 2) / 6;
            else                h = ((r - g) / d + 4) / 6;
          }
          return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
        }
  
        function _updateGradients(h, s, l) {
          _cpSat.style.background =
            'linear-gradient(to right,hsl(' + h + ',0%,' + l + '%),hsl(' + h + ',100%,' + l + '%))';
          _cpLit.style.background =
            'linear-gradient(to right,hsl(' + h + ',' + s + '%,0%),hsl(' + h + ',' + s + '%,50%),hsl(' + h + ',' + s + '%,100%))';
        }
  
        function _applyToCanvas(hex) {
          var obj = canvas.getActiveObject();
          if (!obj) return;
          if (obj.type === 'i-text' || obj.type === 'text') {
            obj.set({ fill: hex });
          } else if (obj.type === 'group') {
            obj._objects.forEach(function (o) { o.set({ fill: hex }); });
          } else {
            obj.set({ fill: hex });
          }
          canvas.renderAll();
        }
  
        /* Update UI only — used to pre-fill panel without touching canvas */
        function _cpSetUI(hex) {
          _cpSwatch.style.background = hex;
          _cpHex.value = hex;
          var hsl = _hexToHsl(hex);
          _cpHue.value = hsl[0];
          _cpSat.value = hsl[1];
          _cpLit.value = hsl[2];
          _updateGradients(hsl[0], hsl[1], hsl[2]);
        }
  
        /* Update UI AND apply to the active canvas object */
        function _cpApply(hex) {
          _cpSetUI(hex);
          _applyToCanvas(hex);
        }
  
        /* Sliders → live update */
        function _onSlider() {
          var h = +_cpHue.value, s = +_cpSat.value, l = +_cpLit.value;
          var hex = _hslToHex(h, s, l);
          _updateGradients(h, s, l);
          _cpSwatch.style.background = hex;
          _cpHex.value = hex;
          _applyToCanvas(hex);
        }
        _cpHue.addEventListener('input', _onSlider);
        _cpSat.addEventListener('input', _onSlider);
        _cpLit.addEventListener('input', _onSlider);
  
        /* Hex text input → live update */
        _cpHex.addEventListener('input', function () {
          var v = _cpHex.value.trim();
          if (/^#[0-9a-fA-F]{6}$/.test(v)) _cpApply(v);
        });
        _cpHex.addEventListener('blur', function () {
          if (!/^#[0-9a-fA-F]{6}$/.test(_cpHex.value.trim())) {
            _cpHex.value = _cpSwatch.style.background || '#000000';
          }
        });
  
        /* Color button: toggle panel, pre-fill from selected object */
        colorBtn.addEventListener('click', function () {
          if (_cpPanel.hasAttribute('hidden')) {
            var obj = canvas.getActiveObject();
            if (obj) {
              var fill = (obj.type === 'group' && obj._objects && obj._objects[0])
                ? obj._objects[0].fill : obj.fill;
              if (typeof fill === 'string' && /^#[0-9a-fA-F]{6}$/.test(fill)) {
                _cpSetUI(fill);
              }
            }
            _cpPanel.removeAttribute('hidden');
          } else {
            _cpPanel.setAttribute('hidden', '');
          }
        });
  
        /* Close button */
        if (_cpClose) {
          _cpClose.addEventListener('click', function () {
            _cpPanel.setAttribute('hidden', '');
          });
        }
  
        /* Auto-close when canvas selection is cleared */
        canvas.on('selection:cleared', function () {
          _cpPanel.setAttribute('hidden', '');
        });
      }
    }
  
    /* ── Delete ── */
    if (delBtn) {
      delBtn.addEventListener('click', function () {
        var objs = canvas.getActiveObjects();
        if (!objs.length) return;
        objs.forEach(function (o) { canvas.remove(o); });
        canvas.discardActiveObject();
        canvas.renderAll();
      });
    }
  
    /* ── ATC button ── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        /* Delegate to the desktop ATC span so all existing hooks (terms check,
           canvas export, cart popup) fire exactly as they do on desktop. */
        var existingAtc = document.querySelector('.header-right span.add_to_cart');
        if (existingAtc) existingAtc.click();
      });
    }
  
    /* ── Price / Qty display ── */
    function _updateMobAtc() {
      var sym      = (typeof get_sym !== 'undefined' && get_sym) ? get_sym : '$';
      var rawPrice = $('form.form_syn').attr('data_price_product') || '';
      var price    = parseFloat(String(rawPrice).replace(/,/g, '')) || 0;
      var qty      = parseInt($('.sel_qty option:selected').val(), 10) ||
                     parseInt($('.quantity_selected').val(), 10)       ||
                     (typeof ttQtyValue !== 'undefined' ? ttQtyValue : 100);
  
      if (qtyValEl) qtyValEl.textContent = qty;
  
      if (price > 0) {
        /* data_price_product is already the full order total — no multiplication */
        function fmt(v) {
          return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        if (priceValEl) priceValEl.textContent = sym + fmt(price);
      } else {
        if (priceValEl) priceValEl.textContent = '—';
      }
    }
  
    /* Initial read + poll every 600 ms to catch async price updates */
    _updateMobAtc();
    setInterval(_updateMobAtc, 600);
  
    /* ── Close layer menu on outside tap ── */
    document.addEventListener('click', function (e) {
      if (layerMenu && !layerMenu.hidden && layerWrap && !layerWrap.contains(e.target)) {
        layerMenu.hidden = true;
        if (layerBtn) layerBtn.setAttribute('aria-expanded', 'false');
      }
    });
  
    /* ── Mobile sidebar nav tabs (#tt-mob-nav) ────────────────────────────
       Clone each desktop .side-loop (icon + label) into mobile tab buttons.
       Tapping a tab triggers the matching desktop .side-loop click so all
       existing drawer-open / content-show logic runs unchanged.
    ────────────────────────────────────────────────────────────────────── */
    (function () {
      var $mobNav = $('#tt-mob-nav');
      if (!$mobNav.length) return;
  
      /* Build one button per sidebar item */
      $('.side-loop').each(function () {
        var $sl    = $(this);
        var id     = $sl.attr('id') || '';
        var label  = $sl.find('.side-loop-title').text().trim();
        var $icon  = $sl.find('.side-loop-icon').clone();
  
        var $btn = $('<button>', {
          'class'        : 'tt-mob-nav-btn',
          'data-side-id' : id,
          'aria-label'   : label,
          'type'         : 'button'
        });
        $btn.append($icon);
        $btn.append($('<span>', { 'class': 'tt-mob-nav-label' }).text(label));
        $mobNav.append($btn);
      });
  
      /* Tap → trigger matching desktop side-loop click (or open disclaimer directly) */
      $mobNav.on('click', '.tt-mob-nav-btn', function () {
        var id    = $(this).data('side-id');
        var label = ($(this).attr('aria-label') || '').trim().toLowerCase();
  
        /* Mark active in mobile nav */
        $mobNav.find('.tt-mob-nav-btn').removeClass('tt-mob-nav-active');
        $(this).addClass('tt-mob-nav-active');
  
        /* Disclaimer — open its popup directly (id may be empty, matched by label) */
        if (label === 'disclaimer') {
          var discPopup = document.getElementById('tt-disclaimer-popup');
          if (discPopup && typeof discPopup._openDisclaimer === 'function') {
            discPopup._openDisclaimer();
          }
          return;
        }
  
        /* How-to — open its popup directly */
        if (label === 'how-to' || label === 'how to') {
          var howtoPop = document.getElementById('tt-howto-popup');
          if (howtoPop && typeof howtoPop._openHowto === 'function') {
            howtoPop._openHowto();
          }
          return;
        }
  
        /* All other items: delegate to the desktop sidebar item */
        var $desktopLoop = id ? $('.side-loop[id="' + id + '"]') : $([]);
        if ($desktopLoop.length) $desktopLoop.trigger('click');
      });
  
      /* When the drawer closes (X button), clear mobile nav active state */
      $(document).on('click', '.bar_hide, .center_close_btn', function () {
        $mobNav.find('.tt-mob-nav-btn').removeClass('tt-mob-nav-active');
      });
    }());
  
  })();
  
  /* ════════════════════════════════════════════════════════════════════════════
     Design Library — category pill filter + search
     Pill tabs show/hide .dl-category-block divs (NOT .tab-content, so existing
     hide calls in the codebase don't interfere). Search filters individual
     .svg_item.imgs cards by their data-label attribute.
     ════════════════════════════════════════════════════════════════════════════ */
  
  /**
   * Reset the design library to show all cards with "All" pill active.
   * Called when the design panel opens or when search/filter is cleared.
   */
  function ttDlResetFilter() {
    $('#dl-search').val('');
    $('#dl-search-clear').hide();
    /* Hide no-result state */
    $('.dl-no-result-wrapper').hide().removeClass('dl-nr-visible');
    $('#dl-search-query').text('');
    /* Activate the "All" pill */
    $('.dl-cat-btn').removeClass('active').attr('aria-selected', 'false');
    $('#dl-design-grid').closest('#design').find('.dl-cat-item[data-cat="all"] .dl-cat-btn')
      .addClass('active').attr('aria-selected', 'true');
    /* Show every card in the flat grid */
    $('#dl-design-grid .svg_item.imgs').removeClass('dl-hidden');
  }
  
  (function () {
  
    /* ── Category pill click ─────────────────────────────────────────────── */
    $(document).on('click', '.dl-cat-btn', function () {
      var $btn = $(this);
      var cat  = $btn.closest('.dl-cat-item').data('cat');
  
      /* Update pill active state */
      $('.dl-cat-btn').removeClass('active').attr('aria-selected', 'false');
      $btn.addClass('active').attr('aria-selected', 'true');
  
      /* Clear search */
      $('#dl-search').val('');
      $('#dl-search-clear').hide();
      $('.dl-no-result-wrapper').hide().removeClass('dl-nr-visible');
      $('#dl-search-query').text('');
  
      var $allCards = $('#dl-design-grid .svg_item.imgs');
  
      if (cat === 'all') {
        $allCards.removeClass('dl-hidden');
      } else {
        /* Show only cards whose data-cat matches */
        $allCards.each(function () {
          if (String($(this).data('cat')) === String(cat)) {
            $(this).removeClass('dl-hidden');
          } else {
            $(this).addClass('dl-hidden');
          }
        });
      }
    });
  
    /* ── Search input ────────────────────────────────────────────────────── */
    var _dlSearchTimer;
    $(document).on('input', '#dl-search', function () {
      clearTimeout(_dlSearchTimer);
      var $input = $(this);
      _dlSearchTimer = setTimeout(function () {
        var query = $.trim($input.val()).toLowerCase();
  
        if (query === '') {
          ttDlResetFilter();
          return;
        }
  
        $('#dl-search-clear').show();
  
        var found = 0;
        $('#dl-design-grid .svg_item.imgs').each(function () {
          var label   = String($(this).data('label')    || '').toLowerCase();
          var catName = String($(this).data('cat-name') || '').toLowerCase();
          if (label.indexOf(query) > -1 || catName.indexOf(query) > -1) {
            $(this).removeClass('dl-hidden');
            found++;
          } else {
            $(this).addClass('dl-hidden');
          }
        });
  
        if (found === 0) {
          $('#dl-search-query').text(query);
          $('.dl-no-result-wrapper').addClass('dl-nr-visible').show();
        } else {
          $('.dl-no-result-wrapper').hide().removeClass('dl-nr-visible');
          $('#dl-search-query').text('');
        }
      }, 280);
    });
  
    /* ── Clear buttons (header × + no-result "Clear search") ─────────────── */
    $(document).on('click', '#dl-search-clear, #dl-nr-clear-btn', function () {
      ttDlResetFilter();
      $('#dl-search').focus();
    });
  
    /* ── Prevent Enter → form submit (Search 404 fix) ────────────────────── */
    $(document).on('keydown', '#dl-search', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) e.preventDefault();
    });
  
  }());
  
  /* ════════════════════════════════════════════════════════════════════════════
     Asset Panel — Mobile Bottom Sheet helpers
     • Backdrop overlay (created on load)
     • Drag-to-dismiss: handle pill + full drawer (when inner scroll is at top)
     • ttCollapseAssetSheet() — shared helper for auto-collapse after insert
     Only activates on mobile (< 750 px).
     ════════════════════════════════════════════════════════════════════════════ */
  
  /**
   * Programmatically close the asset bottom sheet and clear all related state.
   * Safe to call on desktop (no-op).
   */
  function ttCollapseAssetSheet() {
    if (window.innerWidth >= 750) return;
    /* Trigger the existing close button so all drawer state is cleaned up */
    $('.btn_close').first().trigger('click');
  }
  
  (function () {
    if (window.innerWidth >= 750) return;
  
    /* ── Backdrop ── */
    var backdrop = document.createElement('div');
    backdrop.className = 'tt-drawer-backdrop';
    document.body.appendChild(backdrop);
    window._ttDrawerBackdrop = backdrop;
  
    /* Tapping backdrop closes the sheet */
    backdrop.addEventListener('click', function () {
      ttCollapseAssetSheet();
    });
  
    /* ── Drag-to-dismiss: handle + full drawer body ── */
    var handle      = document.querySelector('.tt-drawer-handle');
    var drawer      = document.querySelector('.left_dwroor');
    var innerScroll = document.querySelector('.body_iner_left');
  
    if (!handle || !drawer) return;
  
    var startY = 0, currentDelta = 0, dragging = false, dragIntent = false;
  
    /* Listen on the entire drawer so the user can drag from anywhere,
       but only initiate a drag when the inner scroll area is at the top
       (otherwise let native scroll handle the gesture). */
    var dragSurface = drawer;
  
    dragSurface.addEventListener('touchstart', function (e) {
      if (!drawer.classList.contains('active')) return;
      var isHandle = handle.contains(e.target);
      var scrolledToTop = !innerScroll || innerScroll.scrollTop <= 0;
  
      /* Only allow drag if touching the handle OR content is at scroll top */
      if (!isHandle && !scrolledToTop) return;
  
      startY       = e.touches[0].clientY;
      currentDelta = 0;
      dragIntent   = true;   /* tentative — confirmed on first significant downward move */
      dragging     = false;
      drawer.style.transition = 'none';
    }, { passive: true });
  
    dragSurface.addEventListener('touchmove', function (e) {
      if (!dragIntent) return;
  
      var delta = e.touches[0].clientY - startY;
  
      /* Confirm drag intent only on downward movement */
      if (!dragging) {
        if (delta < 5) return;  /* ignore tiny / upward movements */
        dragging = true;
      }
  
      currentDelta = Math.max(0, delta);
      drawer.style.transform = 'translateY(' + currentDelta + 'px)';
  
      /* Fade backdrop proportionally */
      var ratio = Math.max(0, 1 - currentDelta / (window.innerHeight * 0.45));
      backdrop.style.opacity = (0.4 * ratio).toFixed(3);
    }, { passive: true });
  
    function _onTouchEnd() {
      dragIntent = false;
      if (!dragging) return;
      dragging = false;
  
      if (currentDelta > 80) {
        /* ── Animate the drawer all the way off-screen FIRST, then clean up ──
           Keeps inline transform = translateY(100%) while .active is removed so
           the CSS transition has nothing to "snap" from (both are 100%).        */
        drawer.style.transition  = 'transform .32s cubic-bezier(.2,.7,.3,1)';
        backdrop.style.transition = 'opacity .32s ease';
        drawer.style.transform   = 'translateY(100%)';
        backdrop.style.opacity   = '0';
  
        setTimeout(function () {
          drawer.style.transition  = '';
          backdrop.style.transition = '';
          backdrop.style.opacity   = '';
          /* drawer.style.transform is still 'translateY(100%)' — identical to
             what CSS applies in the non-active state, so no snap when we remove
             the .active class via ttCollapseAssetSheet(). */
          ttCollapseAssetSheet();
          /* Clear the inline transform so CSS takes full ownership again. */
          drawer.style.transform = '';
  
          /* Refresh canvas offset so objects remain tappable after drawer close */
          if (typeof canvas !== 'undefined') canvas.calcOffset();
          /* Reposition badge after drawer fully closes */
          if (typeof _recalcBadgePosition === 'function') _recalcBadgePosition();
        }, 340);
      } else {
        /* Snap back to open */
        drawer.style.transition = '';
        drawer.style.transform  = '';
        backdrop.style.opacity  = '';
      }
    }
  
    dragSurface.addEventListener('touchend',    _onTouchEnd, { passive: true });
    dragSurface.addEventListener('touchcancel', _onTouchEnd, { passive: true });
  }());
  
  /* ── Empty-canvas placeholder ────────────────────────────────────────────────
     Shows #tt-canvas-empty when the Fabric canvas has no user-placed objects,
     hides it as soon as at least one object is present.
  
     The placeholder stays inside .canvasmainbody (its original DOM position).
     CSS centers it with top/left/transform so it floats over the canvas without
     depending on canvas-container or any Fabric-generated element. */
  (function () {
    var _placeholder = document.getElementById('tt-canvas-empty');
    if (!_placeholder) return;
  
    function _syncPlaceholder() {
      if (typeof canvas === 'undefined' || !canvas) return;
      /* Count only real content objects — ignore boundary/print-area rects
         added programmatically (they carry a custom flag). */
      var objectCount = canvas.getObjects().filter(function (obj) {
        return !obj._isBoundary && !obj._isPrintArea;
      }).length;
      if (objectCount > 0) {
        _placeholder.setAttribute('hidden', '');
      } else {
        _placeholder.removeAttribute('hidden');
      }
    }
  
    /* Wait until Fabric canvas is fully initialised before attaching events. */
    function _attachWhenReady() {
      if (typeof canvas === 'undefined' || !canvas || !canvas.on) {
        setTimeout(_attachWhenReady, 200);
        return;
      }
      canvas.on('object:added',   _syncPlaceholder);
      canvas.on('object:removed', _syncPlaceholder);
      /* Run once on startup to handle localStorage-restored canvases. */
      _syncPlaceholder();
    }
  
    _attachWhenReady();
  }());
  
  // Auto-size and auto-center every newly added object on the canvas
  canvas.on('object:added', function(e) {
    var obj = e.target;
    if (obj._skipAutoCenter) return;  // skip restored objects (localStorage / JSON load)
  
    // Fit inside the canvas while preserving original quality:
    // scale DOWN only if the object is larger than the canvas; never scale up
    // (upscaling degrades quality). Aspect ratio is always preserved.
    var naturalW = obj.width  || 1;
    var naturalH = obj.height || 1;
    var canvasW  = canvas.getWidth();
    var canvasH  = canvas.getHeight();
    var scale    = Math.min(canvasW / naturalW, canvasH / naturalH, 1);
    obj.set({ scaleX: scale, scaleY: scale, angle: 0 });
  
    canvas.centerObject(obj);     // place object dead-center on canvas
    obj.setCoords();              // refresh interactive bounding-box / corner handles
    canvas.requestRenderAll();
  });
  
  // After any drag / scale / rotate: refresh hit-testing so clicks land correctly
  canvas.on('object:modified', function(e) {
    var obj = e.target;
    if (!obj) return;
    obj.setCoords();     // recalculate corner + edge control points
    canvas.calcOffset(); // re-sync canvas DOM position → fixes stale click coordinates
  });